{
  "match.project.shortDescription": "Short description",
  "match.createProject": "Create as project",
  "match.project.open": "Open project",
  "match.project.documentsFailed": "The project has been created. Some documents could not be copied. You can add the missing documents in the project. {message}",
  "match.project.linkFailed": "The project has been created but could not be linked to this match. {message}",
  "admin.access.pendingAction": "Pending change: {action}",
  "admin.groups.sharingPolicyTitle": "Default sharing for posts and projects",
  "admin.groups.sharingPolicyGlobal": "Applies to all users, regardless of the selected person group.",
  "admin.groups.sharingPolicyDetails": "What does this setting do?",
  "admin.groups.defaultRecipientGroups": "Designated person groups: {groups}",
  "admin.groups.requireDefaultRecipientsOff": "Off: Users choose whom to share with and can keep content private.",
  "admin.groups.requireDefaultRecipientsOn": "On: These groups automatically receive access. Users can add other recipients but cannot leave out the designated groups.",
  "share.create.privateHint": "Only you can read this item.",
  "admin.groups.requireDefaultRecipients": "Should posts and projects always be shared with the designated person groups?",
  "admin.groups.requireDefaultRecipientsHint": "Applies when creating or changing sharing. Toggling this setting leaves existing sharing unchanged. Company content follows its own rules.",
  "admin.roles.impactTitle": "Review role changes",
  "admin.roles.trustedAdmin": "Access administrators can grant any supported capability, including administration and access to their own group. Administration alone does not give access to personal data.",
  "admin.roles.impactHint": "These changes affect all current role holders after saving. Other groups or roles may still provide a removed permission. The server checks the current assignments again when you save.",
  "admin.roles.impactAdded": "Permissions added",
  "admin.roles.impactRemoved": "Permissions removed",
  "admin.roles.impactNone": "None",
  "admin.roles.impactGroups": "Affected groups",
  "admin.roles.impactPeople": "Affected people on this page",
  "admin.roles.impactPeopleHint": "Names and pictures are shown where you have access to the person’s data.",
  "admin.roles.impactNext": "Next page",
  "admin.roles.impactSave": "Apply role changes",
  "admin.roles.impactCancelled": "Role changes were not saved.",
  "admin.roles.impactIncompatible": "This change is unavailable: the role is protected, an assignment scope is incompatible, or the administrator group would lose “Manage access”. Adjust the permissions or assignments before saving.",
  "admin.roles.editAffectsHolders": "Saving updates this role for all current holders. You will review the impact before applying changes.",
  "account.label": "Account",
  "admin.access.openRoles": "Open permissions & roles",
  "admin.addAnswer": "Answer",
  "admin.addQuestion": "Add question",
  "admin.addToGroupLabel": "Add questionnaire",
  "admin.addToGroupPlaceholder": "Select questionnaire",
  "admin.answerPlaceholder": "Answer option",
  "admin.applyPosition": "Apply",
  "admin.assignmentImmediateHint": "Changes here take effect immediately, independently of Save.",
  "admin.changesSaved": "Changes saved.",
  "admin.collapseList": "Collapse list",
  "admin.confirmDeleteQ": "Delete questionnaire?",
  "admin.confirmRemoveFromGroup": "Remove from the group? It loses its position, and its answers stop counting towards this group's evaluation.",
  "admin.defaultPowerLabel": "Default power (optional)",
  "admin.deleteGroup": "Delete group",
  "admin.deleteGroupMessage": "Deletes the group only. {count, plural, =0 {It holds no questionnaires.} one {Its # questionnaire stays and loses its group and its position.} other {Its # questionnaires stay and lose their group and their position.}} Answers already given are untouched.",
  "admin.deleteGroupTitle": "Delete “{name}”?",
  "admin.expandListNamed": "Show {title}",
  "admin.groupAssignmentTitle": "Assignment",
  "admin.groupDescriptionDeLabel": "Description (German)",
  "admin.groupDescriptionEnLabel": "Description (English)",
  "admin.groupDescriptionHint": "Read first on the catalogue tile and above the group in Grow. The tile clamps it, so aim for about {max} characters.",
  "admin.groupImageAlt": "Tile image of the group",
  "admin.groupImageDrop": "Drag an image here or click to upload",
  "admin.groupImageHint": "About 16:10, one flat motif, no text and no fine detail. The tile shows it small and sharp.",
  "admin.groupImageLabel": "Tile image",
  "admin.groupImageLimit": "Max. {max} MB, PNG, JPEG, GIF, BMP, TIFF or WebP",
  "admin.groupImageRemove": "Remove image",
  "admin.groupImageRemoveConfirm": "Remove image? The tile falls back to the generated artwork.",
  "admin.groupImageReplace": "Replace",
  "admin.groupImageTooLarge": "Too large (max. {max} MB): {name}",
  "admin.groupImageUnsupported": "Unsupported file type: {name}",
  "admin.groupItemCount": "{count, plural, one {# question} other {# questions}}",
  "admin.groupLabel": "Group",
  "admin.groupLimitReached": "You have reached the maximum of {limit} groups.",
  "admin.groupMembersTitle": "Questionnaires in this group",
  "admin.groupNameDeLabel": "Name (German)",
  "admin.groupNameEnLabel": "Name (English)",
  "admin.groupNamePlaceholder": "e.g. Power Quiz",
  "admin.groupNoMembers": "No questionnaire assigned yet.",
  "admin.groupPositionHint": "Where the group itself sits in Grow · Play.",
  "admin.groupPositionLabel": "Position in Grow · Play",
  "admin.groupSaveFailed": "The group could not be saved.",
  "admin.groupValidationHint": "A name in German and English is required.",
  "admin.inGroupOption": "{name} (in {group})",
  "admin.instructionsLabel": "Instructions (optional)",
  "admin.instructionsPlaceholder": "Hint for the person filling it out",
  "admin.memberPositionLabel": "Position in the group",
  "admin.moveDown": "Move down",
  "admin.moveUp": "Move up",
  "admin.nameLabel": "Name",
  "admin.namePlaceholder": "e.g. Empathy check",
  "admin.newGroup": "+ New group",
  "admin.newGroupTitle": "New group",
  "admin.newQuestionnaire": "+ New questionnaire",
  "admin.noQuestionnaires": "No questionnaires yet.",
  "admin.nonePlaceholder": "None",
  "admin.notVisibleInGrow": "Not in the Grow play catalogue.",
  "admin.publishAnyway": "Publish anyway",
  "admin.publishEmptyMessage": "This group has no active questionnaire, so publishing it still gives the catalogue no tile to show.",
  "admin.publishEmptyTitle": "Publish without an active questionnaire?",
  "admin.publishGroup": "Publish",
  "admin.qTitle": "Questionnaires",
  "admin.questionPlaceholder": "Question / statement",
  "admin.referenceData.saveFailed": "The entry could not be saved.",
  "admin.rehomeConfirm": "Move",
  "admin.rehomeFromMessage": "“{name}” moves out of “{from}” and into “{to}”, at the end of the order. Answers already given move with it and count towards the evaluation of “{to}” from now on.",
  "admin.rehomeMessage": "“{name}” is placed at the end of “{to}”. Answers already given count towards the evaluation of “{to}” from now on.",
  "admin.rehomeTitle": "Move “{name}”?",
  "admin.removeAnswer": "Remove answer",
  "admin.removeQuestion": "Remove question",
  "admin.roles.addRole": "+ New role",
  "admin.roles.assignPermissions": "What can this role do?",
  "admin.roles.assignments": "Assignments",
  "admin.roles.assignmentsHint": "This role applies through these groups. The total counts each stored member once. Assignments cannot be changed here yet.",
  "admin.roles.clearSearch": "Clear search",
  "admin.roles.created": "Role created. Its assigned permissions have been saved.",
  "admin.roles.customRoles": "Custom roles",
  "admin.roles.delete": "Delete role",
  "admin.roles.deleteConfirm": "Permanently delete “{name}”? No Grant references this role. The permission catalog is kept.",
  "admin.roles.deleting": "Deleting …",
  "admin.roles.description": "Description (optional)",
  "admin.roles.descriptionPlaceholder": "What is this role for?",
  "admin.roles.details": "Role details",
  "admin.roles.edit": "Edit role",
  "admin.roles.empty": "No roles yet. Create a role with the permissions it needs.",
  "admin.roles.existing": "Existing roles",
  "admin.roles.intro": "A role bundles permissions for a task. View existing roles and create your own bundles here.",
  "admin.roles.invalidFields": "Enter a role name (up to 120 characters) and keep the description within 2,000 characters.",
  "admin.roles.listTitle": "Roles",
  "admin.roles.loading": "Loading roles and permissions…",
  "admin.roles.membersIn": "People in {name}",
  "admin.roles.membersLoading": "Loading people …",
  "admin.roles.name": "Role name",
  "admin.roles.namePlaceholder": "e.g. HR profile management",
  "admin.roles.new": "Create new role",
  "admin.roles.noAssignments": "Not assigned to a group yet.",
  "admin.roles.noMembers": "No stored members found.",
  "admin.roles.noResults": "No matching permissions. Your selection is preserved.",
  "admin.roles.noRoleResults": "No permissions found for this view.",
  "admin.roles.peopleCount": "{count, plural, one {# person} other {# people}}",
  "admin.roles.permissions": "Permissions",
  "admin.roles.permissionsRequired": "Select at least one available permission before saving.",
  "admin.roles.readOnly": "Read-only",
  "admin.roles.resumeDraft": "Resume draft",
  "admin.roles.retry": "Try again",
  "admin.roles.scope": "Scope: {name}",
  "admin.roles.search": "Search permissions",
  "admin.roles.selected": "{count, plural, one {# permission selected} other {# permissions selected}}",
  "admin.roles.shown": "{shown} of {total} permissions",
  "admin.roles.systemProtected": "This role is provided by the system. Its name and permissions are fixed. It cannot be edited or deleted here.",
  "admin.roles.systemRoles": "System roles",
  "admin.roles.title": "Permissions & roles",
  "admin.roles.unassigned": "People receive this role through a later assignment.",
  "admin.roles.unnamedPerson": "Unnamed person",
  "admin.selectOrCreate": "Select a group or questionnaire on the left, or create a new one.",
  "admin.selectPower": "Select power",
  "admin.selectionGone": "This entry no longer exists. Pick another one on the left.",
  "admin.statusActive": "Active",
  "admin.statusDeleted": "Deleted",
  "admin.statusDraft": "Draft",
  "admin.statusInactive": "Inactive",
  "admin.statusLabel": "Status",
  "admin.statusPublished": "Published",
  "admin.toggleGroupCollapsed": "{state, select, collapsed {Expand} other {Collapse}} {name}",
  "admin.ungroupMessage": "“{name}” leaves “{from}” and loses its position. Its answers no longer count towards the evaluation of “{from}”.",
  "admin.ungroupTitle": "Remove “{name}” from its group?",
  "admin.ungrouped": "Without group",
  "admin.unpublishGroup": "Withdraw",
  "admin.unpublishMessage": "The group leaves the Grow play catalogue. Answers already given stay and keep counting towards the evaluation.",
  "admin.unpublishTitle": "Withdraw “{name}”?",
  "admin.validationHint": "Name, plus text + power per question and text per answer required.",
  "admin.weightLabel": "Weight",
  "admin.yesDelete": "Yes, delete",
  "admin.yesRemove": "Yes, remove",
  "adminSettings.appearance.accentHint": "Accent · Buttons, highlights",
  "adminSettings.appearance.accentLabel": "Accent",
  "adminSettings.appearance.bgHint": "Base · Page",
  "adminSettings.appearance.bgLabel": "Background",
  "adminSettings.appearance.openPicker": "Open colour picker",
  "adminSettings.appearance.presetsFor": "Presets for {label}",
  "adminSettings.appearance.reset": "↺ Reset to default",
  "adminSettings.appearance.sub": "Background, boxes and accent drive the app. Text, shades and buttons are derived from them and stay readable (WCAG AA).",
  "adminSettings.appearance.previewShow": "Show preview",
  "adminSettings.appearance.previewHide": "Hide preview",
  "adminSettings.appearance.previewSub": "How the palette looks in the app. Every colour below is derived from the three above.",
  "adminSettings.appearance.preview.pageAction": "Edit visibility",
  "adminSettings.appearance.preview.pageSecondary": "Organisational record",
  "adminSettings.appearance.preview.cardTitle": "Business card",
  "adminSettings.appearance.preview.tabPersonal": "Personal",
  "adminSettings.appearance.preview.tabCompany": "Company",
  "adminSettings.appearance.preview.fieldLabel": "Nationality",
  "adminSettings.appearance.preview.placeholder": "e.g. German",
  "adminSettings.appearance.preview.cardText": "Secondary text, metadata and placeholders stay readable on every palette.",
  "adminSettings.appearance.preview.open": "Open ↗",
  "adminSettings.appearance.preview.share": "↗ Share",
  "adminSettings.appearance.preview.chip": "New",
  "adminSettings.appearance.preview.bars": "Power bars, the selected one in the accent",
  "adminSettings.appearance.preview.toast": "Unsaved changes",
  "adminSettings.appearance.preview.save": "Save",
  "adminSettings.appearance.preview.hintButtonsPage": "Buttons on boxes use the background colour, because it stands out enough from the boxes.",
  "adminSettings.appearance.preview.hintButtonsInk": "Buttons on boxes are {colour}: background and boxes differ by only {ratio}:1, buttons in the background colour need 4.5:1.",
  "adminSettings.appearance.preview.black": "black",
  "adminSettings.appearance.preview.white": "white",
  "adminSettings.appearance.preview.hintAccent": "As text on boxes, the accent is replaced by the ink where it would not be readable.",
  "adminSettings.appearance.surfaceHint": "Cards · Surfaces",
  "adminSettings.appearance.surfaceLabel": "Boxes",
  "adminSettings.appearance.title": "Palette",
  "adminSettings.branding.appName": "App name",
  "adminSettings.branding.appNameHint": "Shown top-left. Empty falls back to “smycles”.",
  "adminSettings.branding.appNamePlaceholder": "smycles",
  "adminSettings.branding.linkPicker.displayText": "Display text",
  "adminSettings.branding.linkPicker.insert": "Insert",
  "adminSettings.branding.linkPicker.page.growPlay": "Grow · Play",
  "adminSettings.branding.linkPicker.page.home": "Home",
  "adminSettings.branding.linkPicker.page.match": "Match",
  "adminSettings.branding.linkPicker.page.share": "Share",
  "adminSettings.branding.linkPicker.searchPlaceholder": "Search by name …",
  "adminSettings.branding.linkPicker.shareItem": "Specific Share item …",
  "adminSettings.branding.linkPicker.trigger": "Insert link",
  "adminSettings.branding.linkPicker.unnamedShareItem": "Unnamed Share item",
  "adminSettings.branding.logo": "Logo",
  "adminSettings.branding.logoChange": "Change the logo",
  "adminSettings.branding.logoChangeHover": "Change logo",
  "adminSettings.branding.logoChoose": "Upload a logo",
  "adminSettings.branding.logoEmpty": "No logo",
  "adminSettings.branding.logoHint": "Shown top-left in place of the app name. PNG, JPEG, GIF, BMP, TIFF or WebP up to {max, number} MB, cropped to the sidebar's 4:1; a transparent background works best.",
  "adminSettings.branding.logoRefusedTooLarge": "The logo was refused: the cropped image is still too large.",
  "adminSettings.branding.logoRefusedUnsupported": "The logo was refused: it is not a PNG, JPEG, GIF, BMP, TIFF or WebP image.",
  "adminSettings.branding.logoRemove": "Remove logo",
  "adminSettings.branding.logoTooLarge": "{name} is too large. The logo may be at most {max, number} MB.",
  "adminSettings.branding.logoTooManyPixels": "This image is too large to crop. Use one under {max} megapixels.",
  "adminSettings.branding.logoUnreadable": "That file could not be read. Try choosing it again.",
  "adminSettings.branding.logoUnsupported": "{name} cannot be used as the logo. Choose a PNG, JPEG, GIF, BMP, TIFF or WebP image.",
  "adminSettings.branding.paletteNote": "The palette below applies live; unsaved changes appear in the save bar and persist platform-wide on save.",
  "adminSettings.branding.sub": "App name, logo and colour palette. Applies platform-wide.",
  "adminSettings.branding.title": "Branding",
  "adminSettings.branding.welcomeMessage": "Welcome message",
  "adminSettings.branding.welcomeMessageHint": "Supports links: [Text](/path). Everything else is shown as plain text.",
  "adminSettings.branding.welcomeMessagePlaceholder": "Shown as a pop-up on the next visit to the home page and stays there as a dismissable hint.",
  "adminSettings.emailTemplates.body": "Content",
  "adminSettings.emailTemplates.defaultActive": "The default is currently active.",
  "adminSettings.emailTemplates.empty": "No email templates are available.",
  "adminSettings.emailTemplates.kind.INVITATION": "Invitation",
  "adminSettings.emailTemplates.loading": "Loading…",
  "adminSettings.emailTemplates.placeholderRequired": "{token} (required)",
  "adminSettings.emailTemplates.placeholders": "Available placeholders: {tokens}",
  "adminSettings.emailTemplates.previewApproximationHint": "This preview is approximate. Keycloak and the recipient's email client determine the final appearance.",
  "adminSettings.emailTemplates.previewEmptyBody": "No content.",
  "adminSettings.emailTemplates.previewEmptySubject": "No subject.",
  "adminSettings.emailTemplates.previewLabel": "Email preview",
  "adminSettings.emailTemplates.previewLink": "Individual invitation link",
  "adminSettings.emailTemplates.realmWideHint": "This text applies to all Keycloak action emails in the realm, including credential resets initiated in the Admin Console.",
  "adminSettings.emailTemplates.reset": "Use default",
  "adminSettings.emailTemplates.storageDisabled": "Editing email templates is not enabled on this server. The template is shown read-only.",
  "adminSettings.emailTemplates.storageUnavailable": "The template store is currently unreachable. The template is shown read-only and stored changes may not be visible.",
  "adminSettings.emailTemplates.sub": "Subject and content used for the next system email.",
  "adminSettings.emailTemplates.subject": "Subject",
  "adminSettings.emailTemplates.title": "Email templates",
  "adminSettings.emailTemplates.validation.applicationNameSingleLine": "The app name must contain exactly one line. Change it in system settings.",
  "adminSettings.emailTemplates.validation.bodyTooLong": "Content must not exceed {max} characters after inserting the app name.",
  "adminSettings.emailTemplates.validation.linkInSubject": "The {token} placeholder is not allowed in the subject.",
  "adminSettings.emailTemplates.validation.requiredPlaceholder": "Content must contain the required {token} placeholder.",
  "adminSettings.emailTemplates.validation.reservedSequence": "The template contains an unsupported control sequence.",
  "adminSettings.emailTemplates.validation.subjectSingleLine": "The subject must contain exactly one line.",
  "adminSettings.emailTemplates.validation.subjectTooLong": "The subject must not exceed {max} characters after inserting the app name.",
  "adminSettings.emailTemplates.validation.unknownPlaceholder": "The placeholder {token} is not supported.",
  "adminSettings.emailTemplates.viewEditor": "Editor",
  "adminSettings.emailTemplates.viewLabel": "Template view",
  "adminSettings.emailTemplates.viewPreview": "Preview",
  "adminSettings.hrPrompt.defaultActive": "The Genesis default is currently active.",
  "adminSettings.hrPrompt.hint": "The '{{responseLanguage}}' placeholder is replaced automatically. A match supplement comes last in the combined prompt and takes precedence on conflicts.",
  "adminSettings.hrPrompt.label": "Global HR base prompt",
  "adminSettings.hrPrompt.reset": "Use Genesis default",
  "adminSettings.hrPrompt.sub": "Central recruiter instruction for all review matches. Match-specific supplements are appended afterwards.",
  "adminSettings.hrPrompt.title": "HR prompt",
  "agent.attach.button": "Attach a document",
  "agent.attach.cancel": "Cancel",
  "agent.attach.drop": "Drop to attach to this chat",
  "agent.attach.prompt": "Attach “{name}”?",
  "agent.attach.remove": "Remove attachment",
  "agent.attach.status.error": "upload failed",
  "agent.attach.status.failed": "failed",
  "agent.attach.status.pending": "queued",
  "agent.attach.status.processing": "processing…",
  "agent.attach.status.ready": "ready",
  "agent.attach.status.uploading": "uploading…",
  "agent.attach.textOnly": "Upload (text only)",
  "agent.attach.unavailable": "Unavailable for the current model",
  "agent.attach.unavailableHint": "Not embedded for the active model. Remove and upload again to use it.",
  "agent.attach.withImages": "Upload with images",
  "agent.attach.withoutImages": "Upload without images",
  "agent.back": "Back to chats",
  "agent.chatOpenError": "Couldn't load that chat. Try again.",
  "agent.chatsEmpty": "No chats yet. Start a new one above.",
  "agent.chatsError": "Couldn't load chats.",
  "agent.chatsLoading": "Loading…",
  "agent.close": "Close",
  "agent.closeImage": "Close image",
  "agent.contextBreak": "New context window",
  "agent.deleteChat": "Delete chat",
  "agent.deleteMessage": "This conversation will be permanently deleted.",
  "agent.deleteTitle": "Delete chat?",
  "agent.empty": "Ask the assistant about people, profiles and more.",
  "agent.error": "Couldn't reach the assistant. Try again.",
  "agent.expandImage": "View full size",
  "agent.externalContentNotice": "Includes content from the web. AI can make mistakes, please check the sources.",
  "agent.input": "Assistant input",
  "agent.jumpToLatest": "Jump to latest",
  "agent.newChat": "New chat",
  "agent.page.edit": "Edit in master data",
  "agent.page.notFound": "AI agent not found",
  "agent.page.notFoundHint": "This AI agent does not exist, or was deleted.",
  "agent.personInfo.heading": "Profile",
  "agent.personChoice.label": "People to choose from",
  "agent.personChosen": "I mean {person}, the person in the system.",
  "agent.personInfo.label": "Load full profile",
  "agent.placeholder": "Ask the assistant…",
  "agent.send": "Send",
  "agent.stop": "Stop",
  "agent.starters.growth.0": "What skills should I develop next?",
  "agent.starters.growth.1": "Which roles match my experience?",
  "agent.starters.growth.2": "Where can I grow from here?",
  "agent.starters.growth.3": "What experience am I missing for senior roles?",
  "agent.starters.growth.4": "Suggest a learning path for me",
  "agent.starters.growth.5": "Which skills are most in demand?",
  "agent.starters.growth.6": "What strengths can I build on?",
  "agent.starters.growth.7": "Compare my profile to a target role",
  "agent.starters.growth.8": "What gaps hold me back?",
  "agent.starters.growth.9": "Recommend next steps for my career",
  "agent.starters.match.0": "List my recent matches",
  "agent.starters.match.1": "What search options are there?",
  "agent.starters.match.2": "Show details of my latest match",
  "agent.starters.match.3": "Count my matches",
  "agent.starters.match.4": "Find a match by name",
  "agent.starters.match.5": "Which match did I update last?",
  "agent.starters.match.6": "Search for a person",
  "agent.starters.match.7": "Show my newest match's candidates",
  "agent.starters.match.8": "What can I search for?",
  "agent.starters.match.9": "List matches from this month",
  "agent.starters.save.0": "Show my profile",
  "agent.starters.save.1": "What skills are on my profile?",
  "agent.starters.save.2": "Which languages do I have?",
  "agent.starters.save.3": "What experience is on my profile?",
  "agent.starters.save.4": "Summarize my profile",
  "agent.starters.save.5": "What is my current job title?",
  "agent.starters.save.6": "List my education",
  "agent.starters.save.7": "Which companies have I worked at?",
  "agent.starters.save.8": "What's my strongest skill area?",
  "agent.starters.save.9": "Show my contact details",
  "agent.starters.share.0": "List my shared items",
  "agent.starters.share.1": "Show my most recent share",
  "agent.starters.share.2": "Summarize my shared projects",
  "agent.starters.share.3": "Show my public shares",
  "agent.starters.share.4": "Show my private shares",
  "agent.starters.share.5": "List what I shared this month",
  "agent.starters.share.6": "Show details of my latest share",
  "agent.starters.share.7": "Find a shared item by name",
  "agent.starters.share.8": "List items shared with my team",
  "agent.starters.share.9": "List my shared projects",
  "agent.title": "Assistant",
  "agent.progress.resolvingCondition": "Condition {index} of {total}: {condition}",
  "agent.progress.conditionReworded": "Stored as ''{value}'' instead",
  "agent.progress.conditionUnrecorded": "Field ''{field}'' is barely filled in, using ''{insteadField}'' instead",
  "agent.progress.conditionAbsent": "Nothing in the data matches ''{field}''",
  "agent.progress.combining": "Putting it together: {filter}",
  "agent.progress.logic.and": "and",
  "agent.progress.logic.or": "or",
  "agent.progress.op.eq": "is exactly",
  "agent.progress.op.ne": "is not",
  "agent.progress.op.contains": "like",
  "agent.progress.op.startsWith": "starts with",
  "agent.progress.op.endsWith": "ends with",
  "agent.progress.op.in": "in",
  "agent.progress.op.notIn": "not in",
  "agent.progress.op.lt": "is less than",
  "agent.progress.op.lte": "is at most",
  "agent.progress.op.gt": "is greater than",
  "agent.progress.op.gte": "is at least",
  "agent.progress.op.any": "is set",
  "agent.progress.counting": "Counting people where {filter}",
  "agent.progress.countingAll": "Counting everyone",
  "agent.progress.listing": "Looking up people where {filter}",
  "agent.progress.listingAll": "Looking up people",
  "agent.progress.tallying": "Tallying {field} where {filter}",
  "agent.progress.tallyingAll": "Tallying {field} across everyone",
  "agent.progress.considering": "Considering",
  "agent.progress.searchingAlternatives": "Did not find any, starting a deeper search",
  "agent.progress.alternativeFound": "Found it under \"{term}\"",
  "agent.progress.nothingFound": "Confirmed there is nothing like that",
  "agent.progress.working": "Working on it",
  "agent.progress.counting.companies": "Counting companies where {filter}",
  "agent.progress.countingAll.companies": "Counting all companies",
  "agent.progress.listing.companies": "Looking up companies where {filter}",
  "agent.progress.listingAll.companies": "Looking up companies",
  "agent.progress.planningSearch": "Working out where to look",
  "agent.progress.planningSearchRoute": "{route, select, field {Looking in the expertise labels} rag {Reading the company summaries} both {Looking in the expertise labels and the summaries} other {Working out where to look ({route})}}",
  "agent.progress.searchingFields": "Checking the expertise labels for \"{terms}\"",
  "agent.progress.embeddingLabels": "Reading the expertise labels, company {company} of {companies}",
  "agent.progress.indexingSummaries": "Creating an index of the company summaries",
  "agent.progress.searchingSummaries": "Searching the summaries for \"{query}\"",
  "agent.progress.chosenCell": "{selected} chosen",
  "agent.progress.ofPool": "{count} of {candidates}",
  "agent.progress.searchingSummariesTable": "Searching the summaries for:",
  "agent.progress.searchingSummariesTableEach": "Searching the summaries for – {each} each:",
  "agent.thinking.show": "Show what led to this answer",
  "agent.thinking.hide": "Hide what led to this answer",
  "agent.progress.weighingHits": "Reading the {hits} candidates and weighing them up",
  "agent.progress.weighingHitsExplained": "Reading the {hits} candidates and weighing them up – {returned} hits from {searches} searches, {hits} unique in total",
  "agent.progress.resultCandidates": "{count, plural, =0 {no candidates} one {# candidate} other {# candidates}}",
  "agent.progress.resultCandidatesCut": "the closest {count} of {candidates}",
  "agent.progress.resultSelected": "{selected, plural, =0 {none of them chosen} one {# chosen} other {# chosen}}",
  "agent.progress.resultFound": "{count, plural, =0 {none found} other {# found}}",
  "agent.progress.resultFoundOfMatched": "{count} of {matched} found",
  "agent.progress.summariesMatched": "{count, plural, one {# company} other {# companies}} found by summary",
  "agent.progress.summariesMatchedNone": "No company describes itself that way",
  "agent.progress.searchingWeb": "Searching the web for \"{query}\"",
  "agent.progress.searchingWebAll": "Searching the web",
  "agent.progress.locatingPlace": "Checking where {place} is",
  "agent.progress.locatingPlaceIn": "Checking whether {place} is in {area}",
  "agent.progress.field.name": "name",
  "agent.progress.field.name.family": "surname",
  "agent.progress.field.name.given": "first name",
  "agent.progress.field.formattedName": "name",
  "agent.progress.field.id": "id",
  "agent.progress.field.jobTitle": "job title",
  "agent.progress.field.profession": "profession",
  "agent.progress.field.currentEmployer": "employer",
  "agent.progress.field.city": "city",
  "agent.progress.field.country": "country",
  "agent.progress.field.countryState": "state",
  "agent.progress.field.nationality": "nationality",
  "agent.progress.field.citizenships": "citizenship",
  "agent.progress.field.gender": "gender",
  "agent.progress.field.ageInYears": "age",
  "agent.progress.field.birthDate": "date of birth",
  "agent.progress.field.languageSkills": "languages",
  "agent.progress.field.expertises": "expertise",
  "agent.progress.field.experiences": "experience",
  "agent.progress.field.educations": "education",
  "agent.progress.field.industry": "industry",
  "agent.progress.field.employeeCount": "number of employees",
  "agent.progress.field.summary": "description",
  "agent.progress.field.competencyFieldName": "expertise",
  "agent.tour.back": "Back",
  "agent.tour.buttonHint.back": "Back: revisit the previous step.",
  "agent.tour.buttonHint.next": "Next: continue right away.",
  "agent.tour.buttonHint.pause": "Pause: halt the tour and ask questions.",
  "agent.tour.buttonHint.skipSection": "Skip section: jump to the next area.",
  "agent.tour.buttonHint.stop": "Stop or Esc: end the tour.",
  "agent.tour.chipHome": "Main page",
  "agent.tour.continue": "Continue",
  "agent.tour.escHint": "_Use the buttons below the chat: back, pause, next and skip section. Press **Esc** or the stop button anytime to end the tour._",
  "agent.tour.finished": "That's the end of the tour. Ask me anything about what you saw!",
  "agent.tour.mobileNotice": "Tours highlight elements on the page next to the chat, so they need a larger screen. Please try it on a desktop window.",
  "agent.tour.modeActive": "Tour mode",
  "agent.tour.modeFinished": "Tour finished. Click a snippet or step back to review; stop exits.",
  "agent.tour.modePaused": "Tour paused. You can ask questions now.",
  "agent.tour.next": "Next",
  "agent.tour.next.heading": "Now try it yourself:",
  "agent.tour.next.linkedin": "Import your data via LinkedIn",
  "agent.tour.next.match": "Create a match",
  "agent.tour.next.profile": "Fill out your profile",
  "agent.tour.next.project": "Create a project",
  "agent.tour.next.quiz": "Take a power quiz",
  "agent.tour.noTour": "There is no tour for this page yet.",
  "agent.tour.pause": "Pause",
  "agent.tour.pillar.grow": "GROW is your power playground: assess your 30 powers, watch learning content and play your way to a sharper profile.",
  "agent.tour.pillar.home": "The Smycles logo always takes you to the main page: your dashboard with the latest numbers from every section.",
  "agent.tour.pillar.match": "MATCH builds teams: you define the requirements, the solver picks the right people.",
  "agent.tour.pillar.save": "SAVE is your personal data vault: your profile, CV entries, documents, contacts and pinboard.",
  "agent.tour.pillar.share": "SHARE is the community feed: publish projects and posts, gather interested people and feedback.",
  "agent.tour.questionContinue": "Show everything",
  "agent.tour.questionFinish": "Finish the tour",
  "agent.tour.sectionQuestion": "Should I show you one section first? Pick it below the chat, otherwise I'll present the main page and every section one after another.",
  "agent.tour.sectionQuestionNext": "That section is done. Should I show you another one? Pick it below the chat, otherwise the tour ends here.",
  "agent.tour.sectionsIntro": "I'll quickly show you the sections before we go into details.",
  "agent.tour.skipSection": "Skip section",
  "agent.tour.starterChip": "Show me around this page",
  "agent.tour.starterChipAll": "Show me around the app",
  "agent.tour.stop": "Stop tour",
  "agent.tour.topbar.assistant": "The AI assistant: this button opens and closes the chat you are reading right now.",
  "agent.tour.topbar.chat": "Messages: direct chats with your contacts.",
  "agent.tour.topbar.notifications": "Notifications: invitations, updates and activity around you land here.",
  "agent.tour.topbar.search": "The global search: find people, projects and posts from anywhere in the app.",
  "agent.tour.topbar.user": "Your account: click your name for the profile menu, settings and logout.",
  "agent.tour.welcome": "Welcome to the Smycles system. This tour presents the important features. The buttons under the chat steer the tour. You can also click any chat snippet to jump back to its spot.",
  "agent.untitled": "Untitled chat",
  "auth.redirecting": "Redirecting to login…",
  "auth.sessionExpired.body": "You have been signed out because the session reached its time limit. Changes are no longer being saved. Sign in again to continue where you left off.",
  "auth.sessionExpired.bodyTokensLost": "You have been signed out. Changes are no longer being saved. Sign in again to continue where you left off.",
  "auth.sessionExpired.signIn": "Sign in again",
  "auth.sessionExpired.title": "Session ended",
  "chat.closeChat": "Close chat",
  "chat.deleteChat": "Delete chat",
  "chat.deleteChatConfirm": "Delete this conversation?",
  "chat.liveUpdatesUnavailable": "Live updates unavailable",
  "chat.messageInput": "Message input",
  "chat.messages": "Messages",
  "chat.minimize": "Minimize",
  "chat.more": "More",
  "chat.newConversation": "New conversation",
  "chat.noConversationsYet": "No conversations yet",
  "chat.online": "Online",
  "chat.openMessages": "Messages",
  "chat.searchChats": "Search chats…",
  "chat.searchEnd": "{count} results",
  "chat.searchHint": "Type at least {n} characters",
  "chat.searchPeople": "Search people…",
  "chat.seen": "Seen",
  "chat.sendMessage": "Send message",
  "chat.typing": "typing…",
  "chat.unreadMessages": "{count} unread",
  "chat.writeMessage": "Write a message…",
  "chat.you": "You",
  "cockpit.dismiss": "Dismiss",
  "cockpit.dismissAll": "Dismiss all",
  "cockpit.dismissAllMessage": "This clears your notification inbox and cannot be undone. Notifications that are still waiting for your answer are kept.",
  "cockpit.dismissAllTitle": "Dismiss all notifications?",
  "cockpit.jobActive": "Active",
  "cockpit.noNotifications": "No notifications",
  "cockpit.notifications": "Notifications",
  "cockpit.showMoreDocuments": "Show {count} more",
  "cockpit.unread": "unread",
  "comments.delete.body": "The comment will be removed for good. This cannot be undone.",
  "comments.delete.title": "Delete comment?",
  "comments.discard.body": "Discard the unsaved changes to this comment?",
  "common.add": "Add",
  "common.back": "Back",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.comingSoon": "Coming soon",
  "common.confirm": "Confirm",
  "common.create": "Create",
  "common.delete": "Delete",
  "common.discard": "Discard",
  "common.duplicateName": "An entry with this name already exists. Please choose a different name.",
  "common.edit": "Edit",
  "common.errorWithMessage": "Error: {message}",
  "common.fileDrop.overlay": "Drop to upload …",
  "common.fileDrop.zone": "Drag a file here or click to upload",
  "common.forbidden": "You do not have the required permissions for this action.",
  "common.forbiddenWithCode": "You do not have the required permissions for this action. (Code {code})",
  "common.loadMore": "Load more",
  "common.loading": "Loading…",
  "common.loadingMore": "Loading…",
  "common.next": "Next",
  "common.nextPage": "Next",
  "common.noBackend": "No backend endpoint",
  "common.noResults": "No results found",
  "common.notFound": "Not found",
  "common.notFoundBody": "The page you're looking for doesn't exist.",
  "common.pageOf": "Page {page} of {total}",
  "common.prevPage": "Previous",
  "common.remove": "Remove",
  "common.reset": "Reset",
  "common.save": "Save",
  "common.saveFailed": "Save failed.",
  "common.saving": "Saving…",
  "common.search": "Search",
  "common.serverError": "Something went wrong. Please try again.",
  "common.serverErrorWithCode": "Something went wrong. Please try again. (Code {code})",
  "common.share.ariaActive": "Sharing active",
  "common.share.ariaInactive": "Not sharing",
  "common.share.off": "Private",
  "common.share.on": "Share",
  "common.tryAgain": "Try again",
  "common.undo": "Undo",
  "common.unsavedChanges": "Unsaved changes",
  "community.tour.contacts.desc": "{count} contacts in the current view. Click a card to open the profile, use \"+ Add\" to put it into communities, or drag it onto one on the left.",
  "community.tour.contacts.title": "Your contacts",
  "community.tour.controls.desc": "Search contacts by name, change the sort order, or filter to contacts that are not in any community yet.",
  "community.tour.controls.title": "Search & sort",
  "community.tour.groups.desc": "{count} communities to group your contacts. Click one to see its members, create new ones via \"+ Community\", and drag a contact card onto a community to add it.",
  "community.tour.groups.title": "Your communities",
  "community.tour.label": "Save Community",
  "community.tour.summary": "This is your Community page: {contacts} contacts, organized into {groups} communities.",
  "company.admin.competencies.blank": "A skill needs a name. Give it one, or remove it.",
  "company.admin.competencies.duplicate": "This company already lists the skill ‘{label}’.",
  "company.admin.competencies.editLabel": "Edit skill",
  "company.admin.competencies.label": "Skill",
  "company.admin.competencies.labelPlaceholder": "e.g. Regulatory Affairs",
  "company.admin.competencies.listFull": "This company already lists {max, number} skills, which is the maximum. Remove one to add another.",
  "company.admin.competencies.none": "No skills listed yet.",
  "company.admin.competencies.pendingAddNamed": "‘{label}’ will be added when you save.",
  "company.admin.competencies.pendingEditNamed": "‘{label}’ will be rewritten when you save.",
  "company.admin.competencies.pendingRemoveNamed": "‘{label}’ will be removed when you save.",
  "company.admin.competencies.stagedList": "Pending skill changes",
  "company.admin.competencies.tooLong": "A skill can be at most {max, number} characters long.",
  "company.admin.done": "Done editing",
  "company.admin.edit": "Edit company",
  "company.admin.error.alreadyMember": "This person is already listed at this company.",
  "company.admin.error.cannotAdminister": "This person's account is not active, so they cannot administer a company. Choose somebody whose account is still active.",
  "company.admin.error.employeeCount": "The number of employees must be a whole number of 0 or more.",
  "company.admin.error.expertiseAlreadyListed": "“{label}” is already listed, so it cannot be added twice.",
  "company.admin.error.expertiseListFull": "This company already lists {max, number} skills, which is the maximum. Remove one to add another.",
  "company.admin.error.expertiseTooLong": "A skill can be at most {max, number} characters long. Shorten it and add it again.",
  "company.admin.error.lastAdmin": "A company must keep at least one administrator. Make somebody else an administrator first.",
  "company.admin.error.logoRefused": "The logo was refused. It has to be a PNG, JPEG, GIF, BMP, TIFF or WebP image of at most {max, number} MB.",
  "company.admin.error.nameRequired": "A company name is required.",
  "company.admin.error.nameTooLong": "The company name may be at most {max, number} characters.",
  "company.admin.error.notAdmin": "You no longer administer this company. Reload the page to see what you can still do.",
  "company.admin.error.saveProfile": "The company could not be saved.",
  "company.admin.error.summaryTooLong": "The About us text may be at most {max, number} characters.",
  "company.admin.error.tooManyContactPersons": "A company can have at most {max, number} contact persons. Somebody else has just used the last slot, so unmark one to mark this person.",
  "company.admin.field.employeeCount": "Employees",
  "company.admin.field.industry": "Industry",
  "company.admin.field.industryNoResults": "No industry matches",
  "company.admin.field.industryPlaceholder": "No industry",
  "company.admin.field.industrySearch": "Search industries",
  "company.admin.field.name": "Name",
  "company.admin.field.summary": "About us",
  "company.admin.logo.change": "Change the company logo",
  "company.admin.logo.changeHover": "Change logo",
  "project.access.count": "Access · {count}",
  "project.access.hint": "Everyone listed here can see the project. Candidates are something else: they are asked, and they have no access.",
  "project.access.none": "Nobody has access. Add a person below.",
  "project.access.roleAdmin": "Manage",
  "project.access.roleReader": "View",
  "project.activity.ablauf": "Timeline started",
  "project.activity.anlass": "Occasion added",
  "project.activity.aufteilen": "Split into sections",
  "project.activity.created": "Project created",
  "project.activity.dokumente": "Documents filed",
  "project.activity.empty": "Nothing yet. What happens in the project shows up here.",
  "project.activity.kandidaten": "Candidates picked",
  "project.activity.mitglieder": "Team extended",
  "project.activity.showAll": "Show {count} more",
  "project.activity.team": "Team described",
  "project.anlass.placeholder": "Pick an occasion",
  "project.candidates.allContacts": "All",
  "project.candidates.existingMatchDesc": "Take an earlier match result as the starting point.",
  "project.candidates.existingMatchLabel": "Your matches so far",
  "project.candidates.existingMatchTitle": "I already have a match",
  "project.candidates.knownDesc": "From your community or through search.",
  "project.candidates.knownTitle": "Add from community",
  "project.candidates.linkedTitle": "Matches of this project",
  "project.candidates.matchDesc": "Straight into MATCH, with this project's requirements.",
  "project.candidates.matchTitle": "I want to match",
  "project.candidates.noLinked": "This project has no match yet.",
  "project.candidates.noMatches": "No match with a result. Turn the filter off to see all of them.",
  "project.candidates.onlyWithResult": "With results only",
  "project.candidates.openMatch": "Open",
  "project.candidates.pick": "Add",
  "project.candidates.picked": "Added",
  "project.candidates.pickedNote": "People you ask get no access to the project yet, but you can already plan tasks for them.",
  "project.candidates.remove": "Remove",
  "project.candidates.resultCount": "{count, plural, =0 {no result} one {1 result} other {# results}}",
  "project.candidates.unlink": "Unlink",
  "project.candidates.unlinkBody": "“{name}” will no longer belong to this project. The match itself, with its candidates and results, stays.",
  "project.candidates.unlinkTitle": "Unlink from the project",
  "project.create.contextSub": "If you already have something, bring it along. The assistant reads occasion, requirements and first roles out of it. It works just as well without.",
  "project.create.contextTitle": "Bring context along",
  "project.create.descLabel": "Description",
  "project.create.descPlaceholder": "What is this about? Two sentences are enough, the rest grows with the project.",
  "project.create.dropHint": "max. 10 MB per file",
  "project.create.dropLabel": "Drop a file here or click",
  "project.create.eyebrow": "Create",
  "project.create.fromDocuments": "From my documents",
  "project.create.generate": "Generate for me",
  "project.create.generatePrompt": "Derive occasion, breakdown and first roles from the title, the description and the attached documents.",
  "project.create.importLabel": "Import from",
  "project.create.sub": "A title is enough. Everything else is optional and can be added inside the project later.",
  "project.create.submit": "Create project",
  "project.create.submitting": "Creating …",
  "project.create.title": "New project",
  "project.create.actingAsCompany": "Creating as {company}. Leave the company context to create it as yourself.",
  "project.create.titleLabel": "Title",
  "project.create.titlePlaceholder": "What do you need people for?",
  "project.create.uploadLabel": "Documents",
  "project.data.service.asana.desc": "Tasks as context",
  "project.data.service.asana.title": "Asana",
  "project.data.service.jira.desc": "Tickets as context",
  "project.data.service.jira.title": "Jira",
  "project.data.service.monday.desc": "Boards as context",
  "project.data.service.monday.title": "Monday",
  "project.data.service.trello.desc": "Cards as context",
  "project.data.service.trello.title": "Trello",
  "project.delete.confirm": "Delete this project for good? Linked matches stay.",
  "project.delete.title": "Delete project",
  "project.documents.ariaLabel": "Add documents",
  "project.documents.dropHint": "max. 10 MB per file, also lands in your documents",
  "project.documents.dropLabel": "Drop a file here or click",
  "project.documents.empty": "No documents yet.",
  "project.documents.tooLarge": "Too large (max. {max} MB per file): {names}",
  "project.event.date": "Date",
  "project.event.kind": "Kind",
  "project.event.kind.deadline": "Deadline",
  "project.event.kind.meeting": "Meeting",
  "project.event.kind.milestone": "Milestone",
  "project.event.title": "Event",
  "project.facet.ablauf.add": "Follow the activity",
  "project.facet.ablauf.empty": "Nothing has happened yet",
  "project.facet.ablauf.filled": "Running",
  "project.facet.ablauf.label": "Activity",
  "project.facet.anlass.add": "Choose occasion",
  "project.facet.anlass.empty": "What is this about?",
  "project.facet.anlass.filled": "Programme · rollout in three countries",
  "project.facet.anlass.label": "Occasion",
  "project.facet.aufteilen.add": "Plan the schedule",
  "project.facet.aufteilen.empty": "Break it into sections",
  "project.facet.aufteilen.filled": "4 sections",
  "project.facet.aufteilen.label": "Schedule",
  "project.facet.dokumente.add": "Add documents",
  "project.facet.dokumente.empty": "Nothing filed yet",
  "project.facet.dokumente.filled": "Documents filed",
  "project.facet.dokumente.label": "Documents",
  "project.facet.kandidaten.add": "Find people",
  "project.facet.kandidaten.empty": "Who could join?",
  "project.facet.kandidaten.filled": "People asked",
  "project.facet.kandidaten.label": "Match",
  "project.facet.mitglieder.add": "Show the team",
  "project.facet.mitglieder.empty": "Nobody on board yet",
  "project.facet.mitglieder.filled": "People in the project",
  "project.facet.mitglieder.label": "Team",
  "project.facet.team.add": "Add requirements",
  "project.facet.team.empty": "Which skills does it take?",
  "project.facet.team.filled": "Profile described",
  "project.facet.team.label": "Requirements",
  "project.guided.anlass.aufgabe.desc": "Something bounded that needs doing. Small and quick.",
  "project.guided.anlass.aufgabe.title": "Task",
  "project.guided.anlass.auftrag.desc": "A client, an agreed outcome, a price.",
  "project.guided.anlass.auftrag.title": "Contract",
  "project.guided.anlass.ausschreibung.desc": "A formal procedure with a deadline, required forms, and evaluation.",
  "project.guided.anlass.ausschreibung.title": "Tender",
  "project.guided.anlass.initiative.desc": "Something you want to start, without anyone having asked for it.",
  "project.guided.anlass.initiative.title": "Initiative",
  "project.guided.anlass.planvorstellung.desc": "Still an idea, but tellable already. Numbers are estimated.",
  "project.guided.anlass.planvorstellung.title": "Pitch",
  "project.guided.anlass.programm.desc": "Something bigger with stages that breaks down into parts.",
  "project.guided.anlass.programm.title": "Programme",
  "project.guided.aufteilen.addEvent": "+ Event",
  "project.guided.aufteilen.addSection": "+ Work package",
  "project.guided.aufteilen.autosaved": "Saved automatically",
  "project.guided.aufteilen.newSectionName": "Work package {n}",
  "project.guided.aufteilen.newTaskName": "New task",
  "project.guided.aufteilen.sub": "Work packages with a period, tasks inside them, dates in between. Four to eight packages are enough.",
  "project.guided.team.expertiseTitle": "Required skills (min.)",
  "project.guided.team.powersSub": "Click a group to weight its five powers.",
  "project.guided.team.powersTitle": "Power Scorecard",
  "project.guided.team.profileName": "Custom",
  "project.guided.team.sub": "You are looking for skills, not names. What stands here is the same profile a match will later compute with.",
  "project.import.notLinked": "{service} is currently not linked",
  "project.lanes.collapseLane": "Collapse lane",
  "project.lanes.collapsedCount": "{count, plural, one {1 entry} other {# entries}}",
  "project.lanes.empty": "No work packages with a period yet.",
  "project.lanes.expandLane": "Expand lane",
  "project.lanes.scaleCompact": "Small",
  "project.lanes.scaleDetail": "Large",
  "project.lanes.scaleLabel": "Scale",
  "project.lanes.scaleNormal": "Medium",
  "project.lanes.unassigned": "Unassigned",
  "project.meta.owner": "Owner",
  "project.meta.status": "Status",
  "project.meta.tags": "Tags",
  "project.notFound": "Project not found",
  "project.plan.addTask": "Add task",
  "project.plan.addTaskHere": "Add a task to this work package",
  "project.plan.assignee": "Assigned to",
  "project.plan.collapsePackage": "Hide tasks",
  "project.plan.deleteEvent": "Delete event",
  "project.plan.deleteEventConfirm": "Delete event?",
  "project.plan.deletePackage": "Delete work package",
  "project.plan.deletePackageConfirm": "{count, plural, =0 {Delete work package?} one {Delete it with one task?} other {Delete it with # tasks?}}",
  "project.plan.done": "Done",
  "project.plan.editRow": "Edit",
  "project.plan.empty": "No work packages yet. A work package is a piece of work with a period; the tasks live inside it.",
  "project.plan.end": "End",
  "project.plan.event": "Event",
  "project.plan.expandPackage": "Show tasks",
  "project.plan.lanes.weekRange": "Week {week}: {from} to {to}",
  "project.plan.newEventName": "New event",
  "project.plan.order.label": "Sort",
  "project.plan.order.newest": "Newest first",
  "project.plan.order.oldest": "Oldest first",
  "project.plan.package": "Work package",
  "project.plan.packageTitle": "Work package",
  "project.plan.removeTask": "Delete task",
  "project.plan.removeTaskConfirm": "Delete task?",
  "project.plan.selectHint": "Click a bar to change it here.",
  "project.plan.start": "Start",
  "project.plan.taskCount": "{count, plural, one {1 task} other {# tasks}}",
  "project.plan.taskTitle": "Task",
  "project.plan.unnamed": "Untitled",
  "project.readOnlyBanner": "You can only view this project. Ask the owner for write access.",
  "project.readOnlyAskCompanyAdmin": "You can only view this project. Ask an administrator of {company} for write access.",
  "project.readOnlyNeedsCompanyContext": "Belongs to {company}. Switch to the company context to edit it.",
  "project.readOnlyLeaveCompanyContext": "You are acting as {company}. Leave the company context to edit your project.",
  "project.results.candidates": "{count, plural, one {1 candidate} other {# candidates}}",
  "project.results.close": "Close",
  "project.results.hide": "Hide people",
  "project.results.loading": "Loading results …",
  "project.results.noPersons": "Nobody in this result.",
  "project.results.none": "This match has no result yet.",
  "project.results.show": "Show people",
  "project.results.unnamed": "Result",
  "project.service.importTags": "Import · Context",
  "project.service.importTitle": "Bring in context",
  "project.settings.heading": "Name, status & access",
  "project.settings.noWriteRights": "You don't have write access to these project settings.",
  "project.settings.title": "Project settings",
  "project.status.active": "In progress",
  "project.status.cancelled": "Cancelled",
  "project.status.done": "Completed",
  "project.status.funding": "Funding",
  "project.status.idea": "Idea",
  "project.status.paused": "Paused",
  "project.status.scaling": "Scaling",
  "project.status.seed": "Seed",
  "project.tags.add": "Tag",
  "project.tags.empty": "No tags yet. They help find similar projects later.",
  "project.tags.new": "New tag",
  "project.tags.placeholder": "Tag, then Enter",
  "project.tags.remove": "Remove {tag}",
  "project.team.addMore": "Find more",
  "project.team.asked": "Asked",
  "project.team.askedNote": "People you asked cannot see the project yet, but you can already plan tasks for them.",
  "project.team.badgeMember": "In the project",
  "project.team.empty": "Nobody else on board yet. Through Match you find people from your community, from an earlier match, or through a new search.",
  "project.team.members": "With access",
  "project.team.toMatch": "Find people",
  "project.team.toNewMatch": "I want to match",
  "project.timeline.focusPerson": "Person focus",
  "project.timeline.focusProject": "Project focus",
  "project.toMatch.copyNote": "What comes along is a copy: changing it in the match does not change the project. They stay connected all the same, the match shows up in the project afterwards.",
  "project.toMatch.creating": "Creating match …",
  "project.toMatch.description": "Description",
  "project.toMatch.documentBack": "Take it after all",
  "project.toMatch.documents": "Documents",
  "project.toMatch.documentsDetail": "{count, plural, =0 {Nothing yet} one {One document} other {# documents}}",
  "project.toMatch.go": "Create match and open it",
  "project.toMatch.nothingYet": "Nothing yet",
  "project.toMatch.openPartial": "Open match",
  "project.toMatch.orphaned": "The match was created but could not be linked to the project. You will find it under MATCH.",
  "project.toMatch.partial": "The match was created and linked to the project, but {missing, select, people {the people} documents {the documents} other {the people and the documents}} could not be carried over. You can add them in the match.",
  "project.toMatch.people": "People",
  "project.toMatch.peopleDetail": "{count, plural, =0 {Nobody in the project yet} one {One person from the project} other {# people from the project}}",
  "project.toMatch.peopleDropped": "Stays here",
  "project.toMatch.peopleTaken": "Comes along",
  "project.toMatch.requirements": "Requirements",
  "project.toMatch.requirementsDetail": "{count, plural, =0 {Nothing yet} one {One skill} other {# skills}}",
  "project.toMatch.scorecard": "Power scorecard",
  "project.toMatch.scorecardSet": "Carry the weighting over",
  "project.toMatch.sub": "The match does not start from scratch. Pick what comes along from the project.",
  "project.toMatch.takeTitle": "What comes along",
  "project.workspace.activity": "Recent activity",
  "project.workspace.description": "Description",
  "project.workspace.descriptionEmpty": "No description yet.",
  "project.workspace.documents": "Documents",
  "project.workspace.metaCreated": "Created on {date} by {person}",
  "project.workspace.metaCreatedForCompany": "Created on {date} for {company} by {person}",
  "project.workspace.overview": "Overview",
  "project.workspace.renameLabel": "Rename project",
  "project.workspace.typeBadge": "Project",
  "project.workspace.untitled": "Untitled project",
  "company.admin.logo.choose": "Upload a company logo",
  "company.admin.logo.saved": "Logo saved.",
  "company.admin.logo.tooLarge": "{name} is too large. A logo may be at most {max, number} MB.",
  "company.admin.logo.tooManyPixels": "This image is too large to crop. Use one under {max} megapixels.",
  "company.admin.logo.unreadable": "That file could not be read. Try choosing it again.",
  "company.admin.logo.unsupported": "{name} cannot be used as a logo. Choose a PNG, JPEG, GIF, BMP, TIFF or WebP image.",
  "company.admin.members.add": "Add to company",
  "company.admin.members.addHint": "Puts an existing person on the list. They are not asked first, and nothing is written until you save.",
  "company.admin.members.addTitle": "Add a person",
  "company.admin.members.contactPerson": "Contact person",
  "company.admin.members.contactPersonLimit": "All {max, number} contact persons are marked. Unmark one to mark somebody else.",
  "company.admin.members.noPeople": "Nobody matches who is not already listed.",
  "company.admin.members.pendingAdd": "Will be added when you save.",
  "company.admin.members.pendingContact": "The contact-person mark applies when you save.",
  "company.admin.members.pendingRemove": "Will be removed when you save.",
  "company.admin.members.pendingRole": "The new role applies when you save.",
  "company.admin.members.remove": "Remove",
  "company.admin.members.roleAdmin": "Administrator",
  "company.admin.members.roleMember": "Member",
  "company.admin.members.searchPlaceholder": "Search people by name",
  "company.admin.members.searching": "Searching people",
  "company.admin.members.soleAdmin": "The only administrator. Make somebody else an administrator to change or remove this one.",
  "company.admin.profile.saved": "Saved.",
  "company.admin.status.confirm": "Deactivating takes this company out of both searches and freezes its posts and projects: they can no longer be published, edited or deleted. Nothing is deleted, and reactivating gives all of it back.",
  "company.admin.status.deactivate": "Deactivate company",
  "company.admin.status.deactivateConfirm": "Deactivate",
  "company.admin.status.inactive": "This company is deactivated. It is out of both searches, and nothing can be published or changed in its name.",
  "company.admin.status.label": "Company status",
  "company.admin.status.reactivate": "Reactivate company",
  "company.context.acting": "Acting as {name}.",
  "company.context.actingAsCompanyOnOwnContent": "This content is your own, so changing it means leaving the company you are acting as. Choose “Leave company context”, then try again.",
  "company.context.current": "Acting as this company",
  "company.context.enter": "Act as this company",
  "company.context.enterNamed": "Act as {name}",
  "company.context.landmark": "Company context",
  "company.context.leave": "Leave company context",
  "company.context.notActingAsCompany": "This content belongs to a company, so changing it means acting as that company. Open the company page and choose “Act as this company”, then try again.",
  "company.context.scopeAdmin": "You can view and edit this company, manage its people, and publish in its name.",
  "company.context.unsavedBody": "Changing the company context reloads everything on screen. Changes you have not saved will be lost.",
  "company.create.failed": "The company could not be created.",
  "company.create.submit": "Create company",
  "company.inactive.frozen": "This company is inactive, so its content is frozen. Reactivate the company to publish or change anything in its name.",
  "company.inactive.frozenReader": "This company is inactive, so its content is frozen.",
  "company.mine.empty": "You are not listed at any company yet. An administrator of a company can add you to it.",
  "company.mine.emptyWithCreate": "You are not listed at any company yet. Register one to get started.",
  "company.mine.intro": "The companies you are listed at. Open one to see its page.",
  "company.mine.loading": "Loading your companies",
  "company.mine.new": "New company",
  "company.mine.title": "My companies",
  "company.page.about.empty": "This company has not described itself yet.",
  "company.page.about.title": "About us",
  "company.page.card.title": "Company card",
  "company.page.competencies.empty": "No skills recorded yet.",
  "company.page.competencies.noCapability": "No capability",
  "company.page.competencies.title": "Skills",
  "company.page.contacts.hint": "The people this company named to talk to. Open a profile to get in touch.",
  "company.page.contacts.title": "Contact persons",
  "company.page.employeeCount": "{count, plural, one {# employee} other {# employees}}",
  "company.page.employeeCount.unit": "{count, plural, one {employee} other {employees}}",
  "company.page.employeeCount.unset": "Number",
  "company.page.industry.unset": "Industry not specified",
  "company.page.loading": "Loading company",
  "company.page.members.count": "{count, plural, one {# person} other {# people}}",
  "company.page.members.countPartial": "{shown} of {total} people shown",
  "company.page.members.empty": "Nobody is listed yet.",
  "company.page.members.loadingMore": "Loading people",
  "company.page.members.showMore": "Show more people",
  "company.page.members.title": "People",
  "company.page.notFound": "Company not found",
  "company.page.notFoundHint": "This company does not exist or is not visible to you.",
  "company.page.stopEditingUnsavedBody": "Leaving edit mode discards everything you have not saved: the profile, the logo, and any people or skills you added or removed.",
  "company.page.work.title": "Posts and projects",
  "company.validation.alreadyExists": "{field} is already taken. Choose a different one.",
  "company.validation.formatError": "{field} has an unexpected value. Check it and save again.",
  "company.validation.isMandatory": "{field} is required.",
  "companyFilter.heading": "Company filters{count, plural, =0 {} other { · # active}}",
  "cv.color": "Color",
  "cv.createFailed": "Creating the CV failed.",
  "cv.createTitle": "Create CV",
  "cv.download": "Download",
  "cv.downloadFailed": "Download failed.",
  "cv.editTitle": "Edit CV",
  "cv.error.nameRequired": "A name is required.",
  "cv.field.address": "Location",
  "cv.field.birthDate": "Date of birth",
  "cv.field.drivingLicence": "Driving licence",
  "cv.field.email": "Email",
  "cv.field.nationality": "Nationality",
  "cv.field.phone": "Phone",
  "cv.field.web": "Web",
  "cv.generator": "CV Generator",
  "cv.name": "Name",
  "cv.notSignedIn": "Not signed in?",
  "cv.personal.born": "b. {date}",
  "cv.personal.licence": "Licence {value}",
  "cv.previewTitle": "CV Preview",
  "cv.reallyDelete": "Really delete",
  "cv.saveCv": "Save CV",
  "cv.section.certifications": "Certifications",
  "cv.section.education": "Education",
  "cv.section.experience": "Work Experience",
  "cv.section.expertise": "Skills",
  "cv.section.languages": "Languages",
  "cv.section.summary": "Profile",
  "cv.sectionCertifications": "Certificates",
  "cv.sectionEducation": "Education",
  "cv.sectionExperience": "Work experience",
  "cv.sectionExpertise": "Skills",
  "cv.sectionLanguages": "Languages",
  "cv.sectionProfile": "Profile",
  "cv.sections": "Sections",
  "cv.sidebarContact": "Contact",
  "cv.sliderHeadingSize": "Heading size",
  "cv.sliderIndentation": "Indentation",
  "cv.sliderSectionMargin": "Section margin",
  "cv.sliderSpacing": "Spacing",
  "cv.sliderTextSize": "Text size",
  "cv.template": "Template",
  "cv.template.comic.tagline": "THE BEST RESUME OF ALL TIME!!!",
  "cv.template.contact": "Contact",
  "cv.updateFailed": "Updating the CV failed.",
  "cv.variant": "Variant {n}",
  "design.addEntry": "Add entry",
  "design.apply": "Apply",
  "design.booleanYes": "Yes",
  "design.cardComments": "Comments",
  "design.cardRating": "Rating",
  "design.cardViews": "Views",
  "design.chipCommented": "Commented",
  "design.chipCreated": "Created",
  "design.chipInterested": "Interested",
  "design.chipRated": "Rated",
  "design.chipWatched": "Watched",
  "design.chooseLevel": "Choose level.",
  "design.clearValue": "Clear value",
  "design.copied": "Copied",
  "design.copy": "Copy",
  "design.cropPhoto": "Crop photo",
  "design.cropLogo": "Crop logo",
  "design.filterPlaceholder": "Type to filter …",
  "design.monthPlaceholder": "Month",
  "design.numberStepperDecrease": "Decrease {noun}",
  "design.numberStepperFallbackNoun": "value",
  "design.numberStepperIncrease": "Increase {noun}",
  "design.removeTask": "Remove task",
  "design.requiredField": "Required field",
  "design.selectPlaceholder": "Select …",
  "design.selfAssessmentDone": "Self-assessment completed",
  "design.shareLink": "Share link",
  "design.shareTitle": "Share",
  "design.shareWithArrow": "↗ Share",
  "design.stepChainFailed": "Failed",
  "design.stepChainRunning": "In progress",
  "design.stepChainStateActive": "in progress",
  "design.stepChainStateDone": "done",
  "design.stepChainStateFailed": "failed",
  "design.stepChainStatePending": "pending",
  "design.stepChainStateSkipped": "skipped",
  "design.stillFillIn": "Please still fill in: {fields}",
  "design.yearPlaceholder": "Year",
  "design.zoom": "Zoom",
  "documents.nameTooLong": "A document name may be at most 255 characters.",
  "error.route.body": "Something in this view could not be read. Your data is unchanged. You can go back and try another page.",
  "error.route.reload": "Reload the page",
  "error.route.title": "This page could not be displayed",
  "grow.answer.leadIn": "On your self-assessment:",
  "grow.answer.growthAreas": "Growth areas",
  "grow.answer.example": "Example",
  "grow.answer.situation": "Situation",
  "grow.answer.approach": "Approach",
  "grow.answer.outcome": "Outcome",
  "grow.ask.improveAsk": "How can I develop {name}?",
  "grow.ask.improveBrief": "Start by explaining what {name} is about: the definition and what concretely lies behind it. Then briefly sum up my score of {score} and my growth areas. After that, show me {examples, plural, one {one concrete example} other {# concrete examples}} from my working life for developing {name}. Take my profile and my questionnaire answers into account.",
  "grow.ask.improveBriefIncomplete": "Start by explaining what {name} is about: the definition and what concretely lies behind it. Then tell me briefly where I stand with the questionnaire. After that, show me {examples, plural, one {one concrete example} other {# concrete examples}} from my working life for developing {name}. Take my profile into account.",
  "grow.askConsent.continue": "Continue",
  "grow.askConsent.groupAria": "Send this data or cancel",
  "grow.askConsent.note": "So the AI assistant can give you personal tips for developing your power, it uses your self-assessment for {name} and every field of your profile, including private details such as date of birth, marital status or nationality. It uses this data only for this conversation, for as long as you stay on this page.",
  "grow.assessment.allAnswered": "All questions answered",
  "grow.assessment.askAria": "Ask the assistant about this statement",
  "grow.assessment.boxAriaLabel": "Go to question {index}",
  "grow.assessment.boxTitle": "Question {index}",
  "grow.assessment.boxTitleAnswered": "Question {index} · answered",
  "grow.assessment.enterToContinue": "Enter to continue",
  "grow.assessment.keyboardHint": "Keys 1–{max} or ←/→ to select",
  "grow.assessment.progress": "Question {index} / {total} · {answered} answered",
  "grow.assessment.saveFailed": "Could not save.",
  "grow.assessment.skip": "Skip",
  "grow.assessment.zoneHint": "↑/↓ switches the row (Questions · Rating · Navigation)",
  "grow.assessmentSubtitle": "Rate how strongly each statement applies to you.",
  "grow.elementAssessment.askIntro.0": "I'm rating the statement: \"{statement}\". Help me understand what it means and how to evaluate it for myself.",
  "grow.elementAssessment.askIntro.1": "Help me make sense of this statement: \"{statement}\". What does it mean and how should I rate it?",
  "grow.elementAssessment.askIntro.2": "I'm not sure how to rate \"{statement}\". Can you help me interpret and evaluate it?",
  "grow.elementAssessment.askIntro.3": "What is the statement \"{statement}\" really getting at, and how do I judge it for myself?",
  "grow.elementAssessment.askIntro.4": "Walk me through the statement \"{statement}\" so I can rate it honestly.",
  "grow.elementAssessment.askIntro.5": "Help me reflect on \"{statement}\" – what does it mean and how do I assess it?",
  "grow.elementAssessment.askIntro.6": "How should I think about the statement \"{statement}\" when rating myself?",
  "grow.elementAssessment.askIntro.7": "Unpack \"{statement}\" for me and help me decide how much it applies to me.",
  "grow.elementAssessment.askIntro.8": "I'm evaluating \"{statement}\". What does it mean, and what should I consider before rating it?",
  "grow.elementAssessment.askIntro.9": "Explain \"{statement}\" and help me figure out where I fall on it.",
  "grow.elementAssessment.notSaved": "not saved",
  "grow.elementAssessment.savedStatus": "saved",
  "grow.elementAssessment.savingStatus": "saving…",
  "grow.elementAssessment.statementLabel": "Statement {index}",
  "grow.elementAssessment.toEvaluation": "To evaluation",
  "grow.elementResult.answeredCount": "{answered}/{total} answered",
  "grow.elementResult.askButton": "Discuss my result",
  "grow.elementResult.evaluation": "Evaluation",
  "grow.elementResult.fullyAnswered": "Fully answered",
  "grow.elementResult.lastEvaluatedOn": "Last evaluated: {date}",
  "grow.elementResult.reassess": "Assess again",
  "grow.elementResult.selfAssessmentCompleted": "All statements rated",
  "grow.elementResult.toPower": "To Power",
  "grow.elementResult.toPowerMap": "To Power Map",
  "grow.elementResult.unknownElement": "Unknown element",
  "grow.elementResult.yourScore": "Your score",
  "grow.followUp.exportPdf": "Export the result as a PDF",
  "grow.followUp.longTerm": "Show me goals for the next 6 to 12 months",
  "grow.followUp.saveStudio": "Save the result in Studio",
  "grow.games.group.progress": "{done} of {total} lists done",
  "grow.games.groups.top10.description": "Show others what you love and discover what you have in common. Create your top 10 lists – from movies to music.",
  "grow.games.groups.top10.title": "Top 10",
  "grow.games.toplist.books.description": "Which books moved you most?",
  "grow.games.toplist.books.title": "Books",
  "grow.games.toplist.cities.description": "Which cities draw you most?",
  "grow.games.toplist.cities.title": "Travel destinations",
  "grow.games.toplist.dishes.description": "Which dishes do you like best?",
  "grow.games.toplist.dishes.title": "Dishes",
  "grow.games.toplist.catalogueTooSmall": "There are not enough entries for this game yet.",
  "grow.games.toplist.hobbies.description": "What do you most like to do in your free time?",
  "grow.games.toplist.hobbies.title": "Hobbies",
  "grow.games.toplist.movies.description": "Which movies do you love most?",
  "grow.games.toplist.movies.title": "Movies",
  "grow.games.toplist.music.description": "Which artists and bands do you listen to most?",
  "grow.games.toplist.music.title": "Music",
  "grow.games.toplist.result.again": "Play again",
  "grow.games.toplist.result.apply": "Save to profile",
  "grow.games.toplist.result.discardMessage": "Your top {count} will not be saved to your profile.",
  "grow.games.toplist.result.discardTitle": "Discard your ranking?",
  "grow.games.toplist.result.saved": "Saved to your profile.",
  "grow.games.toplist.result.title": "Your top {count}",
  "grow.games.toplist.result.toProfile": "To profile",
  "grow.games.toplist.series.description": "Which series do you love most?",
  "grow.games.toplist.series.title": "Series",
  "grow.games.toplist.sports.description": "Which sports excite you most?",
  "grow.games.toplist.sports.title": "Sports",
  "grow.games.toplist.yearBc": "{year} BC",
  "grow.games.unknown": "This game is not available here.",
  "grow.play.game.kind": "Game",
  "profile.sidebars.favorites.empty": "Your top 10 lists appear here once you have played them in Grow · Play.",
  "profile.sidebars.favorites.play": "Play",
  "profile.sidebars.favorites.playAgain": "Play again",
  "profile.sidebars.favorites.remove": "Remove {title}",
  "profile.sidebars.favorites.title": "My top 10",
  "profile.sidebars.favorites.titleOther": "Top 10",
  "grow.mediaKind.podcast": "Podcast",
  "grow.mediaKind.script": "Script",
  "grow.mediaKind.video": "Video",
  "grow.noQuestions": "No questions available for this element.",
  "grow.play.group.kind": "Questionnaire",
  "grow.play.group.missing": "This questionnaire is not available on this environment.",
  "grow.play.quiz.continue": "Continue with part {index}",
  "grow.play.quiz.eyebrow": "Grow · Play",
  "grow.play.quiz.partAnswered": "answered",
  "grow.play.quiz.partLabel": "Part {index}",
  "grow.play.quiz.partOpen": "open",
  "grow.play.quiz.partsProgress": "{answered} of {total} parts answered",
  "grow.play.quiz.result.backToParts": "Back to the parts",
  "grow.play.quiz.result.empty": "No powers to show yet.",
  "grow.play.quiz.result.error": "The result could not be loaded: {message}",
  "grow.play.quiz.result.firstValue": "first self-report value",
  "grow.play.quiz.result.locked": "The result opens once all parts are answered.",
  "grow.play.quiz.result.noQuizItems": "not covered by the quiz",
  "grow.play.quiz.result.openPower": "Open this power",
  "grow.play.quiz.result.quizAlone": "Quiz on its own: {score}{band, select, none {} other { · {band}}}{items, select, none {} other {, from {answered} of {total} items}}.",
  "grow.play.quiz.result.quizOnlySource": "From the quiz alone{items, select, none {} other {, {answered} of {total} items}}.",
  "grow.play.quiz.result.subtitle": "How the parts you answered moved your powers. They count towards your self-report score, weighted by how many items they contribute.",
  "grow.play.quiz.result.title": "Your result",
  "grow.play.quiz.result.unchanged": "unchanged",
  "grow.play.quiz.showResult": "Show result",
  "grow.play.quiz.start": "Start quiz",
  "grow.assess.all": "All",
  "grow.assess.analyseDocuments": "Analyse documents",
  "grow.assess.choose": "Take a closer look",
  "grow.assess.completed": "Completed",
  "grow.assess.continue": "Continue questionnaire",
  "grow.assess.documentsCount": "{count, plural, one {# document analysed} other {# documents analysed}}",
  "grow.assess.documentsError": "Analysed documents could not be loaded.",
  "grow.assess.documentsLoading": "Loading analysed documents",
  "grow.assess.documentInsights": "Insights from documents",
  "grow.assess.guided": "Guided questionnaire",
  "grow.assess.inProgress": "In progress",
  "grow.assess.intro": "Explore your <concept>Powers</concept> through questionnaires, self-assessments and document analysis. Choose where to start or continue.",
  "grow.assess.loadError": "Assessments could not be loaded.",
  "grow.assess.noMatches": "No assessments match this filter.",
  "grow.assess.notStarted": "Not started",
  "grow.assess.partsProgress": "{done} / {total} {total, plural, one {part} other {parts}}",
  "grow.assess.powerJourney": "Power Journey",
  "grow.assess.powersMeasured": "Powers measured",
  "grow.assess.progress": "Your progress",
  "grow.assess.selfAssessmentKind": "Self-assessment",
  "grow.assess.smartAnalysisDocuments": "Smart Analysis documents",
  "grow.assess.smartDescription": "The AI reads documents that describe you and analyses how strong your Powers are.",
  "grow.assess.review": "Review questionnaire",
  "grow.assess.start": "Start questionnaire",
  "grow.assess.title": "Understand your Power Profile",
  "grow.assess.tour": "Choose a questionnaire or a Power to assess.",
  "grow.assess.tourFeatured": "Open this questionnaire to answer or resume it.",
  "grow.assess.uploadDocuments": "Upload documents",
  "grow.powerDetail.askButton": "Understand {name}",
  "grow.powerDetail.askImproveButton": "How do I improve {name}?",
  "grow.powerDetail.askIntro.0": "Using the reference material, give me an intro to {name} and tell me more about it.",
  "grow.powerDetail.askIntro.1": "Introduce me to {name} based on the reference material – what is it about?",
  "grow.powerDetail.askIntro.2": "Draw on the reference material to explain {name} to me.",
  "grow.powerDetail.askIntro.3": "What does the reference material say about {name}? Give me an overview.",
  "grow.powerDetail.askIntro.4": "Give me a beginner-friendly intro to {name}, grounded in the reference material.",
  "grow.powerDetail.askIntro.5": "Walk me through {name} using the reference material.",
  "grow.powerDetail.askIntro.6": "From the reference material, summarize what {name} is and why it matters.",
  "grow.powerDetail.askIntro.7": "Help me understand {name} – use the reference material for an intro.",
  "grow.powerDetail.askIntro.8": "Explain {name} to me from the reference material, as if I'm new to it.",
  "grow.powerDetail.askIntro.9": "Based on the reference material, what should I know about {name}?",
  "grow.powerDetail.confidence": "Confidence: {percent}%",
  "grow.powerDetail.combinedScore": "Your combined Power score",
  "grow.powerDetail.continueSelfAssessment": "Continue in-depth assessment",
  "grow.powerDetail.evidenceTitle": "Evidence",
  "grow.powerDetail.eyebrow": "Power · {abbr}",
  "grow.powerDetail.noAnalysis": "No analysis yet",
  "grow.powerDetail.noScore": "No Power score yet",
  "grow.powerDetail.noScoreHint": "Answer statements about this Power or analyse your work documents to begin.",
  "grow.powerDetail.noScoreHintNoUpload": "Answer statements about this Power to begin.",
  "grow.powerDetail.notStarted": "In-depth assessment not started",
  "grow.powerDetail.openDocumentNamed": "Open document {name}",
  "grow.powerDetail.page": "Page {number}",
  "grow.powerDetail.loadError": "Your Power result could not be loaded.",
  "grow.powerDetail.rationaleNoConfidence": "The evidence found was not enough to rate this Power reliably.",
  "grow.powerDetail.rationaleNoEvidence": "No evidence for this Power was found in your documents.",
  "grow.powerDetail.rationaleScoringFailed": "This Power could not be analysed. Run the analysis again.",
  "grow.powerDetail.repeatSelfAssessment": "Review in-depth assessment",
  "grow.powerDetail.selfAssessment": "Self-assessment",
  "grow.powerDetail.smartAnalysis": "Smart Analysis",
  "grow.powerDetail.stanceContra": "Contra",
  "grow.powerDetail.stancePro": "Pro",
  "grow.powerDetail.startSelfAssessment": "Start in-depth assessment",
  "grow.powerDetail.tour.label": "Grow Power",
  "grow.powerDetail.tour.summaryStatus": "You have rated {answered} of {total} in-depth statements.",
  "grow.powerDetail.whatSmartFound": "What Smart Analysis found",
  "grow.powerDetail.yourScore": "Your Power score",
  "grow.powerLibrary.all": "All",
  "grow.powerLibrary.askButton": "Understand my powers",
  "grow.powerLibrary.askIntro.0": "Read my Power Map – where are my strengths and gaps, and what should I focus on?",
  "grow.powerLibrary.askIntro.1": "Give me an overview of my powers: what's strong, what's weak, and where to grow.",
  "grow.powerLibrary.askIntro.2": "Interpret my power profile – the highs, the lows, and a suggested focus.",
  "grow.powerLibrary.askIntro.3": "Based on my powers and the reference material, what patterns do you see?",
  "grow.powerLibrary.askIntro.4": "Help me understand my overall power profile and where to invest.",
  "grow.powerLibrary.askIntro.5": "What do my strongest and weakest powers say about me?",
  "grow.powerLibrary.askIntro.6": "Summarize my power landscape and recommend a growth focus.",
  "grow.powerLibrary.askIntro.7": "Where are my biggest opportunities across my powers?",
  "grow.powerLibrary.askIntro.8": "Walk me through my Power Map and suggest what to work on first.",
  "grow.powerLibrary.askIntro.9": "Give me a big-picture read of my powers and a place to start.",
  "grow.powerLibrary.clearSearch": "Clear search",
  "grow.powerLibrary.heading": "{count} Powers",
  "grow.powerLibrary.journeyTooltip": "The whole route: statement by statement a precise, stable picture emerges. Along the way, you get to know yourself.",
  "grow.powerLibrary.noResults": "No power found for “{query}”.",
  "grow.powerLibrary.onlyUnrated": "Unrated",
  "grow.powerLibrary.openPower": "Open {name}",
  "grow.powerLibrary.powerQuizTooltip": "A few questions give you a real overview of all {count} powers.",
  "grow.powerLibrary.powerScore": "Power Score",
  "grow.powerLibrary.quizUnavailable": "not available yet",
  "grow.powerLibrary.searchPlaceholder": "Search by name or abbreviation",
  "grow.powerLibrary.sourceCombined": "Combined",
  "grow.powerLibrary.sourceSelf": "Self-assessment",
  "grow.powerLibrary.sourceSmart": "Smart Analysis",
  "grow.powerLibrary.subheading": "The complete vocabulary: {clusters} clusters, {powers} powers.",
  "grow.powerLibrary.tour.filters.desc": "Search powers by name or abbreviation, or tap Unrated to see only the {unrated} powers whose statements are still open.",
  "grow.powerLibrary.tour.filters.title": "Search & filter",
  "grow.powerLibrary.tour.grid.desc": "All {total} powers grouped into {clusters} clusters. Click a tile to open that power. A medal and its artwork appear once all its statements are rated; {completed} earned so far.",
  "grow.powerLibrary.tour.grid.title": "The power tiles",
  "grow.powerLibrary.tour.label": "Grow Map",
  "grow.powerLibrary.tour.scoreSource.desc": "Switch which evaluation the numbers on all tiles show. Pick Self-assessment to see the scores from your own ratings.",
  "grow.powerLibrary.tour.scoreSource.title": "Score source",
  "grow.powerLibrary.tour.summary": "This is the Power Map: all {total} powers, periodic-table style. You have fully self-assessed {completed} of {total} so far.",
  "grow.powerProfilePdf.basedOn": "Assessment based on: {source}",
  "grow.powerProfilePdf.coverage": "{source}: {measured}/{total}",
  "grow.powerProfilePdf.details": "Power details",
  "grow.powerProfilePdf.download": "Download PDF",
  "grow.powerProfilePdf.downloadFailed": "Download failed.",
  "grow.powerProfilePdf.exportTitle": "Export Power Profile",
  "grow.powerProfilePdf.fileNamePrefix": "Power-Profile",
  "grow.powerProfilePdf.footer": "Power levels (0–100) describe your current Power Profile: Self-assessment from your own answers, Smart Analysis as an AI reading of your documents, Combined as the mean of both. Based on the Power Matrix v26.2. Not a validated aptitude test.",
  "grow.powerProfilePdf.map": "Power Map",
  "grow.powerProfilePdf.notMeasured": "not measured",
  "grow.powerProfilePdf.previewTitle": "Power Profile PDF preview",
  "grow.powerProfilePdf.sections": "Sections",
  "grow.powerProfilePdf.sources": "Sources",
  "grow.powerProfilePdf.sourceShort.combined": "Comb.",
  "grow.powerProfilePdf.sourceShort.self": "Self",
  "grow.powerProfilePdf.sourceShort.smart": "Smart",
  "grow.powerProfilePdf.title": "Power Profile",
  "grow.powerQuestionnaires.answer": "Answer",
  "grow.powerQuestionnaires.completed": "completed",
  "grow.powerQuestionnaires.empty": "No questionnaires linked to \"{powerName}\" yet.",
  "grow.powerQuestionnaires.heading": "Questionnaires",
  "grow.powerQuestionnaires.loading": "loading…",
  "grow.powerQuestionnaires.repeat": "Repeat",
  "grow.questionnaire.eyebrow": "Grow · Questionnaire",
  "grow.questionnaire.fallbackName": "Questionnaire",
  "grow.questionnaire.noQuestions": "No questions in this questionnaire.",
  "grow.questionnaire.questionLabel": "Question {position}",
  "grow.questionnaire.submit": "Submit",
  "grow.questionnaire.unknownElement": "Unknown element",
  "grow.title": "Grow",
  "grow.unknownElement": "Unknown element",
  "grow.watch.contentCount": "{count} content items",
  "grow.watch.emptyContent": "No content available yet. As soon as videos, podcasts or scripts exist, they will appear here.",
  "grow.watch.filterAll": "All",
  "grow.watch.intro": "Content to consume around your powers: videos, podcasts and scripts. Sit down, watch, listen and read up.",
  "grow.watch.loadingContent": "Content is loading …",
  "grow.watch.title": "Watch",
  "grow.watch.tour.content.desc": "{count} content items, each tagged with its power and cluster. Click a card to consume it.",
  "grow.watch.tour.content.emptyDesc": "No content is available yet. As soon as videos, podcasts or scripts exist, they will appear here as cards you can open.",
  "grow.watch.tour.content.title": "The catalogue",
  "grow.watch.tour.emptySummary": "This is Watch: learning content around your powers as videos, podcasts and scripts. Right now there is nothing here yet.",
  "grow.watch.tour.filters.desc": "Narrow the catalogue by format (videos, podcasts or scripts), or pick All for everything.",
  "grow.watch.tour.filters.title": "Content filter",
  "grow.watch.tour.label": "Grow Watch",
  "grow.watch.tour.summary": "This is Watch: learning content around your powers as videos, podcasts and scripts. Right now there are {count} items here.",
  "home.allAssessmentsDone": "all statements rated",
  "home.allMatches": "All matches ↗",
  "home.candidatesCount": "{count, plural, one {# candidate} other {# candidates}}",
  "home.carouselNext": "Next",
  "home.carouselPrevious": "Previous",
  "home.carouselSlide": "Slide {number}",
  "home.certificate": "Certificate",
  "home.communitiesSub": "{count, plural, one {# community} other {# communities}}",
  "home.community": "Community",
  "home.contacts": "Contacts",
  "home.continueQuiz": "Continue quiz",
  "home.documents": "Documents",
  "home.education": "Education",
  "home.entries": "entries",
  "home.greeting": "Glad you're here.",
  "home.inComparison": "In comparison · Community",
  "home.lastVisitor": "last: {name}",
  "home.myPosts": "My posts ↗",
  "home.noCommunity": "No community yet.",
  "home.noContacts": "no contacts yet",
  "home.noMatches": "No matches",
  "home.noOwnPosts": "No posts of your own yet",
  "home.noOwnPostsHint": "create a project or a post",
  "home.noQuizYet": "no quiz available yet",
  "home.noVisitsYet": "no views yet",
  "home.notRatedYet": "not rated yet",
  "home.openProfileOf": "Open {name}",
  "home.profile": "Profile",
  "home.profileEmpty": "nothing recorded yet",
  "home.profileFallback": "Profile",
  "home.profileVisitors": "Profile visitors",
  "home.ratePowers": "Rate your powers",
  "home.reviewQuiz": "Review quiz",
  "home.roomToGrow": "Room to grow",
  "home.service": "Documents",
  "home.serviceEmpty": "nothing filed yet",
  "home.strengths": "Strengths",
  "home.tour.grow.desc": "How far Power Quiz and Power Journey are, your strongest powers, and what is still open.",
  "home.tour.grow.title": "Grow",
  "home.tour.label": "Home",
  "home.tour.match.desc": "Your matches. Click one to continue where you left off.",
  "home.tour.match.title": "Match",
  "home.tour.save.desc": "Your profile entries, documents, contacts and pins, with quick actions to add new ones.",
  "home.tour.save.title": "Save",
  "home.tour.share.desc": "Your posts and projects and what is happening around them.",
  "home.tour.share.title": "Share",
  "home.tour.summary": "This is the main page: the latest numbers from every section at a glance. Every tile links to its spot in the app.",
  "home.unnamedMatch": "Unnamed match",
  "home.upNext": "Up next",
  "home.upNextFirst": "next: {name}",
  "home.uploadFile": "Upload file",
  "home.viewAll": "View all ↗",
  "home.viewCommunities": "Show communities",
  "home.viewResult": "View result",
  "home.viewRoomToGrow": "Show room to grow",
  "home.viewStrengths": "Show strengths",
  "home.welcomeDialog.acknowledge": "Got it",
  "home.welcomeDialog.acknowledgeIn": "Got it ({seconds})",
  "home.welcomeDialog.title": "Welcome",
  "home.welcomeHint.dismiss": "Dismiss",
  "home.workExperience": "Work experience",
  "invite.conflict": "This address already has access, so no invitation was sent.",
  "invite.created": "Invitation sent.",
  "invite.emailLabel": "Email address",
  "invite.emailPlaceholder": "name@partner.example",
  "invite.eyebrow": "Access · Invitation",
  "invite.heading": "Invite an external person",
  "invite.intro": "They receive an access link valid for 72 hours and set their own password. The link works once and only for this address.",
  "invite.invalidEmail": "Please enter a valid email address.",
  "invite.resent": "This person had already been invited. The access link was sent again.",
  "invite.sending": "Sending…",
  "invite.submit": "Send invitation",
  "likert.1": "Does not apply",
  "likert.2": "Rather does not apply",
  "likert.3": "Partly",
  "likert.4": "Rather applies",
  "likert.5": "Fully applies",
  "linkedin.error.authorize_denied": "LinkedIn authorization was cancelled.",
  "linkedin.error.cancelled": "You cancelled the LinkedIn connection. You can connect again whenever you're ready.",
  "linkedin.error.import_failed": "The import failed. Please try again later.",
  "linkedin.error.not_configured": "LinkedIn import is not configured. Contact your administrator.",
  "linkedin.error.reconnect": "Your LinkedIn session expired or access wasn't complete. Please reconnect.",
  "linkedin.error.snapshotNotReady": "LinkedIn hasn't returned any data yet. Most likely your data export isn't ready: we requested it through the LinkedIn import just now, and LinkedIn can take up to 10 minutes to prepare it. Try again shortly or come back later.",
  "linkedin.error.stillImporting": "Your import is taking longer than expected. It's still running – refresh this page in a moment to see the result.",
  "linkedin.error.temporary": "LinkedIn didn't respond in time. Please try again in a moment.",
  "linkedin.error.unavailable": "LinkedIn import isn't available right now. Please contact your administrator.",
  "linkedin.error.unexpected": "Something went wrong during the import. Please try again later.",
  "linkedin.import.abort": "Abort import",
  "linkedin.import.abortTip": "Still importing – you can keep waiting, or abort and start the import over from the beginning. Nothing has been saved yet.",
  "linkedin.import.alreadyUpToDate": "Everything LinkedIn could add is already in your profile.",
  "linkedin.import.close": "Close",
  "linkedin.import.comeBackLater": "Come back later",
  "linkedin.import.connect": "Connect LinkedIn",
  "linkedin.import.dialogTitle": "LinkedIn import",
  "linkedin.import.elapsed": "Elapsed time: {time}",
  "linkedin.import.field.bio": "Bio",
  "linkedin.import.field.currentEmployer": "Current employer",
  "linkedin.import.field.dateOfBirth": "Date of birth",
  "linkedin.import.field.degree": "Degree",
  "linkedin.import.field.description": "Description",
  "linkedin.import.field.email": "Email",
  "linkedin.import.field.employer": "Employer",
  "linkedin.import.field.endDate": "End date",
  "linkedin.import.field.fieldOfStudy": "Field of study",
  "linkedin.import.field.institution": "Institution",
  "linkedin.import.field.issued": "Issued",
  "linkedin.import.field.jobTitle": "Job title",
  "linkedin.import.field.language": "Language",
  "linkedin.import.field.level": "Level",
  "linkedin.import.field.location": "Location",
  "linkedin.import.field.name": "Name",
  "linkedin.import.field.period": "Period",
  "linkedin.import.field.phone": "Phone",
  "linkedin.import.field.profession": "Profession",
  "linkedin.import.field.skill": "Skill",
  "linkedin.import.field.startDate": "Start date",
  "linkedin.import.field.street": "Street",
  "linkedin.import.field.title": "Title",
  "linkedin.import.field.zipCode": "Zip code",
  "linkedin.import.importing": "Importing your LinkedIn data – this can take up to a minute…",
  "linkedin.import.intro": "Connect your LinkedIn account to import your profile, positions and skills. You'll review what to keep or replace before anything is saved.",
  "linkedin.import.loadingResult": "Finishing import…",
  "linkedin.import.openingReview": "Opening your profile to review the changes…",
  "linkedin.import.regionBlocked": "LinkedIn only allows this consent for members in the European Economic Area. You can fill your profile from a CV instead – upload it under Service and we will extract your positions and skills.",
  "linkedin.import.regionBlockedTitle": "The LinkedIn import only works inside the EEA",
  "linkedin.import.regionExplain": "LinkedIn only hands profile data to other applications for members in the European Economic Area (the EU plus Iceland, Liechtenstein and Norway). This follows from the EU Digital Markets Act. Switzerland and the United Kingdom are not part of it.",
  "linkedin.import.regionNo": "No, outside the EEA",
  "linkedin.import.regionQuestion": "Do you live in the European Economic Area?",
  "linkedin.import.regionYes": "Yes, in the EEA",
  "linkedin.import.retry": "Try again",
  "linkedin.import.retryIn": "Try again ({time})",
  "linkedin.import.warning.certificateInvalidName": "A certificate was skipped because its name was invalid.",
  "linkedin.import.warning.certificateNameDefaulted": "A certificate had no name and was imported with a placeholder.",
  "linkedin.import.warning.educationInvalidStartDate": "An education entry was skipped because its start date was invalid.",
  "linkedin.import.warning.educationMissingFieldOfStudyAndDegree": "An education entry was skipped because it had no field of study or degree.",
  "linkedin.import.warning.educationStartDateDefaulted": "An education entry had no start date and was set to the current month.",
  "linkedin.import.warning.experienceInvalidJobTitle": "A position was skipped because its job title was invalid.",
  "linkedin.import.warning.experienceInvalidStartDate": "A position was skipped because its start date was invalid.",
  "linkedin.import.warning.experienceJobTitleDefaulted": "A position had no job title and was imported with a placeholder.",
  "linkedin.import.warning.experienceStartDateDefaulted": "A position had no start date and was set to the current month.",
  "linkedin.import.warning.languageMissingName": "A language was skipped because it had no name.",
  "linkedin.import.warning.languageTagTooLong": "A language was skipped because its name was too long.",
  "linkedin.import.warning.languageUnrecognizedName": "A language was skipped because its name wasn't recognized.",
  "linkedin.import.warning.languageUnrecognizedProficiency": "A language's proficiency level wasn't recognized.",
  "loginAssignment.action.invite": "Invite",
  "loginAssignment.action.pending": "Earlier invitation unresolved",
  "loginAssignment.dialog.emailLabel": "Recipient",
  "loginAssignment.dialog.eyebrow": "Access · Login assignment",
  "loginAssignment.dialog.inviteHeading": "Give this person a login",
  "loginAssignment.dialog.inviteSubmit": "Invite to this address",
  "loginAssignment.dialog.noSuggestionHint": "No usable address is stored for this person. Enter the one the invitation should go to.",
  "loginAssignment.dialog.resendSubmit": "Resend to this address",
  "loginAssignment.dialog.suggestionHint": "Prefilled from the profile. Check it: an imported address may be provisional.",
  "loginAssignment.dialog.target": "The login is bound to {name}. Their profile, notes and contacts stay exactly where they are.",
  "loginAssignment.empty": "Everybody has a login.",
  "loginAssignment.emptySearch": "No person without a login matches the search.",
  "loginAssignment.showAssignedResults": "Show matches under “With login”",
  "loginAssignment.showUnassignedResults": "Show matches under “Without login”",
  "loginAssignment.intro": "Assign logins to existing profiles and see whether a sign-in has been recorded.",
  "loginAssignment.loading": "Loading…",
  "loginAssignment.noEmail": "No email on file",
  "loginAssignment.openProfile": "Open profile of {name}",
  "loginAssignment.outcome.accountChanged": "The account changed in the meantime. Nothing was sent; check the status and try again.",
  "loginAssignment.outcome.alreadyAssigned": "This person already has a login. Nothing was changed or sent.",
  "loginAssignment.outcome.createUncertain": "The outcome is unclear: an account may or may not have been created, and nothing was sent. Check this person in Keycloak before trying again.",
  "loginAssignment.outcome.emailConflict": "Another account already uses this address. Nothing was changed; pick a different address.",
  "loginAssignment.outcome.invited": "Done. The login is bound to this person and the invitation is on its way.",
  "loginAssignment.outcome.recipientUpdated": "The address was corrected and the invitation sent to the new one.",
  "loginAssignment.outcome.resent": "The invitation was sent again to the same address.",
  "loginAssignment.outcome.sendFailed": "The mail was refused and not delivered. The login stays bound, so sending again is safe.",
  "loginAssignment.outcome.sendUncertain": "The login is bound, but whether the mail went out is unclear. It may have arrived, so do not send it again.",
  "loginAssignment.searchLabel": "Search by name or address",
  "loginAssignment.searchPlaceholder": "Name or address",
  "loginAssignment.view": "Login assignment view",
  "loginAssignment.withoutLogin": "Without login",
  "loginAssignment.withLogin": "With login",
  "loginAssignment.trackingHint": "Sign-ins are recorded since this feature was introduced. Earlier sign-ins are not included.",
  "loginAssignment.firstAuthenticatedAt": "First recorded sign-in on {date} at {time}",
  "loginAssignment.noAuthentication": "No sign-in recorded yet",
  "loginAssignment.emptyAssignedSearch": "No person with a login matches the search.",
  "loginAssignment.emptyAssigned": "No logins have been assigned yet.",
  "loginAssignment.title": "Login assignment",
  "match.addDocumentsAriaLabel": "Add documents",
  "match.agent.add": "Add",
  "match.agent.added": "Added",
  "match.agent.browse": "Choose agents",
  "match.agent.catalogueEmpty": "No AI agents have been created yet.",
  "match.agent.catalogueEmptyAdmin": "Create them in master data",
  "match.agent.catalogueTitle": "Available agents",
  "match.agent.covers": "Covers",
  "match.agent.guardrails": "Guardrails",
  "match.agent.integrations": "Integrations",
  "match.agent.loadMoreFailed": "The next agents could not be loaded.",
  "match.agent.none": "No agents recorded yet.",
  "match.agent.noneShort": "none",
  "match.agent.recommend": "Recommend agents",
  "match.agent.recommendContext": "Answer the question using the following information. Name two to four agents, each with a one-sentence reason, and say how the requirements for the human team members change as a result. Agents are project context and never team members. You cannot store the selection yourself and have no tool for it: name the agents, I will record them.\n\nProject:\n{project}\n\nAlready recorded: {selected}\n\nAvailable agents:\n{catalogue}",
  "match.agent.recommendHint": "Opens the assistant, which suggests fitting agents from your description.",
  "match.agent.recommendPrompt": "Which AI agents fit this project?",
  "match.agent.remove": "Remove {name}",
  "match.agent.searchCount": "{count, plural, one {# agent} other {# agents}}",
  "match.agent.searchCountMore": "{count}+ agents",
  "match.agent.searchLabel": "Search agents",
  "match.agent.searchPlaceholder": "Name, role, tool …",
  "match.agent.tools": "Tools",
  "match.agenticAi": "Agentic AI",
  "match.agenticAiBoxDesc": "Name the AI agents the team works with. The requirements are derived to fit them, so the team is ready to work alongside them.",
  "match.agenticAiOff": "Agentic AI off",
  "match.agenticAiOn": "Agentic AI on",
  "match.challenge.aiAssist": "AI assistance",
  "match.challenge.aiAssistHint": "AI considers the whole profile and judges whether requirements are met even without explicit evidence. It also writes an assessment with a score for every person.",
  "match.challenge.aiAssistHintReduced": "AI considers the whole profile and judges whether requirements are met even without explicit evidence.",
  "match.challenge.aiDeriveHint": "Opens the assistant to suggest requirements from your brief.",
  "match.challenge.aiBriefRequiredHint": "Add a title and description first.",
  "match.challenge.aiFillFirstHint": "Add a description first.",
  "match.challenge.assessmentDetail": "Level of detail",
  "match.challenge.assessmentDetailBullets": "Bullet points",
  "match.challenge.assessmentDetailBulletsDescription": "Compact points separated by line breaks.",
  "match.challenge.assessmentDetailInfo": "Explain level of detail",
  "match.challenge.assessmentDetailLongText": "Long text",
  "match.challenge.assessmentDetailLongTextDescription": "Detailed reasoning with concrete evidence.",
  "match.challenge.assessmentDetailSentences": "Sentences",
  "match.challenge.assessmentDetailSentencesDescription": "Short, complete sentences.",
  "match.challenge.assessmentOutcomeBalanced": "Balanced",
  "match.challenge.assessmentOutcomeBalancedDescription": "Strengths, risks, and open questions are weighted equally in the overall assessment.",
  "match.challenge.assessmentOutcomeFocus": "Outcome focus",
  "match.challenge.assessmentOutcomeFocusInfo": "Explain outcome focus",
  "match.challenge.assessmentOutcomeOpportunities": "Opportunities",
  "match.challenge.assessmentOutcomeOpportunitiesDescription": "Strengths, transferable capabilities, and realistic opportunities are weighted more heavily and shown first.",
  "match.challenge.assessmentOutcomeRisks": "Risks",
  "match.challenge.assessmentOutcomeRisksDescription": "Risks, missing evidence, and open questions are weighted more heavily and shown first.",
  "match.challenge.assessmentStrictness": "Evaluation strictness",
  "match.challenge.assessmentStrictnessExtreme": "Extreme",
  "match.challenge.assessmentStrictnessExtremeDescription": "Only explicit, role-relevant evidence carries strong weight; uncertainties materially limit the result.",
  "match.challenge.assessmentStrictnessInfo": "Explain evaluation strictness",
  "match.challenge.assessmentStrictnessNormal": "Normal",
  "match.challenge.assessmentStrictnessNormalDescription": "The three AI perspectives assess evidence and uncertainty with normal strictness.",
  "match.challenge.assessmentStrictnessStrict": "Strict",
  "match.challenge.assessmentStrictnessStrictDescription": "Unclear or merely implied experience is rated more cautiously within the scoring band.",
  "match.challenge.enterTitle": "Enter title",
  "match.challenge.generateCompanyRequirementsPrompt": "Suggest suitable company requirements (industry, company size and skills) from the title, short and detailed description.",
  "match.challenge.generateRequirementsPrompt": "Suggest suitable requirements from the title, short and detailed description.",
  "match.challenge.generateWithAi": "Generate for me",
  "match.challenge.hrPromptLabel": "Assessment style",
  "match.challenge.interview.invite": "Not sure what to write? Let the assistant interview you.",
  "match.challenge.interview.refine": "Refine with an interview",
  "match.challenge.interview.seed": "Interview me about this project so we get a good project description.",
  "match.challenge.linkBtn": "Link",
  "match.challenge.linkProjectTitle": "Link project to an existing Share item",
  "match.challenge.matchContext": "Match context",
  "match.challenge.noFilesYet": "No files yet.",
  "match.challenge.openLinkedShare": "Open linked Share item",
  "match.challenge.projectTitleLabel": "Project title",
  "match.challenge.publishBtn": "Create as project",
  "match.company.requirementLeniencyLenientDescription": "For required and optional criteria, the AI also considers the About us text.",
  "match.company.requirementLeniencyMustStrictDescription": "Required criteria use skills only; for optional criteria, the AI also considers the About us text.",
  "match.company.requirementLeniencyStrictDescription": "Required and optional criteria use skills only. The About us text is not considered.",
  "match.challenge.requirementLeniency": "Requirement check",
  "match.challenge.requirementLeniencyInfo": "Explain requirement check",
  "match.challenge.requirementLeniencyLenient": "Lenient",
  "match.challenge.requirementLeniencyLenientDescription": "The required level is a guideline: having the skill suffices.",
  "match.challenge.requirementLeniencyMustStrict": "Lenient for optional",
  "match.challenge.requirementLeniencyMustStrictDescription": "Must criteria have to reach the level, presence suffices for optional ones.",
  "match.challenge.requirementLeniencyStrict": "Strict for both",
  "match.challenge.requirementLeniencyStrictDescription": "Must and optional criteria have to reach the required level.",
  "match.challenge.requirements": "Requirements",
  "match.challenge.requirementsCompanyInfo": "Assessed against the details in the company profile.",
  "match.challenge.requirementsSharedInfo": "Only profile information that candidates have shared is taken into account.",
  "match.challenge.roleTitleLabel": "Role title",
  "match.challenge.unlink": "Unlink",
  "match.challenge.unlinkTitle": "Unlink from Share item",
  "match.challenge.unnamedSharedItem": "Unnamed Share item",
  "match.charsCount": "{count} characters",
  "match.company.addEmployeeCount": "Size",
  "match.company.addExpertise": "Skill",
  "match.company.aiOffMeaning": "Switched off, only a literal match counts; everything else cannot be assessed.",
  "match.company.aiScope": "The AI judges skills only, nothing else. Industry and employee count are compared, not judged.",
  "match.company.aiUnassessable": "What it cannot judge counts as cannot be assessed, never as not met.",
  "match.company.atLeast": "at least",
  "match.company.employeesTitle": "Company size",
  "match.company.employeesUnit": "employees",
  "match.company.expertiseTitle": "Skill",
  "match.company.industryTitle": "Industry",
  "match.companyPool.addAllFound": "Add all {count, number}",
  "match.companyPool.addCapped": "{count, number} companies were added – no more fit into the pool.",
  "match.companyPool.addSearchCapped": "{count, number} companies were added – the search has more matches than a match can hold ({max, number}).",
  "match.companyPool.addUpTo": "Add up to {count, number}",
  "match.companyPool.collectFailed": "The matches could not be loaded. Please try again.",
  "match.companyPool.added": "In the pool",
  "match.companyPool.employeesValue": "{count, number} employees",
  "match.companyPool.empty": "No companies yet – add them on the left via search and industry.",
  "match.companyPool.error.full": "A match holds at most {max, number} companies. Remove one to add another.",
  "match.companyPool.finderTitle": "Company finder",
  "match.companyPool.fullNotice": "The pool is full at {max, number} companies.",
  "match.companyPool.inactive": "inactive",
  "match.companyPool.industryFilter": "Pre-filter by industry …",
  "match.companyPool.industryFilterHint": "Industry is both: a criterion of the evaluation and a pre-filter for the pool.",
  "match.companyPool.intro": "Search for companies and add them to this match's pool. Each company is evaluated on its own against the criteria from the Challenge step.",
  "match.companyPool.noCriteriaYet": "This match has no company requirements yet. The ranking will then carry no evidence.",
  "match.companyPool.noIndustry": "no industry",
  "match.companyPool.noneFound": "No companies found",
  "match.companyPool.poolTitle": "Company pool",
  "match.companyPool.readFailed": "The company pool could not be loaded.",
  "match.companyPool.readOnly": "You can only view this pool. Adding and removing companies needs write access on this match.",
  "match.companyPool.searchLabel": "Search companies",
  "match.companyPool.searchPlaceholder": "Name, skill, industry …",
  "match.companyPool.takeIndustriesFromCriteria": "Take industries from the criteria",
  "match.companyPool.unknownIndustry": "unknown industry",
  "match.companyRanking.actualJudgedByAi": "judged by AI",
  "match.companyRanking.actualNotRecorded": "not recorded by the run",
  "match.companyRanking.actualValue": "Actual: {value}",
  "match.companyRanking.aiCeilingExceeded": "This ranking needs more AI judgements than one run may make. Reduce the skill criteria, or ask an administrator to raise the limit.",
  "match.companyRanking.bandsAreDerived": "The A/B/C bands are derived here from the thresholds and are not stored. The position comes from the run and does not change with them.",
  "match.companyRanking.blankExpertiseRefused": "A skill requirement is still empty. Fill it in or remove it, then run again.",
  "match.companyRanking.companiesMeta": "{count, plural, one {# company} other {# companies}}",
  "match.companyRanking.criteriaCompleteRow": "Requirements complete",
  "match.companyRanking.criteriaIncomplete": "{count, plural, one {# requirement is incomplete} other {# requirements are incomplete}} – fill it in or remove it in the Requirements step, then you can rank.",
  "match.companyRanking.criteriaMeta": "{count, plural, one {# requirement} other {# requirements}}",
  "match.companyRanking.empty": "This match's pool is empty – there is nothing to rank.",
  "match.companyRanking.historicalValueNote": "The actual values show the companies as they are today. The run judged them as they were at the time.",
  "match.companyRanking.must": "Must",
  "match.companyRanking.needPool": "Add at least one company to the pool in the Companies step – without a pool there is nothing to rank.",
  "match.companyRanking.noCriteria": "This match has no company requirements.",
  "match.companyRanking.noCriteriaWarning": "Without company requirements the ranking carries no evidence: every company then holds the same empty result.",
  "match.companyRanking.noMatchingExpertise": "no matching skill",
  "match.companyRanking.noMustHint": "Companies end up here when they miss a must criterion or their score falls below the C threshold.",
  "match.companyRanking.noValue": "no value",
  "match.companyRanking.notAssessable": "cannot be assessed",
  "match.companyRanking.notAssessableTab": "Cannot be assessed ({count})",
  "match.companyRanking.openCompany": "Open {name}",
  "match.companyRanking.optional": "Optional",
  "match.companyRanking.otherCriterion": "Other criterion",
  "match.companyRanking.poolLoadedRow": "Companies loaded",
  "match.companyRanking.preRunHeading": "Evaluate every company in the pool on its own against your requirements and get a ranked list.",
  "match.companyRanking.readFailed": "The ranked list could not be loaded.",
  "match.companyRanking.recommendAi": "Manually review {count} AI reasons across {companies} companies.",
  "match.companyRanking.recommendBottleneck": "{criterion} is the biggest bottleneck; avg. fulfilment {average}.",
  "match.companyRanking.recommendData": "Maintain company data for {criterion}; {missing}/{total} values are missing.",
  "match.companyRanking.recommendMust": "Review or relax {criterion}; this must criterion excludes {failed}/{total} companies.",
  "match.companyRanking.recommendNone": "No immediate adjustment needed.",
  "match.companyRanking.reviewHint": "Companies end up here when a criterion could not be assessed, for example a skill the company does not list. They have not failed, they need a look.",
  "match.companyRanking.run": "Rank companies",
  "match.companyRanking.runNoRight": "You cannot generate a ranking for this match right now.",
  "match.companyRanking.running": "Ranking companies…",
  "match.companyRanking.topFiveBasis": "Average of optional criteria",
  "match.companyRanking.topFiveScoreLabel": "Score {score} %",
  "match.companyRanking.unassessableMeta": "{count, plural, one {# criterion cannot be assessed} other {# criteria cannot be assessed}}",
  "match.companyRanking.verdictMet": "met",
  "match.companyRanking.verdictPartial": "partly met",
  "match.companyRanking.verdictUnmet": "not met",
  "match.companyReqsSection": "Company requirements",
  "match.detail.error": "Error: {message}",
  "match.detail.invalidUrl": "Invalid match URL.",
  "match.detail.loading": "Loading…",
  "match.detail.notFound": "Match not found.",
  "match.detailedPlaceholder": "Context, outcome, constraints, prior experience, anything else relevant.",
  "match.docs.stillNeeded": "Still needed: {requirements}",
  "match.docs.requiredTitle": "Title",
  "match.docs.requiredDescription": "Description",
  "match.docs.retry": "↻ Retry",
  "match.docs.tooLarge": "Too large (max. {max} MB per file): {names}",
  "match.docs.uploadFailed": "Upload failed.",
  "match.docs.uploading": "Uploading…",
  "match.documents": "Documents",
  "match.editor.reset": "Reset",
  "match.fieldDetailedDesc": "Detailed description",
  "match.fieldShortDesc": "Short description",
  "match.freitext.addJobTitle": "Job title",
  "match.freitext.jobTitlePlaceholder": "e.g. Senior Designer, Lead Engineer",
  "match.freitext.title": "Work Experience",
  "match.group.COMMUNICATION": "Communication",
  "match.group.FUTURE_ORIENTATION": "Future Orientation",
  "match.group.INVENTIVENESS": "Inventiveness",
  "match.group.RESILIENCE": "Resilience",
  "match.group.RESULT_ORIENTATION": "Result Orientation",
  "match.group.TEAM_SPIRIT": "Teamability",
  "match.labelLanguage": "Language",
  "match.landing.body": "Initiate a match, define requirements and let the solver compose people and agentic AI into an optimal team – transparent, weighted, explainable.",
  "match.landing.candidatesCount": "{count} candidates",
  "match.landing.error": "Error: {message}",
  "match.landing.loading": "loading…",
  "match.landing.newMatch": "Create new match ↗",
  "match.landing.noMatches": "No matches",
  "match.landing.noMatchesHint": "… or not signed in",
  "match.landing.resultsCount": "{count} results",
  "match.landing.subtitle": "From the idea of a team{br}to the best team.",
  "match.landing.yourMatches": "Your Matches",
  "match.matchNameLabel": "Match name",
  "match.modal.accessCount": "Access · {count}",
  "match.modal.addPersonPlaceholder": "+ Add person – search by name …",
  "match.modal.chooseShareItem": "Choose Share item",
  "match.modal.fillTitle": "Fill the project from the Share item",
  "match.modal.link": "Link",
  "match.modal.linkOnly": "Link only",
  "match.modal.linkOnlyTitle": "Link without copying contents",
  "match.modal.linkWithShareItem": "Link to Share item",
  "match.modal.linking": "Linking …",
  "match.modal.loadingEllipsis": "loading …",
  "match.modal.matchNotes": "Match notes",
  "match.modal.matchNotesPlaceholder": "Internal notes, context or open questions – not the project description.",
  "match.modal.myShareItems": "My Share items",
  "match.modal.myShareItemsCount": "My Share items · {count}",
  "match.modal.nameNotesAccess": "Name, notes & access",
  "match.modal.noAccessYet": "Nobody has access yet. Add a person below.",
  "match.modal.noHits": "No hits.",
  "match.modal.noWriteRights": "You don't have write access to these match settings.",
  "match.modal.overwriteTitle": "Overwrite project contents with the Share item",
  "match.modal.owner": "Owner",
  "match.modal.ownerCreatedBy": "Owner · created by",
  "match.modal.publishEyebrow": "Create as project",
  "match.modal.publishHint": "The description and documents are copied. The project is linked to this match and then opened.",
  "match.modal.publishNow": "Create as project",
  "match.modal.publishPublishing": "Creating …",
  "match.modal.publishQuestion": "Create a new project from this match?",
  "match.modal.removeLink": "Remove link?",
  "match.modal.roleAdmin": "Admin",
  "match.modal.roleEditor": "Editor",
  "match.modal.roleHintAdmin": "Manage all content + access",
  "match.modal.roleHintEditor": "Edit content",
  "match.modal.roleHintReader": "View only",
  "match.modal.roleReader": "Reader",
  "match.modal.savingEllipsis": "Saving …",
  "match.modal.searchByName": "Search by name …",
  "match.modal.searchingEllipsis": "searching …",
  "match.modal.takeOver": "Take over",
  "match.modal.unlinkAction": "Unlink",
  "match.modal.unlinkBody": "The link to <b>{name}</b> will be removed.",
  "match.modal.unlinkEyebrow": "Unlink",
  "match.modal.unlinkHint": "The copied content (title, description, documents) stays – only the reference to the Share item disappears.",
  "match.modal.unlinking": "Unlinking …",
  "match.modal.unnamedShareItem": "Unnamed Share item",
  "match.modal.visibleToMe": "Visible to me",
  "match.modal.visibleToMeCount": "Visible to me · {count}",
  "match.modePicker.assessOutput": "verdict + gaps",
  "match.modePicker.assessSlogan": "You already have a team in mind and want to see how well it fits and where the gaps are.",
  "match.modePicker.assessTitle": "Assess team",
  "match.modePicker.optimizeOutput": "one team",
  "match.modePicker.optimizeSlogan": "You have a pool of people and need to form the best team for a project or task.",
  "match.modePicker.optimizeTitle": "Optimize team",
  "match.modePicker.outputLabel": "Result",
  "match.modePicker.rankCompaniesOutput": "ranked list",
  "match.modePicker.rankCompaniesSlogan": "You have a need and want companies sorted by who fits best.",
  "match.modePicker.rankCompaniesTitle": "Rank companies",
  "match.modePicker.rankOutput": "ranked list",
  "match.modePicker.rankSlogan": "You're filling an open position and want candidates sorted by who fits best.",
  "match.modePicker.rankTitle": "Rank candidates",
  "match.modePicker.title": "What question should this match answer?",
  "match.new.accessLabel": "Access",
  "match.new.create": "Create",
  "match.new.creating": "Creating …",
  "match.new.defaultName": "New match",
  "match.new.title": "Create a new match",
  "match.noMatchesEmpty": "No matches",
  "match.noPeopleFound": "No people found",
  "match.optChoose": "– choose –",
  "match.people.addAll": "Add all ({count})",
  "match.people.addAllFromSet": "Add all {count} from {name}",
  "match.people.addAllPinned": "Add all {count} pinned",
  "match.people.addInterested": "Add interested people ({count})",
  "match.people.addUpTo": "Add up to {count} matching",
  "match.people.added": "Added",
  "match.people.allPinned": "All pinned",
  "match.people.emptyCandidates": "No candidates yet – add them on the left via search or filters.",
  "match.people.evaluateLocked": "Evaluate this team",
  "match.people.evaluateLockedTitle": "Evaluate this fully-locked team",
  "match.people.finderTitle": "Person Finder",
  "match.people.interestedExplain": "People who showed interest in this project",
  "match.people.intro": "Search and filter people from your company and add them as candidates.",
  "match.people.introLock": "Mark individual people as locked candidates when they must be part of the team.",
  "match.people.lockAsFix": "Mark as fix in team",
  "match.people.personGroups": "Groups",
  "match.people.pinGroups": "Pin groups",
  "match.people.sampleNotice": "Candidate pool contains the first {count} of {total} matching people from the last bulk add.",
  "match.people.sampleNoticeCapped": "Candidate pool contains the first {count} matching people; more matched than could be added at once.",
  "match.people.savedSetsPlaceholder": "Groups & pins …",
  "match.people.searchPlaceholder": "Name, job title …",
  "match.people.selectedCandidates": "Selected Candidates",
  "match.people.unlock": "Unlock",
  "match.placeholderCount": "Count",
  "match.powerScore.edit": "Adjust data basis",
  "match.powerScore.editHint": "Not everyone has both assessments, or a value for every power. These two settings decide which values the run uses and how missing ones count.",
  "match.powerScore.editInfo": "Explain data basis",
  "match.powerScore.missing": "Missing power",
  "match.powerScore.missingNeutral": "counts 50",
  "match.powerScore.missingZero": "counts 0",
  "match.powerScore.source": "Power source",
  "match.preSolve.assessTeam": "Assess team",
  "match.preSolve.assessing": "Assessing team…",
  "match.preSolve.candidatesLoaded": "Candidates loaded",
  "match.preSolve.conditionsComplete": "Criteria complete",
  "match.preSolve.conditionsIncompleteHint": "{n, plural, one {# criterion without a selection (e.g. choose an industry) – complete or remove it} other {# criteria without a selection – complete or remove them}}",
  "match.preSolve.eyebrow": "Ready to solve",
  "match.preSolve.eyebrowAssess": "Ready to assess",
  "match.preSolve.eyebrowRank": "Ready to rank",
  "match.preSolve.fulfillFirst": "Satisfy the requirements above first.",
  "match.preSolve.fullyLockedHint": "All {teamSize} seats are filled by locked members. The Solver will only evaluate this team, not optimize it.",
  "match.preSolve.heading": "Compose an optimal team from your candidate pool.",
  "match.preSolve.headingAssess": "Assess how well your team meets the requirements.",
  "match.preSolve.headingRank": "Rank your candidates by fit to the requirement profile.",
  "match.preSolve.intro": "The Solver distributes your candidates across {teamSize} slots and optimizes against your requirement profile. You can re-run the calculation as often as you like.",
  "match.preSolve.lockedExceedsBody": "{locked} people are locked in, but the team has {teamSize} seats. Unlock some members or raise the team size before solving.",
  "match.preSolve.lockedExceedsHeading": "More people are locked than there are seats.",
  "match.preSolve.noSizeYet": "no size chosen yet",
  "match.preSolve.personsCount": "{n} people",
  "match.preSolve.poolOnly": "{n} in pool",
  "match.preSolve.poolWithLocked": "{n} in pool · {locked} fix",
  "match.preSolve.rankCandidates": "Rank candidates",
  "match.preSolve.ranking": "Ranking…",
  "match.preSolve.solverRunning": "Solver running…",
  "match.preSolve.startSolver": "Start Solver",
  "match.preSolve.teamSizePlaceholder": "n",
  "match.preSolve.teamSizeSet": "Team size set",
  "match.profilesLoadError": "Loading profiles: {message}",
  "match.readOnlyBanner": "You can only view this match. Ask an admin or owner for write access.",
  "match.recruiting.addBranche": "Industry",
  "match.recruiting.addCertificate": "Certificate",
  "match.recruiting.addEducation": "Education",
  "match.recruiting.addSkillHere": "Add skill here",
  "match.recruiting.branchePlaceholder": "Choose industry",
  "match.recruiting.certificatePlaceholder": "e.g. AWS Solutions Architect",
  "match.recruiting.educationDegreeLabel": "Required degree",
  "match.recruiting.educationDegreePlaceholder": "Select degree",
  "match.recruiting.educationLevelInfo.aria": "Explain AI degree evaluation",
  "match.recruiting.educationLevelInfo.body": "Without AI, the selected catalogue entry is compared directly. With AI enabled, the model is instructed to also consider equivalent or clearly higher formal qualifications.",
  "match.recruiting.educationLevelInfo.title": "Degree evaluation",
  "match.recruiting.experienceTitle": "Required work experience",
  "match.recruiting.expertiseTitle": "Required skills (min.)",
  "match.recruiting.kann.tooltip": "Optional criterion: counts toward the fit score. Click to make it a must.",
  "match.recruiting.minYears": "min.",
  "match.recruiting.must.tooltip": "Must criterion: anyone who does not meet it is unqualified. Click to make it optional.",
  "match.recruiting.personCountLabel": "Minimum number of people",
  "match.recruiting.qualificationsTitle": "Education & certificates",
  "match.recruiting.skillPlaceholder": "e.g. wound care",
  "match.recruiting.unrated": "Present",
  "match.recruiting.years": "Years",
  "match.recruiting.yearsUnit": "years",
  "match.removeAll": "Remove all",
  "match.renameLabel": "Rename match",
  "match.requirements.aria.cefrLevel": "Level",
  "match.requirements.aria.composition": "Composition",
  "match.requirements.aria.operator": "Operator",
  "match.requirements.cefr.A1": "A1 – Beginner",
  "match.requirements.cefr.A2": "A2 – Elementary",
  "match.requirements.cefr.B1": "B1 – Intermediate",
  "match.requirements.cefr.B2": "B2 – Upper intermediate",
  "match.requirements.cefr.C1": "C1 – Advanced",
  "match.requirements.cefr.C2": "C2 – Proficient",
  "match.requirements.cefr.NATIVE": "Native",
  "match.requirements.cityRadius": "Radius in kilometres",
  "match.requirements.cityRadiusDial": "Choose radius, drag outwards from the centre",
  "match.requirements.cityRadiusHint": "Drag up to 100 km, enter larger values above",
  "match.requirements.condition.annualSalary": "Annual salary",
  "match.requirements.otherUnchanged": "{count, plural, one {# other requirement stays} other {# other requirements stay}} unchanged.",
  "match.requirements.personDetails": "Person Details",
  "match.pdf.candidateRanking": "Candidate ranking",
  "match.pdf.companyRanking": "Company ranking",
  "match.pdf.assessedMembersShort": "{count} measured",
  "match.pdf.criteria": "Criteria",
  "match.pdf.dataQuality.healthy": "No data quality notes.",
  "match.pdf.dataQuality.noPowers": "No team member has measured Powers in this result.",
  "match.pdf.dataQuality.noRequirements": "No requirements were defined for this result.",
  "match.pdf.dataQuality.unknownRequirements": "Some saved requirements are from a newer client and are counted but not detailed here.",
  "match.pdf.download": "Download PDF",
  "match.pdf.downloadFailed": "Download failed.",
  "match.pdf.exportTitle": "PDF export",
  "match.pdf.exportedAt": "Exported {date}",
  "match.pdf.factSkillScore": "Facts & skills",
  "match.pdf.inactive": "inactive",
  "match.pdf.measuredPowerMembers": "{count} of {total} people with measured Powers",
  "match.pdf.modeUnknown": "Match result",
  "match.pdf.moreRows": "+{count} more",
  "match.pdf.notes": "Notes",
  "match.pdf.openExport": "PDF export",
  "match.pdf.personDetails": "Person details",
  "match.pdf.peopleOrCandidates": "People / candidates",
  "match.pdf.powerFit": "Power fit",
  "match.pdf.powerStructure": "Power structure",
  "match.pdf.powerTarget": "target {target} · {delta}",
  "match.pdf.powers": "Power clusters",
  "match.pdf.powersMatrix": "Powers matrix",
  "match.pdf.previewTitle": "Match result PDF preview",
  "match.pdf.rankCluster.review": "Review",
  "match.pdf.rankCluster.unqualified": "Criteria not met",
  "match.pdf.requirementFit": "Requirement fit",
  "match.pdf.requirementMatrix": "Requirements matrix",
  "match.pdf.requirements": "Requirements",
  "match.pdf.sections": "Sections",
  "match.pdf.settings.dataQuality": "Data quality",
  "match.pdf.settings.matrices": "Detailed matrices",
  "match.pdf.settings.notes": "Notes",
  "match.pdf.settings.powers": "Power clusters",
  "match.pdf.settings.powerDetail": "Power structure",
  "match.pdf.settings.ranking": "Ranking",
  "match.pdf.settings.requirements": "Requirements",
  "match.pdf.settings.summary": "Summary",
  "match.pdf.settings.team": "Team",
  "match.pdf.summary": "Match analysis",
  "match.pdf.team": "Team",
  "match.pdf.unknownCriteria": "Unknown criteria",
  "match.pdf.rank.band": "Band",
  "match.pdf.rank.candidate": "Candidate",
  "match.pdf.rank.candidateDetail": "Candidate detail",
  "match.pdf.rank.criteriaMatrix": "Criteria matrix",
  "match.pdf.rank.dataQuality": "Data quality: {missing} of {expected} evidence values missing",
  "match.pdf.rank.fromThreshold": "from {value}",
  "match.pdf.rank.poolSplit": "{total} candidates · A {a} · B {b} · C {c} · {review} to review · {unqualified} criteria not met",
  "match.pdf.rank.roleRequirements": "Role requirements",
  "match.pdf.rank.criterion": "Criterion",
  "match.pdf.rank.poolDistribution": "Distribution across the pool",
  "match.pdf.rank.companyDetail": "Company detail",
  "match.pdf.rank.poolSplitCompanies": "{total} companies · A {a} · B {b} · C {c} · {review} to review · {unqualified} criteria not met",
  "match.pdf.rank.candidates": "Candidates",
  "match.pdf.rank.notIncluded": "{count, plural, one {# candidate not included} other {# candidates not included}}",
  "match.pdf.rank.selectAll": "Select all",
  "match.result.adjustRequirements": "Adjust requirements",
  "match.result.adjustTeamSize": "Team size",
  "match.result.age": "Age",
  "match.result.ageRange": "{min}–{max} yrs",
  "match.result.ageRangeAverage": "{min}–{max} yrs (avg {average})",
  "match.result.ageSingle": "{age} yrs",
  "match.result.agentsIntro": "The AI agents this project works with. They are context, not team members: the team above is people only.",
  "match.result.agentsTitle": "Agents",
  "match.result.analysis.carriersClose": "Close: {names}",
  "match.result.analysis.carriersMet": "Met by: {names}",
  "match.result.analysis.carriersNone": "Nobody in the team meets this.",
  "match.result.analysis.donutFulfilled": "met",
  "match.result.analysis.extraSkills": "Strong in the team, not requested: {skills}",
  "match.result.analysis.fulfilment": "Fulfilment",
  "match.result.analysis.gaps": "Gaps",
  "match.result.analysis.metOfTotal": "{met}/{total} met",
  "match.result.analysis.moreRows": "+{count} more",
  "match.result.analysis.noStrengths": "Nothing met yet.",
  "match.result.analysis.recAllMet": "All requirements met.",
  "match.result.analysis.rowClose": "{n} close",
  "match.result.analysis.rowCompositionAll": "everyone in the team",
  "match.result.analysis.rowCompositionExact": "exactly {n} in the team",
  "match.result.analysis.rowCompositionMax": "max. {n} in the team",
  "match.result.analysis.rowCompositionMin": "min. {n} in the team",
  "match.result.analysis.rowMetOf": "{met} of {total}",
  "match.result.analysis.rowToggleAria": "Show who covers {label}",
  "match.result.analysis.soleCarrier": "only {name}",
  "match.result.analysis.strengths": "Strengths",
  "match.result.backToSelection": "← Close",
  "match.result.candidatesMeta": "{count, plural, one {# candidate} other {# candidates}}",
  "match.result.condition.age": "Age",
  "match.result.condition.annualSalary": "Salary",
  "match.result.condition.certificate": "Certificate",
  "match.result.condition.children": "Children",
  "match.result.condition.citizenship": "Citizenship",
  "match.result.condition.city": "Place of residence",
  "match.result.condition.country": "Country",
  "match.result.condition.department": "Department",
  "match.result.condition.driversLicense": "Driver's license",
  "match.result.condition.education": "Education",
  "match.result.condition.exact": "{label}: {value}",
  "match.result.condition.exactNot": "{label}: not {value}",
  "match.result.condition.experience": "Experience",
  "match.result.condition.expertise": "Skill",
  "match.result.condition.gender": "Gender",
  "match.result.condition.industry": "Industry",
  "match.result.condition.language": "Language",
  "match.result.condition.location": "Work location",
  "match.result.condition.maritalStatus": "Marital status",
  "match.result.condition.nationality": "Nationality",
  "match.result.condition.present": "{label}: Present",
  "match.result.condition.presentActual": "Present",
  "match.result.condition.threshold": "{label}: {word} {value}",
  "match.result.condition.thresholdExact": "exactly",
  "match.result.condition.thresholdMax": "max.",
  "match.result.condition.thresholdMin": "min.",
  "match.result.condition.thresholdNot": "not",
  "match.result.dataHint": "Data note",
  "match.result.deleteAriaLabel": "Delete result “{name}”",
  "match.result.deleteConfirmBody": "The saved result <b>“{name}”</b> will be permanently removed. This action cannot be undone.",
  "match.result.deleteConfirmTitle": "Delete result?",
  "match.result.deleteFinal": "Delete permanently",
  "match.result.deleteTitle": "Delete",
  "match.result.deleting": "Deleting…",
  "match.result.dept": "Dept",
  "match.result.detailsHeader": "Details",
  "match.result.discardUnsavedConfirm.confirm": "Discard",
  "match.result.discardUnsavedConfirm.message": "The computed result hasn't been saved yet and will be lost when you go back.",
  "match.result.discardUnsavedConfirm.title": "Discard unsaved result?",
  "match.result.elementRequirementsFulfilled": "Element Requirements · {count} fulfilled",
  "match.result.emptyHint": "No data in the result.",
  "match.result.facts.aiMark": "AI",
  "match.result.facts.leniencyDependent": "{count, plural, one {# requirement only counts as fulfilled under lenient checking} other {# requirements only count as fulfilled under lenient checking}}: the skill is there, the required level is not evidenced.",
  "match.result.facts.lenientMark": "Lenient",
  "match.result.facts.matchedBadge": "Contributes to {met} of {total} requirements",
  "match.result.facts.mustViolated": "{count, plural, one {# must criterion is not met} other {# must criteria are not met}}.",
  "match.result.factsAndSkills": "Requirements matrix",
  "match.result.gender": "Gender",
  "match.result.groupBasics": "Basics",
  "match.result.groupExpertise": "Expertise",
  "match.result.groupTotal": "Total",
  "match.result.hintNoConditionsBody": "This match has no requirements in the Challenge step – so the match analysis and the requirements matrix stay empty. Define conditions to see how the team fulfils them.",
  "match.result.hintNoConditionsLabel": "No requirements defined",
  "match.result.hintNoDemographicsBody": "The people have no birth dates and no gender on file. Department, gender and age below the team therefore stay hidden.",
  "match.result.hintNoDemographicsLabel": "No demographic data",
  "match.result.hintNoPowersBody": "The selected people have not self-assessed their powers. All powers panels therefore stay at zero. As soon as they maintain powers in their profile, the result fills in automatically.",
  "match.result.hintNoPowersLabel": "No power self-assessments",
  "match.result.historyLoading": "Saved results loading …",
  "match.result.historyTitle": "Saved results",
  "match.result.infeasibleBody": "The conditions contradict each other or your candidate pool is too small. Remove hard filters or enlarge the pool, then start the Solver again.",
  "match.result.infeasibleHeading": "The Solver couldn't compose a team that satisfies all requirements.",
  "match.result.infeasibleLockedBody": "Too many people are locked in, or the locked members already violate a requirement. Unlock some members or raise the team size, then run the Solver again.",
  "match.result.infeasibleLockedHeading": "The locked members alone can't form a valid team.",
  "match.result.infeasibleLockedTitle": "Locked candidates block the solve",
  "match.result.infeasibleMet": "{met} of {target} met",
  "match.result.infeasibleOvershoot": "{over} over the limit of {target}",
  "match.result.infeasibleRelaxTitle": "{count, plural, one {Relax this must criterion} other {Smallest fix: relax all of these must criteria}}",
  "match.result.infeasibleShortfall": "short by {shortfall}",
  "match.result.infeasibleTitle": "No solution found",
  "match.result.insights.aiCriterionSubjects": "{count} {subject}",
  "match.result.insights.aiMetShort": "{count} of them matched via AI",
  "match.result.insights.aiReasons": "{count} AI Reasons",
  "match.result.insights.aiShare": "AI share",
  "match.result.insights.averageShort": "avg {value}",
  "match.result.insights.bottlenecks": "Top 3 bottlenecks",
  "match.result.insights.failCount": "{failed}/{total} excluded",
  "match.result.insights.fulfilledShort": "{met}/{total} fulfilled",
  "match.result.insights.gapShort": "{value} gap",
  "match.result.insights.hardestMust": "Knockout criterion",
  "match.result.insights.header": "Match analysis",
  "match.result.insights.koPassing": "meet it",
  "match.result.insights.medianShort": "median {value}",
  "match.result.insights.noAiReasons": "No AI Reasons.",
  "match.result.insights.noBottleneck": "No notable bottlenecks.",
  "match.result.insights.noExclusion": "No must criterion excludes anyone.",
  "match.result.insights.noFulfilled": "No criterion is fulfilled.",
  "match.result.insights.personDetailsInfoAria": "Show person details note",
  "match.result.insights.personDetailsInfoBody": "Person details are not shown as analysis distributions. They remain visible in the candidate detail.",
  "match.result.insights.personDetailsInfoTitle": "Person details",
  "match.result.insights.radius": "Radius",
  "match.result.insights.radiusHint": "Angle schematic, compressed distance scale",
  "match.result.insights.radiusInside": "{count} inside",
  "match.result.insights.radiusMapAria": "Radius map: candidates by distance to {city}",
  "match.result.insights.radiusMissing": "{count} without distance",
  "match.result.insights.radiusOutside": "{count} outside",
  "match.result.insights.radiusTitle": "{radius} km around {city}",
  "match.result.insights.reasonsShort": "{count} Reasons",
  "match.result.insights.recommendAi": "Manually review {count} AI Reasons across {candidates} candidates.",
  "match.result.insights.recommendBottleneck": "{criterion} is the strongest bottleneck; avg fulfilment {average}.",
  "match.result.insights.recommendData": "Fill profile values for {criterion}; {missing}/{total} evidence values are missing.",
  "match.result.insights.recommendMust": "Review or relax {criterion}; this must criterion excludes {failed}/{total} candidates.",
  "match.result.insights.recommendNone": "No immediate adjustment needed.",
  "match.result.insights.recommendation": "Recommendation",
  "match.result.insights.requiredShort": "target {value}",
  "match.result.insights.sdShort": "SD {value}",
  "match.result.insights.subjectCandidates": "candidates",
  "match.result.insights.subjectCompanies": "companies",
  "match.result.insights.textDistribution": "top value {value} ({count}/{present}) · {distinct} variants",
  "match.result.insights.topFulfilled": "Top 3 fulfilled criteria",
  "match.result.insights.unknownShort": "{count} not assessable",
  "match.result.loadFailed": "Result could not be loaded (id {id}). Check the browser console.",
  "match.result.memberAnchorSole": "{name} (alone)",
  "match.result.memberAnchors": "Carries: {list}",
  "match.result.memberCharacter": "Character",
  "match.result.memberClusterCountInfoAria": "Show explanation of the count and the distance",
  "match.result.memberClusterCountInfoBody": "Count: how many of this person's 5 cluster powers are above {threshold} – a mean of 68 can be five times 68 or one strong power beside four weak ones. Bar: it sits on the team's cluster mean – to the right the person lifts the team here, to the left they sit below it. Last, their own cluster mean.",
  "match.result.memberClusterCountInfoTitle": "Count and distance",
  "match.result.memberCoverage": "{met} of {total}",
  "match.result.memberCoverageVsMedian": "{met} of {total} · team median {median, number}",
  "match.result.memberCriteriaLess": "show fewer",
  "match.result.memberCriteriaMore": "show all {n}",
  "match.result.memberCriterionMet": "met",
  "match.result.memberCriterionOpen": "not met",
  "match.result.memberCriterionPartial": "partially met",
  "match.result.memberCriterionUnrated": "not rateable",
  "match.result.memberCriticalTag": "critical",
  "match.result.memberLenientTag": "lenient",
  "match.result.memberNoPowers": "No power assessment on file. This person counts in none of the team’s power averages – their contribution above rests on the requirements alone.",
  "match.result.memberOpenProfile": "Profile",
  "match.result.memberPowerFit": "Power fit {n}",
  "match.result.memberPowerFitInfoAria": "Show explanation of this person’s power fit",
  "match.result.memberPowerFitInfoBody": "The person's own powers (0–100), weighted by the Powers Scorecard. High means they are strong exactly where the weight sits – independent of how they compare to the team.",
  "match.result.memberPowersRelative": "Powers vs. the team",
  "match.result.memberRequirements": "Requirements",
  "match.result.memberSummaryCritical": "Critical for {list}.",
  "match.result.memberSummaryCriticalMust": "Without this person the must {count, plural, one {criterion} other {criteria}} {list} {count, plural, one {fails} other {fail}}.",
  "match.result.memberSummaryExclusiveSkills": "Only one with {list}{rest, plural, =0 {} other { and # more}} at a strong level.",
  "match.result.memberSummaryNoCoverage": "Meets no requirement – the contribution lies in the powers, not in the specialist criteria.",
  "match.result.memberSummaryNoCoverageNoPowers": "Meets no requirement – and with no power assessment on file, nothing else is known about the contribution.",
  "match.result.memberSummaryTopCoverage": "Covers the most requirements in the team.",
  "match.result.memberSummaryTopPowerFit": "Highest power fit in the team.",
  "match.result.memberWhy": "Why in the team",
  "match.result.memberWhySuited": "Why suitable",
  "match.result.noRequirementsEmpty": "This match definition has no requirements – the requirements matrix stays empty.",
  "match.result.openFlag": "open",
  "match.result.organizationalRecordBadge": "With organisational record",
  "match.result.organizationalRecordBadgeTitle": "Visible to record readers only",
  "match.result.openProfileTitle": "{name} – open profile",
  "match.result.powers.collapseClusterAria": "Collapse {cluster}",
  "match.result.powers.expandClusterAria": "Expand {cluster} – show individual powers",
  "match.result.powers.memberBadge": "Mean of this person's 30 powers (0–100)",
  "match.result.powers.memberBadgeUnmeasured": "No powers data – not counted in any average",
  "match.result.powers.reqBadge": "Contributes to {met} of {total} power requirements",
  "match.result.powersBasis": "Based on {measured} of {total} people",
  "match.result.powersColPower": "Power",
  "match.result.powersColStrong": "strong >{threshold}",
  "match.result.powersColStrongInfo": "How many in the team score above {threshold} on this power.",
  "match.result.powersColWeight": "Weighting",
  "match.result.powersCoverageInfo": "No power assessment is on file for {missing, plural, one {# person} other {# people}} on the team. All power averages and counts run over the remaining {measured} only; who is missing is listed at the end of the Power Scorecard matrix.",
  "match.result.powersCoverageInfoAria": "Show explanation of powers coverage",
  "match.result.powersInTeam": "Powers in the team",
  "match.result.powersListHeader": "Top Powers",
  "match.result.powersScorecardInTeam": "Team vs Powers Scorecard",
  "match.result.powersSortScore": "By team score",
  "match.result.powersSortWish": "By weighting",
  "match.result.radarActual": "Team · raw",
  "match.result.radarActualPerson": "Person · raw",
  "match.result.radarScopeCluster": "Clusters",
  "match.result.radarKeyboardHint": "Powers radar – step through the axes with the arrow keys",
  "match.result.radarScopeElement": "All {count} powers",
  "match.result.radarTarget": "Powers Scorecard",
  "match.result.radarTitleActual": "Actual",
  "match.result.radarTitleUnmeasured": "{count, plural, =0 {nobody on the team assessed} one {only # person assessed} other {only # people assessed}}",
  "match.result.radarTitleUnmeasuredPerson": "not assessed",
  "match.result.radarTitleWish": "Weighting",
  "match.result.ranking.actualInline": "Evidence:",
  "match.result.ranking.aiChip": "AI Reason",
  "match.result.ranking.aiChipTitle": "Reason from the AI evaluation",
  "match.result.ranking.assessment.fazit": "Verdict",
  "match.result.ranking.assessment.interviewQuestions": "Questions for the conversation",
  "match.result.ranking.assessment.negative": "Negative",
  "match.result.ranking.assessment.positive": "Positive",
  "match.result.ranking.assessment.ratingHigh": "Suitable",
  "match.result.ranking.assessment.ratingLow": "Rather unsuitable",
  "match.result.ranking.assessment.ratingMedium": "Partly suitable",
  "match.result.ranking.assessment.ratingVeryHigh": "Highly suitable",
  "match.result.ranking.assessment.ratingVeryLow": "Unsuitable",
  "match.result.ranking.assessment.title": "Smycles assessment",
  "match.result.ranking.collapseAll": "Collapse all",
  "match.result.ranking.criterionFailed": "not met",
  "match.result.ranking.criterionMet": "met",
  "match.result.ranking.dotFulfilled": "Fulfilled",
  "match.result.ranking.dotPartial": "Partially fulfilled",
  "match.result.ranking.dotUnfulfilled": "Not fulfilled",
  "match.result.ranking.dotUnknown": "Needs review",
  "match.result.ranking.emptyFilteredTab": "No {requirement} criteria under “{tab}”.",
  "match.result.ranking.emptyHintLabel": "Note",
  "match.result.ranking.emptyShowAll": "Show all criteria",
  "match.result.ranking.emptySwitchTab": "Switch to “{tab}”",
  "match.result.ranking.emptyTab": "There are no criteria under “{tab}”.",
  "match.result.ranking.expandAll": "Expand all",
  "match.result.ranking.filterAll": "All",
  "match.result.ranking.filterKann": "Optional",
  "match.result.ranking.filterMust": "Must",
  "match.result.ranking.fulfilledTab": "Fulfilled ({count})",
  "match.result.ranking.kannTitle": "Optional criteria",
  "match.result.ranking.kindBasics": "Person Details",
  "match.result.ranking.kindCertificate": "Certificate",
  "match.result.ranking.kindEducation": "Education",
  "match.result.ranking.kindExperience": "Experience",
  "match.result.ranking.kindExpertise": "Skill",
  "match.result.ranking.kindLanguage": "Language",
  "match.result.ranking.kindPowers": "Powers",
  "match.result.ranking.kpiPowerFit": "Power-Fit",
  "match.result.ranking.kpiSmycles": "Smycles Score",
  "match.result.ranking.lenientMatchHint": "Fulfilled via lenient requirement check: skill present, required level not verified.",
  "match.result.ranking.lenientTab": "Leniently fulfilled ({count})",
  "match.result.ranking.must": "Must",
  "match.result.ranking.mustFormula": "Must criteria are hard gates: every one has to be met.",
  "match.result.ranking.mustInfoAria": "Show must criteria",
  "match.result.ranking.mustInfoTitle": "Must criteria",
  "match.result.ranking.mustMetSummary": "Met: {met}/{total}",
  "match.result.ranking.mustNone": "No must criteria",
  "match.result.ranking.mustTitle": "Must criteria",
  "match.result.ranking.noAssessment": "No Smycles assessment available.",
  "match.result.ranking.noCriteria": "No criteria defined",
  "match.result.ranking.noMustHint": "Candidates end up here when they miss a must criterion (lock) or their score falls below the C threshold.",
  "match.result.ranking.notRated": "Present · level not rated",
  "match.result.ranking.openProfile": "Open profile",
  "match.result.ranking.optional": "Optional",
  "match.result.ranking.powerFitClusterCompare": "Clusters compared",
  "match.result.ranking.powerFitClusterCompareExplainer": "This person's cluster values against the average across all candidates in this ranking.",
  "match.result.ranking.powerFitPoolCompareSummary": "{above} of {total} clusters above the average across all candidates",
  "match.result.ranking.powerFitRadarExplainer": "This person's actual profile against the match's Powers Scorecard.",
  "match.result.ranking.powerFitTiltsExplainer": "Where this person sits between the two poles of each axis.",
  "match.result.ranking.powerFitTiltsHeading": "Tilt",
  "match.result.ranking.powerFitTooltip": "Power-Fit: weighted average of this person's own power values.",
  "match.result.ranking.review": "Needs review",
  "match.result.ranking.reviewHint": "Candidates end up here when a criterion could not be assessed, for example a skill without a rated level. They have not failed, they need a look.",
  "match.result.ranking.reviewReasonBoth": "Must and optional not assessable",
  "match.result.ranking.reviewReasonKann": "Optional criteria not assessable",
  "match.result.ranking.reviewReasonMust": "Must criterion not assessable",
  "match.result.ranking.scoreCoverage": "{assessable} of {defined} criteria assessable",
  "match.result.ranking.scoreCriteriaValue": "Optional criteria: {criteria}",
  "match.result.ranking.scoreFormula": "Score = average of the optional (Kann) criteria.",
  "match.result.ranking.scoreInfoAria": "Show score calculation",
  "match.result.ranking.scoreInfoTitle": "Calculation",
  "match.result.ranking.scoreMustGate": "Must criteria remain a hard gate on top.",
  "match.result.ranking.scoreNotAssessable": "Optional criteria: not assessable",
  "match.result.ranking.sortBy": "Sort by",
  "match.result.ranking.sortPower": "Power-Fit",
  "match.result.ranking.sortRequirements": "Requirements-Fit",
  "match.result.ranking.sortSmycles": "Smycles",
  "match.result.ranking.tabNameFulfilled": "Fulfilled",
  "match.result.ranking.tabNameLenient": "Leniently fulfilled",
  "match.result.ranking.tabNameUnfulfilled": "Not fulfilled",
  "match.result.ranking.tabNameUnknown": "Needs review",
  "match.result.ranking.thresholdAAria": "Threshold between A and B",
  "match.result.ranking.thresholdBAria": "Threshold between B and C",
  "match.result.ranking.thresholdCAria": "Lower bound for C",
  "match.result.ranking.thresholdsLabel": "Thresholds",
  "match.result.ranking.toggleEvidence": "Show evidence for {name}",
  "match.result.ranking.unfulfilledTab": "Not fulfilled ({count})",
  "match.result.ranking.unknownTab": "Needs review ({count})",
  "match.result.ranking.unqualified": "Criteria not met",
  "match.result.ranking.yearsValue": "{years, plural, one {# year} other {# years}}",
  "match.result.rankingHeader": "Ranking",
  "match.result.requirementDiagram.axisFulfilled": "Fulfilled ↑",
  "match.result.requirementDiagram.axisUnfulfilled": "Not fulfilled ↓",
  "match.result.requirementDiagram.closeLabel": "Close",
  "match.result.requirementDiagram.noContributors": "Nobody on the team carries this.",
  "match.result.requirementDiagram.personLevel": "Level: {level}",
  "match.result.requirementDiagram.ruleAll": "all",
  "match.result.requirementDiagram.ruleAny": "at least 1",
  "match.result.requirementDiagram.ruleExact": "exactly {n}",
  "match.result.requirementDiagram.ruleExactUnknown": "exactly ?",
  "match.result.requirementDiagram.ruleMax": "at most {n}",
  "match.result.requirementDiagram.ruleMaxUnknown": "at most ?",
  "match.result.requirementDiagram.ruleMin": "at least {n}",
  "match.result.requirementDiagram.ruleMinUnknown": "at least ?",
  "match.result.reviewSubtitle": "Optimized for your requirement profile – transparent, explainable, exportable.",
  "match.result.riskEmptyCluster": "{count, plural, one {# cluster with no carrier} other {# clusters with no carrier}}",
  "match.result.riskSoleRequirement": "{count, plural, one {# requirement rests on one person} other {# requirements rest on one person}}",
  "match.result.riskViolatedMust": "{count, plural, one {# must violated} other {# musts violated}}",
  "match.result.saveResult": "Save result",
  "match.result.savedResultLabel": "Saved result · {name}",
  "match.result.savedSubtitle": "You're viewing a saved result of this Match.",
  "match.result.sectionPicker.header": "Visible sections",
  "match.result.sectionPicker.count": "{visible} of {total}",
  "match.result.sectionPicker.trigger": "Sections",
  "match.result.sectionPicker.toggleAria": "Show {section}",
  "match.result.skillMatrix": "Skills matrix",
  "match.result.skillMatrixFocusSkill": "Skill focus",
  "match.result.skillMatrixFocusTeam": "Team focus",
  "match.result.skillMatrixUnrated": "present, no level rated",
  "match.result.skillMaxLevel": "up to {level}",
  "match.result.skillRequested": "Requirement",
  "match.result.skillStrongHint": "strong from {level}",
  "match.result.skillStrongOfTeam": "{n} of {total} strong",
  "match.result.skillStructureHeader": "Top Skills",
  "match.result.skillTotalAtAll": "{n} at all",
  "match.result.solverErrorBody": "Genesis rejected the calculation. This currently happens when the match design contains fields the backend doesn't (yet) know. Try again shortly or report the case with the correlation ID below.",
  "match.result.solverErrorHeading": "The backend didn't finish the Solver.",
  "match.result.solverErrorTitle": "Solver error",
  "match.result.solverNotRun": "Solver hasn't run yet.",
  "match.result.structureBoosters": "Booster coverage",
  "match.result.structureBoostersHint": "Boosters are the powers with the highest innovation relevance. A thinly covered row is the team’s concrete gap.",
  "match.result.structureBoostersInfoAria": "Show explanation of booster coverage",
  "match.result.structureBoostersInfoBody": "Shown is how many of the assessed people bring the power strongly (above {threshold}). Such a gap can be closed by re-staffing or developed deliberately.",
  "match.result.structureBoostersInfoTitle": "Boosters and gaps",
  "match.result.structureCarriers": "Cluster carriers",
  "match.result.structureCarriersHint": "Carrier = at least {min} of the cluster’s 5 powers above {threshold}; complete = all 5 above it.",
  "match.result.structureCarriersInfoAria": "Show explanation of the counting",
  "match.result.structureCarriersInfoBody": "The count is over people with powers data, not the whole team: “2 of 6” means two carriers among six assessed people.",
  "match.result.structureCarriersInfoTitle": "What is counted",
  "match.result.structureHeader": "Powers profile structure",
  "match.result.structureOfTeam": "{n} of {total}",
  "match.result.structureSignature": "· {n} complete",
  "match.result.structureThresholdHint": "powers above {threshold}",
  "match.result.suitability.basis": "AI overall assessment",
  "match.result.suitability.empty": "No AI suitability scores yet. Please run the match again.",
  "match.result.suitability.header": "Top 5 – best fit",
  "match.result.suitability.openProfile": "{name} – open profile",
  "match.result.suitability.rankLabel": "Rank {rank}",
  "match.result.suitability.scoreLabel": "AI suitability {score}%",
  "match.result.teamHeader": "Team · {count, plural, one {# person} other {# people}}",
  "match.result.teamPowers": "Power Scorecard matrix",
  "match.result.teamSizeMeta": "Team size {count}",
  "match.result.tilt.axis.DRIVE": "Drive ↔ attraction",
  "match.result.tilt.axis.MINDSET": "Exploit ↔ explore",
  "match.result.tilt.balanced": "balanced",
  "match.result.tilt.bothWeak": "weak on both sides",
  "match.result.tilt.grade.CLEAR": "clearly {side}",
  "match.result.tilt.grade.LEANS": "leans {side}",
  "match.result.tilt.grade.STRONG": "strongly {side}",
  "match.result.tilt.info.DRIVE": "Share of powers above {threshold}: drive {a}%, attraction {b}%. Drive powers push from within, attraction powers create the conditions under which drive lands in a team. Compared as shares, because drive covers four clusters and attraction two.",
  "match.result.tilt.info.MINDSET": "Share of powers above {threshold}, within drive: exploit {a}%, explore {b}%. Exploit secures and optimises the existing, explore opens what is possible. Teams that combine both are more capable than one-sided ones.",
  "match.result.tilt.infoAria": "Show explanation of the team axes",
  "match.result.tilt.infoNoise": "The wording follows how far the difference clears its own sampling error: leans = beyond it, clearly = one and a half times, strongly = twice. Only these three steps are given: at this team size the exact difference is not dependable enough to read as a number.",
  "match.result.tilt.notSignificant": "Difference too small to read",
  "match.result.tilt.side.EXPLOIT": "Exploit",
  "match.result.tilt.side.EXPLORE": "Explore",
  "match.result.tilt.side.PULL": "Attraction",
  "match.result.tilt.side.PUSH": "Drive",
  "match.result.unlockMembers": "Unlock members",
  "match.result.unnamed": "unnamed",
  "match.result.weightedPowersInfoAria": "Show explanation of this list",
  "match.result.weightedPowersInfoBody": "All 30 powers of the team, sortable by team score or by weighting. Weighting: the 0–10 value from the Powers Scorecard that steered the selection. Ø: the team's mean for this power, 0–100.",
  "match.result.weightedPowersInfoTitle": "What this shows",
  "match.result.weightedPowersSoleHint": "„only …“ means: the only person who brings this power strongly.",
  "match.result.wishFitDelta": "{delta} versus the average across all 30 powers",
  "match.result.wishFitInfoAria": "Show explanation of the weighting",
  "match.result.wishFitInfoBody": "The Powers Scorecard is where you set which powers matter to you (0–10). The number says whether the team sits above or below its own average across all 30 powers exactly there; powers weighted 0 don't count. A weighting is not a requirement: it steers the selection but sets no threshold – so there is nothing to meet or miss here. Who brings each power strongly is in “Top Powers”.",
  "match.result.wishFitInfoTitle": "What is being compared here",
  "match.result.wishFitPoolNote": "the candidate pool had nothing closer",
  "match.roleReqsSection": "Role requirements",
  "match.save.eyebrow": "Save result",
  "match.save.failed": "Save failed",
  "match.save.modeAssess": "Assess",
  "match.save.modeOptimize": "Optimize",
  "match.save.modeRank": "Rank",
  "match.save.modeRankCompanies": "Rank companies",
  "match.save.note": "Note",
  "match.save.sections": "Visible sections",
  "match.save.notePlaceholder": "Optional – context, assumptions, next steps …",
  "match.save.off": "off",
  "match.save.on": "on",
  "match.save.previewAndNote": "Preview & note",
  "match.save.resultName": "Result name",
  "match.save.retry": "Try again",
  "match.save.saved": "Saved",
  "match.save.saving": "Saving…",
  "match.save.statAgenticAi": "Agentic AI",
  "match.save.statConditions": "Conditions",
  "match.save.statMode": "Mode",
  "match.save.statPool": "Pool",
  "match.save.statTarget": "Target",
  "match.save.teamCount": "Team · {count, plural, one {# person} other {# people}}",
  "match.settingsEyebrow": "Match settings",
  "match.shortDescPlaceholder": "In one sentence: what, what for?",
  "match.step.challenge": "Challenge",
  "match.step.companies": "Companies",
  "match.step.people": "Team players",
  "match.step.peopleRank": "Candidates",
  "match.step.result": "Result",
  "match.teamPowers": "Power Scorecard",
  "match.teamProfile": "Selection",
  "match.teamProfileCustom": "Custom",
  "match.teamProfileModifiedSuffix": " · modified",
  "match.teamReqsSection": "Team requirements",
  "match.teamSizeSection": "Team size",
  "match.titlePlaceholder": "e.g. Set crew BTL · Q2 2026",
  "match.tour.create.desc": "This button creates a new match and opens the editor, where you describe what you need and the solver proposes the team.",
  "match.tour.create.title": "Create a new match",
  "match.tour.label": "Match",
  "match.tour.list.desc": "All your matches live here. Click a card to reopen it and continue where you left off.{names}",
  "match.tour.list.names": "Currently: {list}.",
  "match.tour.list.title": "Your matches",
  "match.tour.summary": "This is the Match area: you put teams together from people and requirements. You have {count} matches so far.",
  "match.unnamedMatch": "Unnamed match",
  "match.unnamedProject": "Unnamed project",
  "match.validationRejected": "Genesis rejected the request.",
  "match.weightInput.label": "Weight for {power}",
  "match.weightLevel.high": "High",
  "match.weightLevel.low": "Low",
  "match.weightLevel.medium": "Medium",
  "match.weightLevel.none": "Not relevant",
  "match.workflow.challengeSubtitle": "Describe your project above – the AI derives team size, requirements and powers from it. Below you review the result and fine-tune small details.",
  "match.workflow.challengeSubtitleNoTeamSize": "Describe your project above – the AI derives requirements and powers from it. Below you review the result and fine-tune small details.",
  "match.workflow.challengeSubtitleRank": "Describe the role or open position above – the AI derives the requirements a candidate should meet. Below you review the result and fine-tune small details.",
  "match.workflow.challengeSubtitleRankCompanies": "Describe your need above. Below it you set the requirements a company should meet.",
  "match.workflow.deleteConfirm.confirm": "Delete",
  "match.workflow.deleteConfirm.message": "The Match will be permanently removed from genesis. This action cannot be undone.",
  "match.workflow.deleteConfirm.title": "Delete Match?",
  "match.workflow.deleteTitle": "Delete match",
  "match.workflow.modeAssess": "Assess",
  "match.workflow.modeIndicatorTitle": "Mode (fixed at creation)",
  "match.workflow.modeOptimize": "Optimize",
  "match.workflow.modeRank": "Rank",
  "match.workflow.modeRankCompanies": "Rank companies",
  "match.workflow.nextTo": "Continue to {label}",
  "match.workflow.prevTo": "Back to {label}",
  "match.workflow.settingsTitle": "Match settings",
  "match.workflow.belongsToProject": "Belongs to {links}",
  "match.workflow.unnamedProject": "Unnamed project",
  "matchDetail.tour.label": "Match Detail",
  "matchDetail.tour.summary": "You are editing the match \"{name}\", currently on the \"{step}\" workflow step with {candidates} candidates and {results} saved results. Work through the steps from requirements to the solved team.",
  "matchDetail.tour.untitled": "untitled match",
  "model.connected": "Connected",
  "model.docs.cancel": "Cancel",
  "model.docs.cancelKeep": "Keep processing",
  "model.docs.cancelMessage": "“{title}” will stop processing and be removed.",
  "model.docs.cancelReprocessConfirm": "Stop reprocessing",
  "model.docs.cancelReprocessMessage": "“{title}” is left unchanged. The processing in progress is discarded.",
  "model.docs.cancelReprocessTitle": "Stop reprocessing?",
  "model.docs.cancelTitle": "Cancel processing?",
  "model.docs.delete": "Delete",
  "model.docs.deleteMessage": "“{title}” and its extracted content will be removed.",
  "model.docs.deleteTitle": "Delete document?",
  "model.docs.descLabel": "Document description",
  "model.docs.descPlaceholder": "What it's about (optional)",
  "model.docs.download": "Download",
  "model.docs.dropHint": "PDF, Word, PowerPoint, and more, up to 50 MB",
  "model.docs.dropLabel": "Drop a document or click to choose",
  "model.docs.duplicate": "That document is already uploaded.",
  "model.docs.empty": "No documents yet.",
  "model.docs.enabledLabel": "Enabled",
  "model.docs.failedHint": "Processing failed. Try reprocessing, or re-upload the document.",
  "model.docs.loadError": "Couldn't load documents.",
  "model.docs.needFile": "Choose a document to upload.",
  "model.docs.needSections": "Select at least one section.",
  "model.docs.needTitle": "Add a title.",
  "model.docs.reprocess": "Reprocess",
  "model.docs.sectionGlobal": "Global documents",
  "model.docs.sectionUploaded": "Uploaded documents",
  "model.docs.status.failed": "Failed",
  "model.docs.status.pending": "Pending",
  "model.docs.status.processing": "Processing",
  "model.docs.status.processingFor": "Processing ({provider})",
  "model.docs.status.ready": "Ready",
  "model.docs.status.reembedRequired": "New processing required ({provider})",
  "model.docs.sub": "Documents the assistant can search. Uploads are processed in the background.",
  "model.docs.textOnly": "Text only",
  "model.docs.textOnlyForced": "Images can't be extracted from this file type; it will be indexed as text.",
  "model.docs.textOnlyHint": "Skip images for faster processing; text stays searchable.",
  "model.docs.title": "Knowledge documents",
  "model.docs.titleLabel": "Document title",
  "model.docs.titlePlaceholder": "Title (required)",
  "model.docs.unavailableHint": "Not embedded for the current provider. Re-embed to make it searchable.",
  "model.docs.upload": "Upload and process ({provider})",
  "model.docs.uploadBlocked": "Waiting for the provider switch to take effect… ({seconds}s)",
  "model.docs.uploadError": "Upload failed – try again.",
  "model.docs.uploadedAt": "Uploaded {date}",
  "model.docs.worksWith": "Works with this provider",
  "model.keyAriaLabel": "{provider} API key",
  "model.providerSub": "The upstream model stack. Model kinds resolve to this provider's concrete models.",
  "model.providerSwitchHint": "Switching to {provider} changes the embedding model ({from} → {to}). It may be necessary to reprocess the documents again after saving so they stay searchable.",
  "model.providerTitle": "Provider",
  "model.providerUnavailable": "Not available yet",
  "model.resolvedModels": "Resolved models",
  "model.saveError": "Couldn't save model settings – try again.",
  "model.saveError.apiKeyRequired": "Enter an API key for this provider before activating it.",
  "model.saveError.forbidden": "You need admin rights to change the model configuration.",
  "model.saveError.notConfigured": "Model configuration isn't enabled on this server.",
  "model.saveError.providerNotServable": "This provider isn't supported yet – choose another one.",
  "model.saveError.unauthorized": "Your session has expired – sign in again.",
  "model.saveError.upstream": "Couldn't reach the configuration store – try again.",
  "model.saved": "Settings saved – may take up to 30 seconds to take effect.",
  "model.sources.keyLabel": "API key",
  "model.sources.pubmed.hint": "Articles and abstracts from PubMed through the NCBI E-utilities. Up to 3 requests per second without a key, 10 with one.",
  "model.sources.pubmed.keyLink": "Create a key in your NCBI account",
  "model.sources.pubmed.keyPlaceholder": "your NCBI API key",
  "model.sources.pubmed.offer": "Offer in the Studio",
  "model.sources.pubmed.publisher": "NCBI · U.S. National Library of Medicine",
  "model.sources.sub": "Specialist databases the assistant may search besides the web.",
  "model.sources.title": "Research sources",
  "model.webSearch.hint": "Research on the public web through {provider}, billed per search. Premium adds verified news sources.",
  "model.webSearch.label": "Web search",
  "model.webSearch.off": "Off",
  "model.webSearch.premium": "Premium",
  "model.webSearch.standard": "Standard",
  "model.webSearch.unavailable": "Not available for this provider.",
  "nav.community": "Community",
  "nav.inviteOutsider": "Invite external person",
  "nav.logout": "Logout",
  "nav.mainLandmark": "Main",
  "nav.map": "Map",
  "nav.myCompanies": "My companies",
  "nav.newCompany": "New company",
  "nav.openMenu": "Open menu",
  "nav.pins": "Pins",
  "nav.play": "Play",
  "nav.profile": "Profile",
  "nav.service": "Documents",
  "nav.settings": "Settings",
  "nav.studio": "Studio",
  "nav.watch": "Watch",
  "organizationalRecord.backToProfile": "Back to profile",
  "organizationalRecord.comments.newest": "Newest first",
  "organizationalRecord.comments.oldest": "Oldest first",
  "organizationalRecord.contentField": "Content",
  "organizationalRecord.create": "Create organisational record",
  "organizationalRecord.deleteDocument": "Delete document?",
  "organizationalRecord.deleteEntry": "Delete entry?",
  "organizationalRecord.deleteEntryHelp": "Comments on this entry will also be deleted.",
  "organizationalRecord.globalDescription": "Internal organizational records {subject, select, company {about this company} other {about this person}}. Your record access is global, including outside your department and applications.",
  "organizationalRecord.description": "{subject, select, company {Internal documents and discussions about this company.} other {Internal documents and discussions about this person.}}",
  "organizationalRecord.discussion": "General discussion",
  "organizationalRecord.documents": "Documents",
  "organizationalRecord.documentsHint": "{subject, select, company {Documents in this company's organisational record.} other {Documents in this person's organisational record.}}",
  "organizationalRecord.powerAnalysisDesc": "Finds the person's powers in the documents of their record. You review the result before it goes to the profile.",
  "organizationalRecord.powerAnalysisNeedsDocument": "Upload a document to the record first, then the power analysis can start.",
  "organizationalRecord.download": "Download",
  "organizationalRecord.drafts.discardEntry": "Discard the unsaved changes to this note or report, including its links?",
  "organizationalRecord.drafts.invalid": "Complete the title and content of your notes or reports, and check the text length. Comments require text (up to 4,096 characters); notes and reports allow 255 characters in the title and 65,535 in the content.",
  "organizationalRecord.editEntry": "Edit entry",
  "organizationalRecord.empty": "{subject, select, company {No organisational record has been created for this company yet.} other {No organisational record has been created for this person yet.}}",
  "organizationalRecord.entries": "Notes & reports",
  "organizationalRecord.heading": "Organisational record",
  "organizationalRecord.kind": "Type",
  "organizationalRecord.links.add": "Link {title} ({kind})",
  "organizationalRecord.links.comment": "Discussion comment",
  "organizationalRecord.links.details": "Details & links",
  "organizationalRecord.links.downloaded": "The file was downloaded because this format does not support previews.",
  "organizationalRecord.links.label": "Linked",
  "organizationalRecord.links.noMatches": "No matching documents or entries.",
  "organizationalRecord.links.remove": "Remove link to {title}",
  "organizationalRecord.links.search": "Find documents and entries in this organisational record …",
  "organizationalRecord.links.select": "Link a document or entry",
  "organizationalRecord.links.unavailable": "This content is no longer available in this organisational record.",
  "organizationalRecord.links.unused": "No references to this content yet.",
  "organizationalRecord.links.usedIn": "Used in",
  "organizationalRecord.newEntry": "Add note / report",
  "organizationalRecord.noAccess": "This area requires the organisation Manager/HR role.",
  "organizationalRecord.noDocuments": "No documents yet.",
  "organizationalRecord.noEntries": "No notes or reports yet.",
  "organizationalRecord.note": "Note",
  "organizationalRecord.preview": "Preview",
  "organizationalRecord.rename": "Rename",
  "organizationalRecord.report": "Report",
  "organizationalRecord.titleField": "Title",
  "organizationalRecord.updated": "Edited by {name} on {date}",
  "organizationalRecord.upload": "Upload document",
  "organizationalRecord.uploadHelp": "PDF, Office, text or images · up to 10 MB per file",
  "organizationalRecord.uploadRejected": "Choose a supported, non-empty file of up to 10 MB.",
  "person.email.missing": "No email address provided",
  "personFilter.addFilter": "+ Add filter",
  "personFilter.allFilters": "All filters",
  "personFilter.frequent": "Frequent",
  "personFilter.heading": "Team Player filters{count, plural, =0 {} other { · # active}}",
  "pinboard.tour.controls.desc": "Search pins by name, change the sort order, or filter to pins that are not in any group yet.",
  "pinboard.tour.controls.title": "Search & sort",
  "pinboard.tour.grid.desc": "{count} {typeLabel} in the current view. Click a card to open it, use \"+ Add\" to put it into groups, or the trash icon to unpin it.",
  "pinboard.tour.grid.title": "Your pinned items",
  "pinboard.tour.label": "Save Pins",
  "pinboard.tour.sidebar.desc": "Switch between your pinned people ({people}), posts ({posts}) and projects ({projects}), and pick a pin group below. Drag a card onto a group to file it there.",
  "pinboard.tour.sidebar.title": "Types & groups",
  "pinboard.tour.summary": "This is your pinboard with everything you saved: {people} people, {posts} posts and {projects} projects.",
  "power.instrument.journey": "Power Journey",
  "power.instrument.parts": "{answered} / {total} parts",
  "power.instrument.quiz": "Power Quiz",
  "power.instrument.inDepthStatements": "{answered} / {total} in-depth statements",
  "power.name.Abs": "Abstraction",
  "power.name.Ada": "Adaption",
  "power.name.Agg": "Aggression",
  "power.name.Aut": "Autonomy",
  "power.name.Awe": "Self-Perception",
  "power.name.Cha": "Charisma",
  "power.name.Con": "Concentration",
  "power.name.Cou": "Courage",
  "power.name.Cur": "Curiosity",
  "power.name.Dil": "Diligence",
  "power.name.Emp": "Empathy",
  "power.name.Exp": "Expression",
  "power.name.Fai": "Belief",
  "power.name.Fid": "Fidelity",
  "power.name.Fns": "Fairness",
  "power.name.Hum": "Humor",
  "power.name.Ima": "Imagination",
  "power.name.Imp": "Improvisation",
  "power.name.Ins": "Inspiration",
  "power.name.Int": "Intention",
  "power.name.Inu": "Intuition",
  "power.name.Joy": "Joy",
  "power.name.Lan": "Language",
  "power.name.Min": "Mindfulness",
  "power.name.Pas": "Passion",
  "power.name.Per": "Perception",
  "power.name.Psc": "Perseverance",
  "power.name.Rpy": "Responsibility",
  "power.name.Str": "Strategy",
  "power.name.Tol": "Tolerance",
  "power.tag.Co": "Communication",
  "power.tag.Co.description": "Capturing and conveying. These Powers turn inner experience into shared perception, language, and expression.",
  "power.tag.Fo": "Future Orientation",
  "power.tag.Fo.description": "Direction toward the uncertain. These Powers give the team the strength to think beyond what exists and move into the open.",
  "power.tag.In": "Inventiveness",
  "power.tag.In.description": "Unlocking the new. These Powers open the space beyond the known and keep the team capable of learning.",
  "power.tag.Re": "Resilience",
  "power.tag.Re.description": "Stability under load. These Powers keep the team capable of acting as pressure, duration, and resistance increase.",
  "power.tag.Ro": "Result Orientation",
  "power.tag.Ro.description": "Commitment to outcome. These Powers turn intent into reliably completed, effective work.",
  "power.tag.Ts": "Teamability",
  "power.tag.Ts.description": "The glue of community. These Powers turn individuals into a resilient, diverse, and sustainable whole.",
  "profile.fields.addCountry": "+ Country",
  "profile.fields.avatarAlt": "Avatar",
  "profile.fields.changePhoto": "Change photo",
  "profile.fields.removePhoto": "Remove photo",
  "profile.merge.add": "Add",
  "profile.merge.badge.conflict": "Differs",
  "profile.merge.badge.new": "New",
  "profile.merge.bar.allReviewed": "All changes reviewed",
  "profile.merge.bar.aria": "Import changes",
  "profile.merge.bar.next": "Next",
  "profile.merge.bar.open": "{count, plural, one {# field left to review} other {# fields left to review}}",
  "profile.merge.bar.previous": "Previous",
  "profile.merge.cefr.native": "Native",
  "profile.merge.chooseAria": "Keep your value or use the imported one",
  "profile.merge.date.beforeBirth": "This date is before the date of birth.",
  "profile.merge.date.format": "Use a date like YYYY, YYYY-MM or YYYY-MM-DD.",
  "profile.merge.date.future": "This date can't be in the future.",
  "profile.merge.date.range": "End date must be on or after the start date.",
  "profile.merge.dateBlocked": "Some dates need fixing before saving.",
  "profile.merge.editAria.existing": "Edit your value",
  "profile.merge.editAria.incoming": "Edit the imported value",
  "profile.merge.field.childCountMax": "The number of children cannot exceed {max}.",
  "profile.merge.field.childCountNegative": "The number of children cannot be negative.",
  "profile.merge.field.invalidEmail": "Enter a valid email address.",
  "profile.merge.field.invalidPhone": "Enter a valid phone number.",
  "profile.merge.field.invalidUrl": "Enter a valid web address.",
  "profile.merge.field.tooLong": "Keep this to {max} characters or fewer.",
  "profile.merge.fieldBlocked": "Some values need fixing before saving.",
  "profile.merge.guide.review": "Review",
  "profile.merge.guide.step": "{current, number} of {total, number}",
  "profile.merge.incomingLabel": "Imported",
  "profile.merge.keep": "Keep mine",
  "profile.merge.keepAll": "Keep all mine",
  "profile.merge.language.unknown": "“{value}” is not a recognizable language. Choose the right one, or skip this entry.",
  "profile.merge.languageBlocked": "Choose a real language for the imported entry, or skip it.",
  "profile.merge.replacesSaved": "Replaces your saved value",
  "profile.merge.replacesSavedRow": "Replaces your saved entry",
  "profile.merge.reset.existing": "Reset to your saved value",
  "profile.merge.reset.incoming": "Reset to the imported value",
  "profile.merge.reviewBlocked": "Review every change before saving.",
  "profile.merge.save": "Save changes",
  "profile.merge.saveFailed": "This change could not be saved.",
  "profile.merge.savePartial": "{count, plural, one {# change couldn't be saved. Please try again.} other {# changes couldn't be saved. Please try again.}}",
  "profile.merge.saving": "Saving…",
  "profile.merge.showLess": "Show less",
  "profile.merge.showMore": "Show more",
  "profile.merge.side.existing": "Your value",
  "profile.merge.skills.importAllAria": "Import all skills",
  "profile.merge.skip": "Skip",
  "profile.merge.status.add": "Will be added",
  "profile.merge.status.keep": "Keeping your value",
  "profile.merge.status.skip": "Skipped",
  "profile.merge.status.use": "Using the imported value",
  "profile.merge.use": "Use imported",
  "profile.merge.useAll": "Use all imported",
  "profile.page.add.certificate": "Add certificate",
  "profile.page.add.education": "Add education",
  "profile.page.add.experience": "Add work experience",
  "profile.page.add.expertise": "Add skill",
  "profile.page.add.language": "Add language",
  "profile.page.addToCommunity": "Community",
  "profile.page.addToPins": "Pins",
  "profile.page.ageSuffix": "{age} years",
  "profile.page.avatar.notAnImage": "Choose an image file.",
  "profile.page.avatar.notReadable": "That file could not be read as an image.",
  "profile.page.avatar.tooLarge": "Choose an image of {max} MB or less.",
  "profile.page.avatar.tooManyPixels": "This image is too large to crop. Use one under {max} megapixels.",
  "profile.page.businessCard": "Business card",
  "profile.page.businessCardRoleHint": "Taken from Details › Company › Job title",
  "profile.page.details": "Details",
  "profile.page.details.company": "Company",
  "profile.page.details.personal": "Personal",
  "profile.page.editVisibility": "Edit visibility",
  "profile.page.empty.certificates": "No certificates",
  "profile.page.empty.education": "No education",
  "profile.page.empty.experience": "No work experience",
  "profile.page.empty.expertise": "No skills",
  "profile.page.empty.languages": "No languages",
  "profile.page.error.certificateNameRequired": "Name is required.",
  "profile.page.error.fieldOfStudyRequired": "Field of study is required.",
  "profile.page.error.invalidFields": "{count, plural, one {One field needs attention} other {# fields need attention}} before saving.",
  "profile.page.error.jobTitleRequired": "Job title is required.",
  "profile.page.error.languageLevelRequired": "Please choose a level for the foreign language.",
  "profile.page.error.nameRequired": "First name and last name are required.",
  "profile.page.error.saveCertificate": "Could not save the certificate",
  "profile.page.error.saveEducation": "Could not save the education entry",
  "profile.page.error.saveEntriesFailedCount": "{count, plural, one {# entry could not be saved.} other {# entries could not be saved.}}",
  "profile.page.error.saveExperience": "Could not save the experience",
  "profile.page.error.saveLanguage": "Could not save the language",
  "profile.page.error.savePerson": "Could not save person",
  "profile.page.error.saveSkill": "Could not save the skill",
  "profile.page.error.skillNameRequired": "A name is required.",
  "profile.page.error.startDateRequired": "Start date is required.",
  "profile.page.error.tooManyActivities": "Keep this to {max} entries or fewer.",
  "profile.page.familyName.placeholder": "Last name",
  "profile.page.field.activities.counter": "{count} of {max}",
  "profile.page.field.activities.label": "Main tasks",
  "profile.page.field.activities.placeholder": "e.g. Code reviews",
  "profile.page.field.cefr": "Level (CEFR)",
  "profile.page.field.certificateName.label": "Name",
  "profile.page.field.certificateName.placeholder": "e.g. AWS Solutions Architect",
  "profile.page.field.country": "Country",
  "profile.page.field.degree.label": "Degree",
  "profile.page.field.degree.none": "No degree selected",
  "profile.page.field.degree.placeholder": "Choose degree",
  "profile.page.field.degree.search": "Search degree",
  "profile.page.field.department": "Department",
  "profile.page.field.employer.label": "Employer",
  "profile.page.field.employer.placeholder": "e.g. Smycles GmbH",
  "profile.page.field.expertiseName.label": "Name",
  "profile.page.field.expertiseName.placeholder": "e.g. Kubernetes",
  "profile.page.field.field.label": "Field of study",
  "profile.page.field.field.placeholder": "e.g. Computer science",
  "profile.page.field.from": "From",
  "profile.page.field.industry": "Industry",
  "profile.page.field.institution": "Educational institution",
  "profile.page.field.issueDate": "Issue date",
  "profile.page.field.jobTitle.label": "Job title",
  "profile.page.field.jobTitle.placeholder": "e.g. Software developer",
  "profile.page.field.language.label": "Language",
  "profile.page.field.language.placeholder": "Choose language",
  "profile.page.field.level": "Level",
  "profile.page.field.location": "Location",
  "profile.page.field.nativeSpeaker.label": "Native language",
  "profile.page.field.nativeSpeaker.placeholder": "Native language",
  "profile.page.field.to": "To",
  "profile.page.givenName.placeholder": "First name",
  "profile.page.hideVisibility": "Hide visibility",
  "profile.page.inCommunity": "In community",
  "profile.page.inPins": "In pins",
  "profile.page.label.apartment": "Apartment",
  "profile.page.label.birthday": "Birthday",
  "profile.page.label.childCount": "Number of children",
  "profile.page.label.citizenship": "Citizenship",
  "profile.page.label.city": "Place of residence",
  "profile.page.label.contractType": "Contract type",
  "profile.page.label.country": "Country",
  "profile.page.label.countryState": "State / region",
  "profile.page.label.currentActivity": "Current activity",
  "profile.page.label.currentEmployer": "Employer",
  "profile.page.label.currentTasks": "Main tasks",
  "profile.page.label.drivingLicence": "Driving licence",
  "profile.page.label.email": "Email",
  "profile.page.label.gender": "Gender",
  "profile.page.label.houseNumber": "House number",
  "profile.page.label.jobDepartment": "Department",
  "profile.page.label.jobLocation": "Work location",
  "profile.page.label.jobTitle": "Job title",
  "profile.page.label.maritalStatus": "Marital status",
  "profile.page.label.miscellaneous": "Other",
  "profile.page.label.nationality": "Nationality",
  "profile.page.label.phone": "Phone",
  "profile.page.label.profession": "Profession",
  "profile.page.label.street": "Street",
  "profile.page.label.website": "Website",
  "profile.page.label.workingTimeModel": "Working time",
  "profile.page.label.zipCode": "Postal code",
  "profile.page.loadFailed": "Profile could not be loaded",
  "profile.page.loadFailedHint": "Please reload the page or sign in again.",
  "profile.page.notFound": "Profile not found",
  "profile.page.notFoundHint": "This profile does not exist or has not been shared with you.",
  "profile.page.openChat": "Open chat",
  "profile.page.section.certificates": "Certificates",
  "profile.page.section.education": "Education",
  "profile.page.section.experience": "Work experience",
  "profile.page.section.expertise": "Skills",
  "profile.page.section.languages": "Languages",
  "profile.page.serviceMenu": "Service",
  "profile.page.sharedItems": "Share",
  "profile.page.sharedItemsNone": "No posts to show",
  "profile.page.startChat": "Send message",
  "profile.page.summary": "Summary",
  "profile.rows.done": "Done",
  "profile.rows.level": "Level: {level}",
  "profile.rows.nativeSpeaker": "Native speaker",
  "profile.rows.noLevel": "No level",
  "profile.rows.today": "today",
  "profile.sidebars.closeCluster": "Close",
  "profile.sidebars.combined": "Combined",
  "profile.sidebars.errorPrefix": "Error: {message}",
  "profile.sidebars.loading": "loading…",
  "profile.sidebars.noEvaluation": "Not yet assessed.",
  "profile.sidebars.openClusterFor": "Show evaluation for {power}",
  "profile.sidebars.powerMap": "Power Map",
  "profile.sidebars.powersNotAssessed": "This person has not been assessed yet.",
  "profile.sidebars.powersNotShared": "This person has not shared their powers.",
  "profile.sidebars.powersTitle": "Powers",
  "profile.sidebars.selfAssessment": "Self-assessment",
  "profile.sidebars.smartAnalysis": "Smart analysis",
  "profile.skills.addAtLevel": "Add skill at this level",
  "profile.skills.unrated": "Unrated",
  "profile.skills.viewDiagram": "Modern",
  "profile.skills.viewList": "Classic",
  "profile.tour.about.desc": "Your summary text, your personal and company details and your {languages} languages. Click any field to edit it in place.",
  "profile.tour.about.title": "Summary, details and languages",
  "profile.tour.card.desc": "Click any field (name, phone, email, country, city) to edit it in place; changes are collected and saved via the save bar.{missing}",
  "profile.tour.card.missingHint": "Some of your contact fields are still empty.",
  "profile.tour.card.title": "Your business card",
  "profile.tour.cv.desc": "{experiences} work experiences, {educations} educations, {skills} skills and {certificates} certificates. Add new entries here or click an existing one to edit it.",
  "profile.tour.cv.title": "Your CV entries",
  "profile.tour.label": "Save Profile",
  "profile.tour.powers.desc": "Your strongest powers at a glance. Click one to see its detail page, or assess more of them over in Grow.",
  "profile.tour.powers.title": "Your powers",
  "profile.tour.service.desc": "AI helpers and data services for your profile: extract powers and skills, import a CV or LinkedIn profile, generate a CV and export your data.",
  "profile.tour.service.title": "Service menu",
  "profile.tour.summary": "This is your own profile with {count} CV entries. Almost every field is editable right on the page.",
  "profile.tour.visibility.desc": "This toggle reveals a share switch next to every field and entry, so you decide exactly what other people can see of your profile.",
  "profile.tour.visibility.title": "Edit visibility",
  "profileExtraction.abort": "Abort extraction",
  "profileExtraction.abortTip": "Still extracting - you can keep waiting, or abort and try again with the same document. Nothing has been saved yet.",
  "profileExtraction.alreadyInDocuments": "Already in Documents - it is not saved again.",
  "profileExtraction.analysing": "Extracting profile data from your document - this can take up to two minutes...",
  "profileExtraction.documentUnavailable": "The document could not be loaded.",
  "profileExtraction.dropZone": "Drag a document here or click to upload",
  "profileExtraction.dropZoneHint": "CV, LinkedIn export, application form … · PDF, DOC, DOCX, TXT, RTF, HTML, image · max. 10 MB",
  "profileExtraction.elapsed": "Elapsed time: {time}",
  "profileExtraction.fileTooLarge": "File is too large (max. 10 MB).",
  "profileExtraction.noResult": "The document could not be analysed.",
  "profileExtraction.nothingNew": "Nothing new found – your profile already covers this document.",
  "profileExtraction.ready": "We found details to review in {file}.",
  "profileExtraction.review": "Review changes",
  "profileExtraction.saveFailed": "The file could not be saved in Documents.",
  "profileExtraction.timeout": "Analysis is taking too long. Please try again.",
  "profileExtraction.title": "CV Extractor",
  "profileExtraction.unsupportedType": "Unsupported file type.",
  "progress.counter.generic": "{done} of {total}",
  "progress.counter.matchAssessment": "{done} of {total} assessments finished",
  "progress.counter.matchCriteria": "{done} of {total} checks",
  "progress.detail.matchAssessmentsFailed": "{count} of them failed",
  "progress.detail.matchCandidatesLoaded": "{count, plural, one {# candidate} other {# candidates}} loaded",
  "progress.detail.matchCompaniesLoaded": "{count, plural, one {# company} other {# companies}} loaded",
  "progress.detail.matchChecksWithAi": "{count} of them with AI",
  "progress.detail.matchCriteriaActive": "{count, plural, one {# criterion} other {# criteria}} active",
  "progress.detail.matchLocationsResolved": "{count} of {total} residences located",
  "progress.elapsedMinutes": "{minutes} min {seconds} s",
  "progress.elapsedSeconds": "{seconds} s",
  "progress.label": "Progress",
  "progress.stage.matchAssessment": "Assess candidates",
  "progress.stage.matchCriteria": "Check criteria",
  "progress.stage.matchFinalize": "Create result",
  "progress.stage.matchPrepare": "Prepare",
  "progress.stage.matchSolve": "Compose teams",
  "progress.stage.unknown": "Working",
  "progress.waiting": "Starting …",
  "referenceData.add": "Add",
  "referenceData.cancel": "Cancel",
  "referenceData.confirmDelete.message": "The entry is removed for good and will no longer be offered in profiles and Match requirements.",
  "referenceData.confirmDelete.title": "Delete “{label}”?",
  "referenceData.contractType.add": "New contract type",
  "referenceData.contractType.empty": "No contract types yet.",
  "referenceData.contractType.sub": "Managed list of contract types.",
  "referenceData.contractType.title": "Contract types",
  "referenceData.degree.add": "New degree",
  "referenceData.degree.empty": "No degrees yet.",
  "referenceData.degree.sub": "Managed list of academic degrees for education entries.",
  "referenceData.degree.title": "Degrees",
  "referenceData.delete": "Delete",
  "referenceData.duplicate": "This entry already exists.",
  "referenceData.edit": "Edit",
  "referenceData.gender.add": "New gender",
  "referenceData.gender.empty": "No entries.",
  "referenceData.gender.sub": "Managed list of genders.",
  "referenceData.gender.title": "Genders",
  "referenceData.industry.add": "New industry",
  "referenceData.industry.empty": "No industries yet.",
  "referenceData.industry.sub": "Managed list of industries for profiles and Match requirements.",
  "referenceData.industry.title": "Industries",
  "referenceData.jobDepartment.add": "New department",
  "referenceData.jobDepartment.empty": "No departments yet.",
  "referenceData.jobDepartment.sub": "Managed list of departments for profiles and Match requirements.",
  "referenceData.jobDepartment.title": "Departments",
  "referenceData.jobLocation.add": "New work location",
  "referenceData.jobLocation.empty": "No work locations yet.",
  "referenceData.jobLocation.sub": "Managed list of work locations for profiles and Match requirements.",
  "referenceData.jobLocation.title": "Work locations",
  "referenceData.loading": "Loading…",
  "referenceData.maritalStatus.add": "New marital status",
  "referenceData.maritalStatus.empty": "No entries.",
  "referenceData.maritalStatus.sub": "Managed list of marital statuses.",
  "referenceData.maritalStatus.title": "Marital statuses",
  "referenceData.save": "Save",
  "referenceData.workingTimeModel.add": "New working-time model",
  "referenceData.workingTimeModel.empty": "No working-time models yet.",
  "referenceData.workingTimeModel.sub": "Managed list of working-time models.",
  "referenceData.workingTimeModel.title": "Working-time models",
  "save.addToCollection.adding": "Adding…",
  "save.addToCollection.doneInGroup": "<nm>{name}</nm> was added to <b>{target}</b> in <b>{group}</b>.",
  "save.addToCollection.doneNoGroup": "<nm>{name}</nm> was added to <b>{target}</b> (without group).",
  "save.addToCollection.error": "Could not add. Please try again.",
  "save.addToCollection.goToTarget": "To {target}",
  "save.addToCollection.groupLabel": "Group",
  "save.addToCollection.noGroupPlaceholder": "Without group",
  "save.addToCollection.personFallback": "Person",
  "save.addToCollection.title": "Add {name} to {target}",
  "save.careerGraph.active": "Active",
  "save.careerGraph.done": "Done",
  "save.careerGraph.emptyLabel": "No career or education entries",
  "save.careerGraph.mainTasks": "Main tasks",
  "save.careerGraph.modeGraph": "Modern",
  "save.careerGraph.modeList": "Classic",
  "save.careerGraph.showMainTasks": "Show main tasks",
  "save.careerGraph.title": "Career & Education",
  "save.careerGraph.today": "today",
  "save.careerGraph.todayMarker": "TODAY",
  "save.careerGraph.visibilityPrivate": "Private",
  "save.careerGraph.visibilityPublic": "Public",
  "save.careerGraph.visibilityShared": "Shared",
  "save.collection.addToGroup": "Add to „{name}”",
  "save.collection.allGroups": "All",
  "save.collection.allLabel": "All",
  "save.collection.deleteGroup": "Delete group",
  "save.collection.errorPrefix": "Error: {message}",
  "save.collection.nameLabel": "Name",
  "save.collection.openItem": "Open {title}",
  "save.collection.removeFromGroup": "Remove from „{name}”",
  "save.collection.rename": "Rename",
  "save.collection.renameGroup": "Rename group",
  "save.collection.searchPlaceholder": "Search…",
  "save.community.addCommunity": "+ Community",
  "save.community.addTrigger": "+ Add",
  "save.community.createError": "Community could not be created.",
  "save.community.dailyQuotaExceeded": "Daily limit reached. Please try again later.",
  "save.community.deleteCommunity": "Delete community",
  "save.community.deleteCompletely": "Delete completely",
  "save.community.deleteConfirm": "Delete \"{name}\"? The contacts are kept, only the grouping is removed.",
  "save.community.deleteContactPrompt": "Delete \"{name}\" from your contacts and all communities?",
  "save.community.description": "Group your contacts. Select a community on the left and drag contacts into it or add them to one or more communities via \"Add\".",
  "save.community.emptyAllGrouped": "All contacts are in communities.",
  "save.community.emptyCommunity": "No one in this community yet. Drag contacts here or use \"Add\".",
  "save.community.emptyNoContacts": "No contacts yet.",
  "save.community.headerCount": "{count, plural, one {# contact} other {# contacts}}",
  "save.community.limitReached": "You have reached the maximum of {limit} communities.",
  "save.community.namePlaceholder": "Community name …",
  "save.community.newCommunity": "New community",
  "save.community.removeContact": "Remove contact",
  "save.community.removeFromCommunityPrompt": "Remove \"{name}\" from \"{community}\" (stays your contact and in other communities) or delete completely from your contacts and all communities?",
  "save.community.removeFromGroup": "Remove from group",
  "save.community.renameCommunity": "Rename community",
  "save.community.renameError": "Community could not be renamed.",
  "save.community.title": "Community",
  "save.community.ungroupedLabel": "Contacts without a community",
  "save.extraction.analysing": "Analysing …",
  "save.extraction.analysisComplete": "Analysis complete.",
  "save.extraction.analysisFailed": "Analysis failed.",
  "save.extraction.analysisFailedWithReason": "Analysis failed ({reason}).",
  "save.extraction.count.alreadyAnalysed": "{count} already analysed",
  "save.extraction.count.analysed": "{count} analysed",
  "save.extraction.count.failed": "{count} failed",
  "save.extraction.count.nothingFound": "{count} nothing found",
  "save.extraction.count.unreadable": "{count} unreadable",
  "save.extraction.done": "Done",
  "save.extraction.dropZone": "Drag a file here or click to upload",
  "save.extraction.dropZoneHint": "PDF, Word, Excel, images · max. 10 MB per file",
  "save.extraction.documentsLoadError": "Saved documents could not be loaded. You can still upload a new file.",
  "save.extraction.duplicateWarning": "Already exists in Documents - the stored document is analysed, no re-upload.",
  "save.extraction.fileTooLarge": "“{name}” is too large (max. 10 MB per file).",
  "save.extraction.fromDocuments": "From Documents",
  "save.extraction.guidePowersAboutYou": "It is about you. Evidence the analysis cannot attribute to you is discarded, and whatever is found is written to your profile.",
  "save.extraction.guidePowersConcrete": "It describes how you work: references, appraisals, feedback, project and role descriptions. A job title or a plain skills list provides no usable evidence.",
  "save.extraction.guideSkillsAboutYou": "Only upload documents that are about you.",
  "save.extraction.guideSkillsConcrete": "The more concretely an experience is described, the higher the level. A bare list of keywords stays at the lowest level.",
  "save.extraction.guideSkillsSuitable": "Anything that says something about your work and project experience or your skills is suitable: CV, certificates, further training, project documentation, job references.",
  "save.extraction.guideTitle": "Which documents work best",
  "save.extraction.loadingDocuments": "Loading documents …",
  "save.extraction.newFile": "New file",
  "save.extraction.newSkillsHeading": "Newly detected skills{count, plural, =0 {} other { (#)}}",
  "save.extraction.noAnalyzableDocuments": "None of your documents can be analysed.",
  "save.extraction.noDocuments": "No documents available.",
  "save.extraction.noFolder": "No folder",
  "save.extraction.noMatches": "No matches",
  "save.extraction.noNewSkills": "No new entries - everything was probably already in your skills.",
  "save.extraction.noPowerChanges": "No changes – no power value moved.",
  "save.extraction.nothingFoundHint": "Try references, appraisals or feedback – text that describes how you work.",
  "save.extraction.notAnalysedChip": "{count} not analysed",
  "save.extraction.notSignedIn": "Not signed in - upload not possible.",
  "save.extraction.nothingSelected": "Nothing selected",
  "save.extraction.outcome.alreadyAnalysed": "Already analysed",
  "save.extraction.outcome.analysed": "Analysed",
  "save.extraction.outcome.failed": "Analysis failed",
  "save.extraction.outcome.nothingFound": "Analysed, nothing found",
  "save.extraction.outcome.unreadable": "No readable text",
  "save.extraction.persistUploads": "Save uploaded files in Documents",
  "save.extraction.poweredBy": "Powered by smycles AI",
  "save.extraction.powersNoIndication": "{count, plural, one {# power with no indication.} other {# powers with no indication.}}",
  "save.extraction.powersUpdatedHeading": "Powers updated{count, plural, =0 {} other { (#)}}",
  "save.extraction.reopen.expired": "This analysis result is no longer available. Results stay available for 30 days.",
  "save.extraction.reopen.startedAt": "Started {date}",
  "save.extraction.reopen.title": "Document analysis",
  "save.extraction.runningInBackground": "Running in the background - you can close this and keep working. You’ll be notified when it’s done.",
  "save.extraction.searchDocuments": "Search documents",
  "save.extraction.selectAllInGroup": "Select all in {group}",
  "save.extraction.selectedCount": "{total, plural, one {# document selected} other {# documents selected}}",
  "save.extraction.startAnalysis": "Start analysis",
  "save.extraction.stillRunning": "The analysis is taking a while and keeps running in the background. You’ll get a notification when it’s done.",
  "save.extraction.tooMany": "You can analyse at most {max} documents at once.",
  "save.extraction.toggleCollapse": "Expand/collapse",
  "save.extraction.unsupportedType": "“{name}” can’t be analysed. Supported: PDF, Word, Excel and images.",
  "save.extraction.uploadFailedDuplicate": "Upload failed. A document with this name probably already exists.",
  "save.pinGroupDialog.createFailed": "The group could not be created.",
  "save.pinGroupDialog.invalidName": "Invalid name.",
  "save.pinGroupDialog.limitReached": "You have reached the maximum of {limit} groups.",
  "save.pinGroupDialog.placeholder": "e.g. Mentors",
  "save.pinGroupDialog.renameFailed": "The group could not be renamed.",
  "save.pinGroupDialog.submitCreate": "Create",
  "save.pinGroupDialog.titleCreate": "New group",
  "save.pinGroupDialog.titleRename": "Rename group",
  "save.pinGroupDialog.tryAgain": "Please try again.",
  "save.pinGroupSidebar.addGroup": "+ Group",
  "save.pinGroupSidebar.deleteMessage": "Delete “{name}”? The pins remain, only the grouping is removed.",
  "save.pinGroupSidebar.deleteTitle": "Delete group",
  "save.pinGroupSidebar.tabPerson": "People",
  "save.pinGroupSidebar.tabPost": "Posts",
  "save.pinGroupSidebar.tabProject": "Projects",
  "save.pinboardPage.description": "Drag a card onto a group on the left, or add it to one or more groups via “Add”. Dragging onto “All” removes it from the current group.",
  "save.pinboardPage.emptyAllGrouped": "All pinned {typeLabel} are in groups.",
  "save.pinboardPage.emptyNoneInView": "No pinned {typeLabel} in this view.",
  "save.pinboardPage.itemFallback": "Entry",
  "save.pinboardPage.openItem": "Open {name}",
  "save.pinboardPage.removeFromGroup": "Remove from group",
  "save.pinboardPage.removeFromGroupMessage": "Remove “{title}” from “{group}” (stays pinned and in other groups) or unpin completely?",
  "save.pinboardPage.removePin": "Remove pin",
  "save.pinboardPage.title": "Pins",
  "save.pinboardPage.typePersons": "People",
  "save.pinboardPage.typePosts": "Posts",
  "save.pinboardPage.typeProjects": "Projects",
  "save.pinboardPage.ungroupedLabel": "Pins without a group",
  "save.pinboardPage.unpin": "Unpin",
  "save.pinboardPage.unpinCompletely": "Unpin completely",
  "save.pinboardPage.unpinMessage": "Unpin “{title}”?",
  "search.activeCount": "{count} active",
  "search.addTermPlaceholder": "Type a term, then press Enter",
  "search.allFiltersAdded": "All filters added",
  "search.any": "Any",
  "search.chipType": "Type",
  "search.clear": "Clear search",
  "search.confirmRemoveFromGroup": "Remove?",
  "search.discoverHeading": "Discover",
  "search.done": "Done",
  "search.either": "Either",
  "search.errorPrefix": "Error: {message}",
  "search.extended": "Extended search",
  "search.eyebrow": "Search",
  "search.fieldAge": "Age",
  "search.fieldChildren": "Number of children",
  "search.fieldCitizenship": "Citizenship",
  "search.fieldCity": "Place of residence",
  "search.fieldCompanySize": "Size (employees)",
  "search.fieldCountry": "Country",
  "search.fieldDepartment": "Department",
  "search.fieldExpertise": "Expertise",
  "search.fieldFirstName": "First name",
  "search.fieldGender": "Gender",
  "search.fieldIndustry": "Industry",
  "search.fieldJobTitle": "Job title",
  "search.fieldLanguages": "Languages",
  "search.fieldLastName": "Last name",
  "search.fieldLocation": "Work location",
  "search.fieldMaritalStatus": "Marital status",
  "search.fieldNationality": "Nationality",
  "search.filterHeading": "{type} filters",
  "search.flagCommented": "Commented",
  "search.flagOwner": "Owner",
  "search.flagPinned": "Pinned",
  "search.flagRated": "Rated",
  "search.flagSignedUp": "Interested",
  "search.groupAgents": "AI agents",
  "search.groupCompanies": "Companies",
  "search.groupPosts": "Posts",
  "search.groupProjects": "Projects",
  "search.groupTeamplayers": "Team players",
  "search.hide": "Hide ▴",
  "search.no": "No",
  "search.noFilters": "No filters set.",
  "search.noResults": "No matches",
  "search.openChat": "Open chat",
  "search.pin": "Pin",
  "search.pinInto": "Pin into {name}",
  "search.pinNoGroup": "Pin (no group)",
  "search.placeholder": "Search team players, projects, posts …",
  "search.placeholderCompany": "Company name, skill, industry …",
  "search.placeholderPerson": "Name, job title …",
  "search.placeholderShared": "Title, description …",
  "search.publisher": "Published by",
  "search.publisherCompany": "Companies",
  "search.publisherPerson": "People",
  "search.queryLabel": "Search term",
  "search.rangeTo": "to",
  "search.removeFieldLabel": "Remove {field}",
  "search.removeFromGroup": "Remove from {name}",
  "search.removeTermLabel": "Remove {term}",
  "search.reset": "Reset",
  "search.resultCount": "{count} {type}",
  "search.resultCountMore": "{count}+ {type}",
  "search.resultCountOf": "{count} of {total} {type}",
  "search.search": "Search",
  "search.searching": "Searching …",
  "search.show": "Show ▾",
  "search.tabCompany": "Companies",
  "search.tabShare": "Share",
  "search.tabTeamplayer": "Teamplayer",
  "search.tour.filters.desc": "Build structured filters here and combine them with the free-text search term above, then hit Search. {count} filters are active right now.",
  "search.tour.filters.emptyDesc": "Build structured filters here and combine them with the free-text search term above, then hit Search. No filters are set right now.",
  "search.tour.filters.title": "Filters",
  "search.tour.label": "Search",
  "search.tour.results.desc": "The matches appear here, currently {summary}. Click a result to open it; scrolling down loads more.",
  "search.tour.results.title": "Results",
  "search.tour.summary": "This is the extended search. Find people, companies, or shared projects and posts. You are currently searching {type}.",
  "search.tour.typeToggle.desc": "Switch the search category: Teamplayer finds people, Companies finds companies by name, skill or industry, and Share finds projects and posts.",
  "search.tour.typeToggle.title": "What to search",
  "search.typeAll": "All",
  "search.typePosts": "Posts",
  "search.typeProjects": "Projects",
  "search.unpin": "Unpin",
  "search.useExtended": "Use extended search",
  "search.writeMessage": "Write a message",
  "search.yes": "Yes",
  "secretInput.hide": "Hide value",
  "secretInput.show": "Show value",
  "service.docItemRow.download": "Download",
  "service.docItemRow.newBadge": "New",
  "service.docItemRow.open": "Open",
  "service.docItemRow.rename": "Click to rename",
  "service.docItemRow.selectAriaLabel": "Select {name}",
  "service.docItemRow.sourceLabel": "Source: {source}",
  "service.docPreviewCard.cvGeneratorDraft": "CV-Generator draft",
  "service.docPreviewCard.download": "Download",
  "service.docPreviewCard.newBadge": "New",
  "service.docPreviewCard.open": "Open",
  "service.docPreviewCard.rename": "Click to rename",
  "service.docPreviewCard.selectAriaLabel": "Select {name}",
  "service.error.nameRequired": "A name is required.",
  "service.extRename.ariaLabel": "Rename",
  "service.filterBuilder.addFilter": "+ Add filter",
  "service.filterBuilder.all": "All",
  "service.filterBuilder.allFiltersAdded": "All filters added",
  "service.filterBuilder.clear": "Clear",
  "service.filterBuilder.done": "Done",
  "service.filterBuilder.removeFilterLabel": "Remove {label}",
  "service.folderRow.deleteFolder": "Delete folder",
  "service.folderRow.deleteFolderAria": "Delete folder {name}",
  "service.folderRow.deleteFolderOnlyHint": "Delete only the folder: {count, plural, one {# file moves} other {# files move}} to “Unsorted”",
  "service.folderRow.deleteLabel": "Delete:",
  "service.folderRow.deleteWithFilesHint": "Permanently delete the folder along with {count, plural, one {# file} other {# files}}",
  "service.folderRow.folderNamePlaceholder": "Folder name …",
  "service.folderRow.folderOnly": "Folder only",
  "service.folderRow.newFolder": "New folder",
  "service.folderRow.renameFolder": "Rename folder",
  "service.folderRow.toggleHint": "Expand/collapse (double-click: rename)",
  "service.folderRow.withFiles": "With files",
  "service.folderRow.withFilesLoadingHint": "Available once all documents have loaded",
  "service.page.allInFolders": "Everything filed in folders",
  "service.page.bulkCv.addMore": "Add files",
  "service.page.bulkCv.addToCommunity": "Community",
  "service.page.bulkCv.addedToCommunity": "Added {n} to {names}",
  "service.page.bulkCv.analysePowers": "Analyse powers",
  "service.page.bulkCv.communitySubject": "{n} imported people",
  "service.page.bulkCv.desc": "Drop multiple CVs to create or update the corresponding profiles. Existing profiles are only filled where empty – nothing is overwritten.",
  "service.page.bulkCv.dupWarning": "CVs without an email create a new profile on every run. Avoid re-importing the same files.",
  "service.page.bulkCv.hint": "PDF, DOC, DOCX, TXT, RTF, HTML, images · max. 10 MB per file · up to 25 files",
  "service.page.bulkCv.importBtn": "Import {n, plural, one {# CV} other {# CVs}}",
  "service.page.bulkCv.importPhoto": "Import photo",
  "service.page.bulkCv.importing": "Importing {done}/{total} …",
  "service.page.bulkCv.openProfile": "profile",
  "service.page.bulkCv.outcomeCreated": "New",
  "service.page.bulkCv.outcomeFailed": "couldn't import",
  "service.page.bulkCv.outcomeUpdated": "Updated",
  "service.page.bulkCv.powerApplied": "{n, plural, one {# power applied} other {# powers applied}}",
  "service.page.bulkCv.powerApply": "Apply selected to profiles ({n})",
  "service.page.bulkCv.powerApplying": "Applying …",
  "service.page.bulkCv.powerDetails": "Details",
  "service.page.bulkCv.powerEmpty": "No powers found",
  "service.page.bulkCv.powerFailed": "Power analysis failed",
  "service.page.bulkCv.powerFiling": "Filing in the organizational record …",
  "service.page.bulkCv.powerHideDetails": "Hide details",
  "service.page.bulkCv.powerKeepOpen": "Keep this page open until the power analyses are done: proposals can only be applied here.",
  "service.page.bulkCv.powerQueued": "Power analysis waiting",
  "service.page.bulkCv.powerReady": "{n, plural, one {# power proposed} other {# powers proposed}}",
  "service.page.bulkCv.powerRunning": "Power analysis running …",
  "service.page.bulkCv.powerSelect": "Select the power proposal for {name}",
  "service.page.bulkCv.powerSelectAll": "Select all proposals",
  "service.page.bulkCv.powerUnsupported": "No power analysis: file type not supported",
  "service.page.bulkCv.rejected": "Some files were skipped (too large or unsupported type).",
  "service.page.bulkCv.summary": "{created} created, {updated} updated, {failed} failed",
  "service.page.bulkCv.title": "Import profiles",
  "service.page.bulkCv.tooMany": "You can import at most {max} files at once.",
  "service.page.bulkCv.willAddToCommunity": "New imports will be added to: {names}",
  "service.page.bulkCv.willAnalysePowers": "After the import, each CV goes into the person's organizational record and is analysed for powers (PDF, DOCX and images only).",
  "service.page.bulkCv.zone": "Drag CVs here or click to add",
  "service.page.bulkYaml.actionDry": "Validate",
  "service.page.bulkYaml.actionLabel": "Mode",
  "service.page.bulkYaml.actionReal": "Import",
  "service.page.bulkYaml.background": "Runs in background",
  "service.page.bulkYaml.batchDone": "All {n, number} files are uploaded. Processing continues in the background - you may leave this page.",
  "service.page.bulkYaml.batchFailed": "Failed",
  "service.page.bulkYaml.batchHide": "Hide result",
  "service.page.bulkYaml.batchLimit": "At most {max, number} files can be started in one batch. Split larger selections into multiple batches.",
  "service.page.bulkYaml.batchMixed": "Partially successful",
  "service.page.bulkYaml.batchOpen": "Show result",
  "service.page.bulkYaml.batchPending": "Pending",
  "service.page.bulkYaml.batchSuccess": "Successful",
  "service.page.bulkYaml.batchUploading": "Uploading file {n, number}… ({done, number} started)",
  "service.page.bulkYaml.capacityRejected": "The file could not be started because all import slots were occupied. It has not been checked yet.",
  "service.page.bulkYaml.completedAt": "Completed {date}",
  "service.page.bulkYaml.desc": "Import a multi-document YAML payload, or drop a PDF or CV for profile extraction. The job continues when you leave this page.",
  "service.page.bulkYaml.documentsFound": "{n, plural, one {# document} other {# documents}} found",
  "service.page.bulkYaml.downloadSchema": "Download JSON schema",
  "service.page.bulkYaml.downloadYaml": "Download YAML example",
  "service.page.bulkYaml.dryRunAtomicNote": "A validation always covers the whole file at once. Single units are not isolated here.",
  "service.page.bulkYaml.dryRunNoSave": "No data was saved. The transaction was deliberately rolled back.",
  "service.page.bulkYaml.dryRunSuccessTitle": "Validation successful",
  "service.page.bulkYaml.dryRunSummary": "{n, plural, one {# row} other {# rows}} would be affected",
  "service.page.bulkYaml.extractionDone": "Extraction finished",
  "service.page.bulkYaml.extractionFailed": "Extraction failed.",
  "service.page.bulkYaml.extractionOpen": "Open result",
  "service.page.bulkYaml.extractionResultHint": "The extracted powers and skills are in your own profile.",
  "service.page.bulkYaml.extractionRunning": "Extracting powers and skills …",
  "service.page.bulkYaml.failedPartial": "Import failed. Units that had already been committed were kept.",
  "service.page.bulkYaml.forbidden": "You lack permission to import this file. Import access is required; files containing people or reference data also require the corresponding editing permissions.",
  "service.page.bulkYaml.formatKindLabel": "Examples for",
  "service.page.bulkYaml.formatLimits": "Format {version} · at most {docs, number} documents per file · genesis format limit {size}.",
  "service.page.bulkYaml.formatLoadFailed": "The format description could not be loaded.",
  "service.page.bulkYaml.formatLoading": "Loading format …",
  "service.page.bulkYaml.formatTitle": "Format and examples",
  "service.page.bulkYaml.formatUnavailable": "The deployed importer did not describe this kind.",
  "service.page.bulkYaml.formatUploadLimit": "Spark upload limit: {size} per file. Larger files are rejected before the import starts.",
  "service.page.bulkYaml.hideYaml": "Hide YAML",
  "service.page.bulkYaml.hint": "YAML, PDF or DOCX · each file becomes its own import job",
  "service.page.bulkYaml.importBtn": "Run import",
  "service.page.bulkYaml.importBtnMany": "Run import for {n, number} files",
  "service.page.bulkYaml.indexing": "Checking the file …",
  "service.page.bulkYaml.jobIdHint": "Job ID, for support",
  "service.page.bulkYaml.leaveHint": "You may leave this page. A notification links back to this result.",
  "service.page.bulkYaml.limitsNote": "Maximum {docs, number} records per import · up to {files, number} files per batch · at most {size} per file.",
  "service.page.bulkYaml.limitsNoteSizeOnly": "Up to {files, number} files per batch · at most {size} per file.",
  "service.page.bulkYaml.modeAllOrNothing": "Abort completely",
  "service.page.bulkYaml.modeKeepSuccessful": "Keep successful",
  "service.page.bulkYaml.modeLabel": "On errors",
  "service.page.bulkYaml.newRun": "Choose another file",
  "service.page.bulkYaml.personActionsTitle": "Person changes",
  "service.page.bulkYaml.personCreate": "Create",
  "service.page.bulkYaml.personCreated": "New profile created",
  "service.page.bulkYaml.personDelete": "Delete",
  "service.page.bulkYaml.personDeleted": "Profile deleted",
  "service.page.bulkYaml.personExisting": "Existing",
  "service.page.bulkYaml.personIdGenerated": "The UUID is generated during the import.",
  "service.page.bulkYaml.personIdWasGenerated": "The UUID was generated during the import.",
  "service.page.bulkYaml.personIncoming": "Import",
  "service.page.bulkYaml.personMismatchNotice": "{n, plural, one {Running the import updates the existing person with this UUID. If that is not intended, correct the UUID in the file first.} other {Running the import updates the existing persons with these UUIDs. If that is not intended, correct the UUIDs in the file first.}}",
  "service.page.bulkYaml.personMismatchText": "Name and primary e-mail both differ from the stored person. The import updates the existing person with this UUID.",
  "service.page.bulkYaml.personMismatchTitle": "Possibly wrong person ID",
  "service.page.bulkYaml.personRestore": "Restore",
  "service.page.bulkYaml.personRestoreNotice": "{n, plural, one {Running the import restores this deleted profile. If that is not intended, remove the UUID from the file first.} other {Running the import restores these deleted profiles. If that is not intended, remove the UUIDs from the file first.}}",
  "service.page.bulkYaml.personRestoreResultText": "The profile was restored with the data contained in the YAML. Data not contained in the YAML was not restored.",
  "service.page.bulkYaml.personRestoreResultTitle": "Deleted profile was restored",
  "service.page.bulkYaml.personRestoreValidationText": "This UUID belongs to a deleted person. The import restores the profile data contained in the YAML. Data not contained in the YAML will not be restored.",
  "service.page.bulkYaml.personRestoreValidationTitle": "Deleted profile will be restored",
  "service.page.bulkYaml.personRestored": "Deleted profile restored",
  "service.page.bulkYaml.personRiskNotice": "Running the import applies the shown updates and restores the deleted profiles. If that is not intended, correct the UUIDs in the file first.",
  "service.page.bulkYaml.personRowLabel": "Person {n}: {action}",
  "service.page.bulkYaml.personUpdate": "Update",
  "service.page.bulkYaml.personUpdated": "Existing profile updated",
  "service.page.bulkYaml.personWillBeCreated": "New profile will be created",
  "service.page.bulkYaml.personWillBeUpdated": "Existing profile will be updated",
  "service.page.bulkYaml.pipelineLabel": "Import steps",
  "service.page.bulkYaml.problemDependency": "This document was skipped because a referenced document failed.",
  "service.page.bulkYaml.problemDependencyFix": "Fix the first failed document. This dependent document can then be imported automatically.",
  "service.page.bulkYaml.problemDocumentation": "Open format and example documentation ↓",
  "service.page.bulkYaml.problemDuplicate": "The ID or another unique value already exists.",
  "service.page.bulkYaml.problemDuplicateFix": "Use merge to update it. To create a new entry, omit the document's content.id or assign a new one.",
  "service.page.bulkYaml.problemFix": "How to fix it",
  "service.page.bulkYaml.problemInvalidFormat": "The YAML syntax or document structure is invalid.",
  "service.page.bulkYaml.problemInvalidFormatFix": "Check indentation, the document envelope, value types, and required blocks against an example.",
  "service.page.bulkYaml.problemInvalidReference": "A referenced entry cannot be found.",
  "service.page.bulkYaml.problemInvalidReferenceFix": "Use the UUID of an existing entry, or reference a document in this file through its metadata.name.",
  "service.page.bulkYaml.problemInvalidReferenceValue": "The referenced entry “{value}” cannot be found.",
  "service.page.bulkYaml.problemInvalidValue": "The value “{value}” is invalid.",
  "service.page.bulkYaml.problemInvalidValueFix": "Use the documented type, spelling, and permitted value range.",
  "service.page.bulkYaml.problemInvalidValueGeneric": "A value is missing, invalid, or outside the permitted range.",
  "service.page.bulkYaml.problemInvalidValueSuggestion": "Use “{value}” instead.",
  "service.page.bulkYaml.problemLocation": "Near line {line}",
  "service.page.bulkYaml.problemLocationColumn": "Near line {line}, column {column}",
  "service.page.bulkYaml.problemMissing": "The required field “{field}” is missing.",
  "service.page.bulkYaml.problemMissingAlternative": "At least one of these fields is required: {expected}.",
  "service.page.bulkYaml.problemMissingAlternativeFix": "Add at least one of the listed fields with a non-empty value.",
  "service.page.bulkYaml.problemMissingFix": "Add the field with a value of the type shown in the format documentation.",
  "service.page.bulkYaml.problemPersistence": "The database could not store this otherwise valid document.",
  "service.page.bulkYaml.problemPersistenceFix": "Retry once. If it fails again, give support the job ID shown above.",
  "service.page.bulkYaml.problemUnexpected": "The import failed for an unexpected technical reason.",
  "service.page.bulkYaml.problemUnexpectedFix": "Retry once. If it fails again, give support the job ID shown above.",
  "service.page.bulkYaml.problemUnknown": "The field “{field}” is not supported here.",
  "service.page.bulkYaml.problemUnknownField": "a required field",
  "service.page.bulkYaml.problemUnknownFix": "Rename or remove the field and compare the document with the format example.",
  "service.page.bulkYaml.problemUnknownFixExpected": "Rename or remove it. Supported fields include: {expected}.",
  "service.page.bulkYaml.problemPermissionDenied": "You do not have permission to import this company.",
  "service.page.bulkYaml.problemPermissionDeniedFix": "Creating a company requires company-creation access. Updating one requires an active admin membership in that company. Ask an administrator to check your access.",
  "service.page.bulkYaml.problemUnsupported": "This operation or field change is not supported for this document kind.",
  "service.page.bulkYaml.problemUnsupportedFix": "Use one of the operations listed for this kind and leave immutable fields unchanged.",
  "service.page.bulkYaml.problemWhat": "What is wrong",
  "service.page.bulkYaml.progress": "{done} of {total} documents processed{kind, select, none {} other { · {kind}}}",
  "service.page.bulkYaml.queued": "Waiting for processing",
  "service.page.bulkYaml.rejectedTooLarge": "Too large (over {max} per file): {names}",
  "service.page.bulkYaml.rejectedType": "Unsupported file type ({names}). Use .yaml or .yml.",
  "service.page.bulkYaml.retryBtn": "Fix file and retry",
  "service.page.bulkYaml.retryFile": "Retry",
  "service.page.bulkYaml.retrying": "Retrying …",
  "service.page.bulkYaml.rolledBack": "Import failed; all database changes were rolled back.",
  "service.page.bulkYaml.routeExtraction": "CV and PDF extraction",
  "service.page.bulkYaml.routeYaml": "YAML import",
  "service.page.bulkYaml.routingHint": "PDF and DOCX files go to CV extraction. Validation and partial import are YAML only.",
  "service.page.bulkYaml.runBadgeDry": "Validation · {mode}",
  "service.page.bulkYaml.runBadgeReal": "Import · {mode}",
  "service.page.bulkYaml.showYaml": "Show YAML",
  "service.page.bulkYaml.stageFile": "File",
  "service.page.bulkYaml.stageImport": "Import",
  "service.page.bulkYaml.stageQueue": "Queue",
  "service.page.bulkYaml.stageResult": "Result",
  "service.page.bulkYaml.startDry": "Run validation",
  "service.page.bulkYaml.startDryMany": "Run validation for {n, number} files",
  "service.page.bulkYaml.starting": "Starting …",
  "service.page.bulkYaml.stepStateActive": "in progress",
  "service.page.bulkYaml.stepStateDone": "done",
  "service.page.bulkYaml.stepStateFailed": "failed",
  "service.page.bulkYaml.stepStatePending": "not started yet",
  "service.page.bulkYaml.successTitle": "Import successful",
  "service.page.bulkYaml.summary": "{n, plural, one {# row} other {# rows}} affected",
  "service.page.bulkYaml.title": "File import",
  "service.page.bulkYaml.unitDeleteAria": "Delete {id}",
  "service.page.bulkYaml.unitDeletePersonMessage": "“{id}” will be deleted permanently, including all profile data. This removes the whole person, not just the imported changes.",
  "service.page.bulkYaml.unitDeletePersonTitle": "Delete person?",
  "service.page.bulkYaml.unitDeleteSharedItemMessage": "“{id}” will be deleted permanently, including all comments. This removes the whole post, not just the imported changes.",
  "service.page.bulkYaml.unitDeleteSharedItemTitle": "Delete post?",
  "service.page.bulkYaml.unitDeleted": "Deleted",
  "service.page.bulkYaml.unitDependencyFailed": "Not attempted, because a unit it depends on did not succeed.",
  "service.page.bulkYaml.unitDuplicate": "This entry already exists. Use “merge” instead of “insert” to update it, or remove it first.",
  "service.page.bulkYaml.unitInvalidInput": "The document was rejected: invalid or missing values.",
  "service.page.bulkYaml.unitInvalidReference": "A reference in the document does not exist.",
  "service.page.bulkYaml.unitPersistenceError": "The database refused this write.",
  "service.page.bulkYaml.unitTechnicalId": "Technical ID",
  "service.page.bulkYaml.unitTechnicalIdAria": "Show technical ID for {label}",
  "service.page.bulkYaml.unitUnexpectedError": "Unexpected error while importing this unit.",
  "service.page.bulkYaml.unitsFailed": "{n} failed",
  "service.page.bulkYaml.unitsFailedGroup": "Failed units",
  "service.page.bulkYaml.unitsSkipped": "{n} skipped",
  "service.page.bulkYaml.unitsSkippedGroup": "Skipped units",
  "service.page.bulkYaml.unitsSucceeded": "{n} succeeded",
  "service.page.bulkYaml.unitsSucceededGroup": "Succeeded units",
  "service.page.bulkYaml.warningBlobCleanup": "{n, plural, one {# uploaded file could not be removed again and remains stored.} other {# uploaded files could not be removed again and remain stored.}}",
  "service.page.bulkYaml.warningBlobCleanupHint": "An operator can remove them by hand using these storage ids.",
  "service.page.bulkYaml.zone": "Drag YAML, PDF or CV files here or click to add",
  "service.page.cardCvExtractorDesc": "Parses résumés and imports positions, skills and data in a structured way.",
  "service.page.cardCvExtractorTitle": "CV extractor",
  "service.page.cardCvGeneratorDesc": "Generates a résumé from profile data - appears on the right in DOCUMENTS.",
  "service.page.cardCvGeneratorTitle": "CV generator",
  "service.page.cardDatatransferDesc": "Exports your profile and grow data as a JSON file (GDPR Art. 20) - appears in DOCUMENTS and downloads immediately.",
  "service.page.cardDatatransferTitle": "Data transfer",
  "service.page.cardHardskillDesc": "Detects technical hard skills and tools from your profile and rates their level.",
  "service.page.cardHardskillTitle": "Hard skill analysis",
  "service.page.cardLinkedinDesc": "Imports profile, positions and skills directly from your LinkedIn account.",
  "service.page.cardLinkedinTitle": "LinkedIn import",
  "service.page.cardPowerProfilePdfDesc": "Exports your Power Profile as a PDF, with the sources of your choice side by side.",
  "service.page.cardPowerProfilePdfTitle": "Power Profile",
  "service.page.cardPowerDesc": "Identifies powers, skills and experience from free text and self-description.",
  "service.page.cardPowerTitle": "Power analysis",
  "service.page.cardYamlExportDesc": "Exports your entire profile including photos and documents as a YAML file that can be imported again.",
  "service.page.cardYamlExportTitle": "Complete profile",
  "service.page.clearSelection": "Clear selection",
  "service.page.confirmDelete": "Really delete?",
  "service.page.cvFallbackName": "CV",
  "service.page.cvNotMovable": "CV drafts cannot be moved into folders",
  "service.page.documentDeleteBlocked": "This document is still used in shared posts. Remove it there first:",
  "service.page.documentsCount": "{total, plural, one {# document} other {# documents}}",
  "service.page.documentsHint": "All files you have uploaded or generated through the profile services.",
  "service.page.documentsTitle": "Documents",
  "service.page.dropIntoFolder": "Drop to upload into this folder",
  "service.page.emptyDropHint": "Drag files here or click to upload",
  "service.page.errExportSave": "Export could not be saved.",
  "service.page.errFolderCreate": "Folder could not be created.",
  "service.page.errFolderLimit": "You have reached the maximum of {limit} folders.",
  "service.page.errFolderRename": "Folder could not be renamed.",
  "service.page.errMove": "Move failed.",
  "service.page.errNoContent": "No content available.",
  "service.page.errNotSignedInExport": "Not signed in - export not possible.",
  "service.page.errNotSignedInUpload": "Not signed in - upload not possible.",
  "service.page.errProfileLoad": "Profile data could not be loaded.",
  "service.page.errRename": "Rename failed.",
  "service.page.errUploadDuplicate": "Upload failed. A document with this name probably already exists.",
  "service.page.errUploadNameTaken": "Already in Documents, not uploaded again: {names}.",
  "service.page.errUploadTooLarge": "Too large (max. {max} per file): {names}.",
  "service.page.error": "Error: {message}",
  "service.page.exporting": "Exporting …",
  "service.page.filterFileType": "File type",
  "service.page.filterPlaceholder": "Filter your available documents …",
  "service.page.filterSource": "Source",
  "service.page.folderDeleteIncomplete": "{deleted, plural, =0 {No document deleted} one {# document deleted} other {# documents deleted}}, {kept, plural, other {# could not be deleted}}, so the folder stays.",
  "service.page.folderDeleteKeptShared": "still used in shared posts. Remove it there first:",
  "service.page.folderEmpty": "Folder is empty - drag documents onto the folder tile.",
  "service.page.hardskillAnalysisTitle": "Hard skill analysis",
  "service.page.imports.accountProvisioningHint": "Note: These imports create or update profiles. No login details are created, so imported people cannot sign in directly afterwards.",
  "service.page.inputTitle": "Build profile",
  "service.page.maxPerFile": "max. 10 MB per file",
  "service.page.moveToFolder": "Move to folder",
  "service.page.noDocuments": "No documents",
  "service.page.noFolders": "No folders available",
  "service.page.noMatches": "No matches",
  "service.page.noMatchesInFolder": "No matches in this folder",
  "service.page.onlyRealFilesMovable": "Only real files can be moved into folders, not CV generator entries.",
  "service.page.openBlockingSharedItem": "Open shared post {number}",
  "service.page.orDragAndDrop": "Or via drag & drop",
  "service.page.outputTitle": "Export profile",
  "service.page.powerAnalysisTitle": "Power analysis",
  "service.page.removeBlockingSelection": "Remove blocking selection",
  "service.page.reset": "Reset",
  "service.page.selectedCount": "{count} selected",
  "service.page.sourceCvGenerator": "CV generator",
  "service.page.sourceUpload": "File upload",
  "service.page.unsorted": "Unsorted",
  "service.page.uploadFile": "Upload file",
  "service.page.uploading": "Uploading …",
  "service.page.viewCompact": "Compact",
  "service.page.viewPreview": "Preview",
  "service.tour.filters.desc": "Filter your documents by name, source or file type, and switch between preview and compact view.",
  "service.tour.filters.title": "Search & filter",
  "service.tour.label": "Save Documents",
  "service.tour.list.desc": "{count} documents in {folders} folders. Open a folder to see its files, drag documents between folders, and hover a row to rename, select or delete it.",
  "service.tour.list.title": "Your documents",
  "service.tour.summary": "This is your documents page: {count} documents in {folders} folders, from manual uploads to generated CVs.",
  "service.tour.upload.desc": "Upload files here (max. 10 MB each), or simply drag and drop them onto a folder or the list below.",
  "service.tour.upload.title": "Upload files",
  "service.yamlExport.documents": "Documents",
  "service.yamlExport.documentsDesc": "Document folders and files, including metadata, tags and file content. Without Profile, the person must already exist when importing.",
  "service.yamlExport.download": "Download YAML",
  "service.yamlExport.exporting": "Exporting…",
  "service.yamlExport.intro": "Choose which areas to include in the export. You can import the downloaded file again with the YAML importer.",
  "service.yamlExport.profile": "Profile",
  "service.yamlExport.profileDesc": "Personal details, portraits, experience, education, skills, languages and certificates",
  "service.yamlExport.selectionRequired": "Select at least one area.",
  "service.yamlExport.title": "YAML export",
  "settings.account.delete.button": "Delete account",
  "settings.account.delete.confirm": "Delete permanently",
  "settings.account.delete.desc": "Your profile data, documents, contacts and groups are deleted and your login is revoked. This cannot be undone.",
  "settings.account.delete.dialogTitle": "Permanently delete account?",
  "settings.account.delete.placeholder": "Full name",
  "settings.account.delete.prompt": "Type your full name to confirm:",
  "settings.account.delete.retained": "Some content stays: chat messages, conversation history, published contributions and match and assessment results remain, no longer attached to your name.",
  "settings.account.delete.title": "Delete account",
  "settings.account.delete.zone": "Danger zone",
  "settings.eyebrow": "Platform configuration",
  "settings.heading": "Admin",
  "settings.intro": "Branding, managed reference data, questionnaires and appearance.",
  "settings.sectionAI": "AI",
  "settings.sectionAccessManagement": "Access management",
  "settings.sectionBranding": "Branding",
  "settings.sectionEmailTemplates": "Email templates",
  "settings.sectionFragebogen": "Questionnaires",
  "settings.sectionHrPrompt": "HR prompt",
  "settings.sectionLoginAssignment": "Login assignment",
  "settings.sectionRoster": "Import",
  "settings.sectionStammdaten": "Master data",
  "settings.sectionStyleguide": "Styleguide",
  "settings.styleguide.buttons.specimen.combined": "Combined",
  "settings.styleguide.modal.intro": "All three sizes share the scrim, ESC/backdrop close and the title/footer rows. The scrim always stays blurred and keeps a margin – the platform remains visible behind the dialog.",
  "settings.styleguide.modal.openFill": "Open fillViewport",
  "settings.styleguide.modal.openLarge": "Open large",
  "settings.styleguide.modal.openWindowed": "Open windowed",
  "settings.styleguide.section.modal": "Modal",
  "settings.upload.appearance.area": "Settings",
  "settings.upload.appearance.limit": "up to 5 MB",
  "settings.upload.appearance.note": "cropped to 640 × 160 and stored inline",
  "settings.upload.appearance.what": "Logo",
  "settings.upload.docs.area": "Save · Documents",
  "settings.upload.docs.limit": "10 MB per file",
  "settings.upload.docs.what": "File upload (PDF, DOCX, …)",
  "settings.upload.generalNote": "All uploads are base64-encoded and routed through the BFF, which allows max. 16 MB per request. Since base64 inflates the size by about 33 %, the actual file limits sit somewhat below that.",
  "settings.upload.profile.area": "Profile",
  "settings.upload.profile.limit": "5 MB",
  "settings.upload.profile.what": "Profile photo / avatar",
  "settings.upload.shareAttach.area": "Share · Attachments",
  "settings.upload.shareAttach.limit": "up to 16 MB",
  "settings.upload.shareAttach.note": "technical ceiling (BFF)",
  "settings.upload.shareAttach.what": "File attachments on items",
  "settings.upload.shareImage.area": "Share · Items",
  "settings.upload.shareImage.limit": "5 MB per image",
  "settings.upload.shareImage.what": "Cover image",
  "share.comment.saveFailed": "The comment could not be saved.",
  "share.create.actingAsCompany": "Posting as {company}. Leave the company context to post as yourself.",
  "share.create.attachmentsLabel": "Attachments",
  "share.create.authorLabel": "Author",
  "share.create.commentsAfterPublish": "Available after publishing.",
  "share.create.commentsLabel": "Comments",
  "share.create.createHeading": "{type, select, POST {New post} other {New project}}",
  "share.create.descriptionLabel": "Description",
  "share.create.descriptionPlaceholder": "{type, select, POST {Describe your post …} other {Describe your project …}}",
  "share.create.markdownHint": "Markdown works: **bold**, _italic_, lists and links. A pasted URL becomes clickable.",
  "share.create.markdownHintTitle": "Formatting",
  "share.create.editHeading": "{type, select, POST {Edit post} other {Edit project}}",
  "share.create.existingAttachment": "Attachment {n}",
  "share.create.existingImage": "Image {n}",
  "share.create.eyebrowCreate": "Create",
  "share.create.entryChoice.eyebrow": "SHARE · New",
  "share.create.entryChoice.title": "What do you want to make?",
  "share.create.entryChoice.postTitle": "Make a post",
  "share.create.entryChoice.postDesc": "Just report on something, no team search needed.",
  "share.create.entryChoice.projectTitle": "Create a project",
  "share.create.entryChoice.projectDesc": "Find a team, run a timeline, document progress.",
  "share.create.eyebrowEdit": "Edit",
  "share.create.eyebrowPreview": "Preview",
  "share.create.fromDocuments": "From my documents",
  "share.create.imagesLabel": "Images",
  "share.create.loadingFiles": "loading…",
  "share.create.mainImageBadge": "Preview",
  "share.create.mainImageHint": "Set as preview image",
  "share.create.noDescription": "No description.",
  "share.create.previewButton": "Preview",
  "share.create.previewHeading": "Here's how it looks",
  "share.create.publish": "Publish",
  "share.create.publishedAtLabel": "Published on",
  "share.create.ratingLabel": "Rating",
  "share.create.shortDescriptionLabel": "Short description",
  "share.create.shortDescriptionPlaceholder": "In one sentence: what is it about?",
  "share.create.statComments": "Comments",
  "share.create.statInterested": "Interested",
  "share.create.statPins": "Pins",
  "share.create.statRatings": "Ratings",
  "share.create.statViews": "Views",
  "share.create.titleLabel": "Title",
  "share.create.titlePlaceholder": "{type, select, POST {Title of the post} other {Title of the project}}",
  "share.create.tooLarge": "Too large (max. {max} MB per file): {names}",
  "share.create.typeLabel": "Type",
  "share.create.typePost": "Post",
  "share.create.typeProject": "Project",
  "share.create.unsupportedType": "Unsupported file type: {names}",
  "share.create.untitled": "Untitled",
  "share.docPicker.confirm": "Add {count}",
  "share.docPicker.empty": "No documents in your vault yet.",
  "share.docPicker.emptyImages": "No images in your documents yet.",
  "share.docPicker.hint": "Selected documents are attached to the post as a copy.",
  "share.docPicker.loadFailed": "Loading documents failed.",
  "share.docPicker.noMatches": "No matches",
  "share.docPicker.search": "Search documents",
  "share.docPicker.title": "Add from my documents",
  "share.docPicker.unnamedDocument": "Unnamed document",
  "share.itemDetail.alreadyRated": "You have already rated, tap again to change.",
  "share.itemDetail.attachmentDownloadFailed": "Download failed.",
  "share.itemDetail.attachmentOpenFailed": "Open failed.",
  "share.itemDetail.attachmentUnnamed": "Attachment",
  "share.itemDetail.attachments": "Attachments",
  "share.itemDetail.author": "Author",
  "share.itemDetail.commentAsCompany": "Commenting as {company}. Leave the company context to comment as yourself.",
  "share.itemDetail.commentEditedBy": "Edited by {editor} on {when}",
  "share.itemDetail.commentPlaceholder": "Write a comment…",
  "share.itemDetail.commentPublishedBy": "Published by {company}",
  "share.itemDetail.comments": "Comments",
  "share.itemDetail.deleteConfirm": "Delete?",
  "share.itemDetail.downloadAttachment": "Download {name}",
  "share.itemDetail.error": "Error: {message}",
  "share.itemDetail.expressInterest": "Express interest",
  "share.itemDetail.imageN": "Image {n}",
  "share.itemDetail.linkedMatchTitle": "Start a new match linked to this share item",
  "share.itemDetail.loading": "loading…",
  "share.itemDetail.more": "More",
  "share.itemDetail.newMatch": "New match ↗",
  "share.itemDetail.no": "No",
  "share.itemDetail.noComments": "No comments yet, be the first.",
  "share.itemDetail.noDescription": "No description",
  "share.itemDetail.noDescriptionHint": "no content provided",
  "share.itemDetail.notFound": "Post not found",
  "share.itemDetail.openAttachment": "Open {name}",
  "share.itemDetail.postedByOperator": "Posted by {name}",
  "share.itemDetail.publishedBy": "Published by",
  "share.itemDetail.publishedOn": "Published on",
  "share.itemDetail.rateYourselfTitle": "Click to rate it yourself",
  "share.itemDetail.rating": "Rating",
  "share.itemDetail.ratingClose": "close",
  "share.itemDetail.ratingOpen": "rate ›",
  "share.itemDetail.ratingsCount": "({count} ratings)",
  "share.itemDetail.send": "Send",
  "share.itemDetail.share": "Share",
  "share.itemDetail.shareWithIcon": "↗ Share",
  "share.itemDetail.signedUpWithdraw": "✓ Interested - withdraw",
  "share.itemDetail.starsAriaLabel": "{n} of 5 stars",
  "share.itemDetail.starsTitle": "{n, plural, one {# star} other {# stars}}",
  "share.itemDetail.statInterested": "Interested",
  "share.itemDetail.statPins": "Pins",
  "share.itemDetail.statViews": "Views",
  "share.itemDetail.thanks": "Thanks!",
  "share.itemDetail.tour.actions.desc": "Watch the item to follow it, or start a new match linked to it.",
  "share.itemDetail.tour.actions.projectDesc": "Watch the item to follow it, express interest to sign up as a participant, or start a new match linked to this project.",
  "share.itemDetail.tour.actions.title": "Get involved",
  "share.itemDetail.tour.content.desc": "Title, image gallery and full description of \"{name}\". Click the thumbnails to browse the images.",
  "share.itemDetail.tour.content.title": "The content",
  "share.itemDetail.tour.label": "Share Post",
  "share.itemDetail.tour.stats.desc": "The item's reach so far: {views} views, {pins} pins and {signUps} interested people.",
  "share.itemDetail.tour.stats.title": "How it's doing",
  "share.itemDetail.tour.summary": "You are looking at \"{name}\", a {type} from the Share community.",
  "share.itemDetail.unwatch": "✓ Watching - remove",
  "share.itemDetail.watch": "Watch",
  "share.itemDetail.yes": "Yes",
  "share.itemDetail.commentEmpty": "An empty comment cannot be saved.",
  "share.landing.carouselDiscussed": "Most comments",
  "share.landing.carouselInterest": "Most interested",
  "share.landing.carouselNew": "Newest",
  "share.landing.carouselTop": "Top rated",
  "share.landing.discoverAllPosts": "Discover all posts ↗",
  "share.landing.discoverEyebrow": "Discover",
  "share.landing.error": "Error: {message}",
  "share.landing.heroBody": "Publish projects and posts, gather interested people, feedback and reach. And discover what the community is currently building.",
  "share.landing.heroCta": "Create ↗",
  "share.landing.heroSubtitleLine1": "Show what you are working on.",
  "share.landing.heroSubtitleLine2": "Find who joins in.",
  "share.landing.loading": "loading…",
  "share.landing.myActivity": "My activity",
  "share.landing.myProjectsSection": "My projects & posts",
  "share.landing.next": "Next",
  "share.landing.noOwnPosts": "No own posts yet",
  "share.landing.noOwnPostsHint": "create a project or a post",
  "share.landing.noSharedItems": "No shared items available.",
  "share.landing.noShortDescription": "No short description.",
  "share.landing.nothingWatched": "Nothing watched or involved yet",
  "share.landing.nothingWatchedHint": "Watch projects & posts or get involved.",
  "share.landing.open": "Open ↗",
  "share.landing.previous": "Previous",
  "share.landing.share": "↗ Share",
  "share.landing.slide": "Slide {number}",
  "share.landing.statComments": "Comments",
  "share.landing.statInterested": "Interested",
  "share.landing.statRatings": "Ratings",
  "share.landing.statViews": "Views",
  "share.landing.tour.activity.desc": "The {count} items you are watching or signed up for, so you can get back to them quickly.",
  "share.landing.tour.activity.emptyDesc": "Items you watch or sign up for will collect here; nothing yet. Open an item and hit Watch or Express interest.",
  "share.landing.tour.activity.title": "Watched & involved",
  "share.landing.tour.activity.unknownDesc": "Items you watch or sign up for collect here, so you can get back to them quickly.",
  "share.landing.tour.carousel.desc": "Four curated top-5 lists: top rated, newest, most interested, most comments. Switch lists with the tabs; currently showing \"{featured}\". Click Open to jump into an item.",
  "share.landing.tour.carousel.title": "Discover",
  "share.landing.tour.create.desc": "Publish your own project or post here. Describe it, add images, and collect interested people.",
  "share.landing.tour.create.title": "Create something",
  "share.landing.tour.emptySummary": "This is Share, the community feed where people publish projects and posts, gather interested people and feedback.",
  "share.landing.tour.label": "Share",
  "share.landing.tour.mine.desc": "Your own {count} published items. 'View all' opens the full list where you can manage them.",
  "share.landing.tour.mine.emptyDesc": "Your own published items will appear here. You haven't created any yet.",
  "share.landing.tour.mine.title": "My projects & posts",
  "share.landing.tour.mine.unknownDesc": "Your own published items appear here. 'View all' opens the full list where you can manage them.",
  "share.landing.tour.summary": "This is Share, the community feed where people publish projects and posts, gather interested people and feedback. Right now \"{name}\" is in the spotlight.",
  "share.landing.viewAll": "View all ↗",
  "share.landing.watchedSection": "Watched & involved",
  "share.mine.emptyHint": "create a project or a post",
  "share.mine.emptyLabel": "No own posts yet",
  "share.mine.error": "Error: {message}",
  "share.mine.eyebrow": "SHARE · My posts",
  "share.mine.filterAll": "All",
  "share.mine.filterPosts": "Posts",
  "share.mine.filterProjects": "Projects",
  "share.mine.subtitle": "All your projects and posts.",
  "share.mine.title": "My posts",
  "share.mine.tour.filters.desc": "Narrow the list to Projects or Posts, and change the sort order on the right.",
  "share.mine.tour.filters.title": "Filter & sort",
  "share.mine.tour.items.desc": "{count} items. Click one to open it; as the owner you can edit or delete it from its detail page.",
  "share.mine.tour.items.emptyDesc": "Nothing here yet. Create a project or a post and it will show up in this grid.",
  "share.mine.tour.items.title": "Your items",
  "share.mine.tour.label": "Share Mine",
  "share.mine.tour.summary": "These are your own posts, everything you have published on Share. You have {count} items here right now.",
  "share.person.emptyLabel": "No posts to show",
  "share.person.eyebrow": "SHARE · Posts",
  "share.person.loadFailed": "Profile could not be loaded",
  "share.person.notFound": "Profile not found",
  "share.person.notFoundHint": "This profile does not exist or has not been shared with you.",
  "share.person.subtitle": "Projects and posts by {name} that you can see.",
  "share.person.title": "Posts by {name}",
  "share.person.titleUnknown": "Posts",
  "share.person.tour.items.desc": "{count} items. Click one to open it.",
  "share.person.tour.items.title": "Their items",
  "share.person.tour.label": "Share Person",
  "share.person.tour.summary": "What {name} has published on Share and you can see. There are {count} items here right now.",
  "share.landing.noProjects": "No project yet",
  "share.landing.noProjectsHint": "create one with the create button",
  "share.landing.projectBadge": "Project",
  "share.landing.projectsCount": "{count, plural, one {# project} other {# projects}}",
  "share.landing.projectsSection": "My projects",
  "skill.catAwareness": "Awareness & Learning",
  "skill.catImpact": "Create Impact & Influence",
  "skill.catPractical": "Practical Application & Skill Proficiency",
  "skill.desc.1": "You know basic concepts of this competency and have had first touchpoints with it, but do not yet use it practically.",
  "skill.desc.2": "You are actively building foundations in this competency and can handle first simple tasks with support and clear guidance.",
  "skill.desc.3": "You already use this competency in first practical situations and can complete simple tasks independently.",
  "skill.desc.4": "You use this competency regularly and can solve typical tasks reliably and independently.",
  "skill.desc.5": "You have deep practical experience and use this competency confidently in varied, complex, and demanding situations.",
  "skill.desc.6": "You are a recognized reference for this competency and strengthen others in applying it by effectively establishing best practices in the team or organization.",
  "skill.desc.7": "You develop forward-looking approaches for this competency and provide direction-setting impulses that lead to new standards.",
  "skill.infoLabel": "Level description",
  "skill.levelName.1": "Explorer",
  "skill.levelName.2": "Builder",
  "skill.levelName.3": "Contributor",
  "skill.levelName.4": "Practitioner",
  "skill.levelName.5": "Specialist",
  "skill.levelName.6": "Multiplier",
  "skill.levelName.7": "Pioneer",
  "skill.levelTitle.1": "Getting to know it & first touchpoints",
  "skill.levelTitle.2": "Focused development",
  "skill.levelTitle.3": "First practical applications",
  "skill.levelTitle.4": "Regular & reliable practical application",
  "skill.levelTitle.5": "Confident use in demanding contexts",
  "skill.levelTitle.6": "Empowering & developing others",
  "skill.levelTitle.7": "Shaping what is next & driving innovation",
  "sort.az": "A–Z",
  "sort.label": "Sort",
  "sort.nameAz": "Name A–Z",
  "sort.nameZa": "Name Z–A",
  "sort.new": "Newest",
  "sort.old": "Oldest",
  "sort.top": "Top rated",
  "stammdaten.agents": "AI agents",
  "stammdaten.teamprofil": "Power Scorecards",
  "stammdaten.values": "Dropdown values",
  "studio.back": "← All notebooks",
  "studio.deleteNotebook": "Delete notebook?",
  "studio.deleteNotebookMessage": "The notebook is deleted with all its notes.",
  "studio.description": "A place for loose thoughts, names and research finds.",
  "studio.emptyNotebook": "Everything starts with a first note. Add what you have; it does not need to be complete.",
  "studio.emptyPreview": "Room for your next idea.",
  "studio.localNotice": "Notebooks are saved automatically and only you can see them. You can export any of them as Markdown at any time.",
  "studio.textDone": "Done",
  "studio.namePlaceholder": "What are you collecting?",
  "studio.newNotebook": "New notebook",
  "studio.notFound": "This notebook does not exist (any more).",
  "studio.export": "Export",
  "studio.notePlaceholder": "Paste names, links, search results or your own thoughts here…",
  "studio.thought.inProgress": "In progress",
  "studio.compose": "Write a note or ask the assistant",
  "studio.addToNotebook": "Add to notebook",
  "studio.askAssistant": "Ask the assistant",
  "studio.editText": "Edit text",
  "studio.exportTitle": "Export notebook",
  "studio.exportWithAnswers": "With the assistant's answers",
  "studio.exportWithAnswersHint": "Your notes and the questions with their answers, in the notebook's order.",
  "studio.exportNotesOnly": "Only my notes",
  "studio.exportNotesOnlyHint": "Just what you wrote, without the assistant.",
  "studio.exportFinal": "Create a final version with the assistant",
  "studio.exportFinalHint": "The assistant sums up your notes. The result appears in the notebook, where you export it.",
  "studio.exportFinalFile": "Export as file",
  "studio.finalPrompt": "Write a final version of this notebook as Markdown from everything in it: my notes, the documents I brought in and the answers kept here, duplicates merged, ordered by topic, nothing they say left out and nothing added. Reply with the Markdown only.",
  "studio.proposalLabel": "Proposal",
  "studio.documentLabel": "Document",
  "studio.noteEdit": "Edit note",
  "studio.text": "Notebook text",
  "studio.notebooks": "Notebooks",
  "studio.open": "Open Studio",
  "studio.renameNotebook": "Rename notebook",
  "studio.storageError": "Your notebooks could not be saved or loaded. Please keep a copy of your text and try again.",
  "studio.title": "Studio",
  "studio.toRecords": "Turn into records",
  "studio.toRecordsPrompt": "Propose records from this notebook.",
  "studio.proposal.title": "Add from the notebook",
  "studio.proposal.createHint": "Creates them and notes their origin in each one's organizational record.",
  "studio.proposal.provenanceNoted": "Its origin is noted in its organizational record.",
  "studio.proposal.provenanceFailed": "Origin not noted in the organizational record: {reason}",
  "studio.provenance.title": "Taken over from the Studio",
  "studio.provenance.intro": "Created from the Studio notebook “{notebook}” on {date}.",
  "studio.provenance.introUnnamed": "Created from the Studio on {date}.",
  "studio.provenance.sources": "The passages it was taken from",
  "studio.provenance.noSources": "The card kept no passages to quote.",
  "studio.proposal.persons": "People",
  "studio.proposal.companies": "Companies",
  "studio.proposal.forbidden": "You are not allowed to create this record.",
  "studio.proposal.issueMandatory": "{field} is missing",
  "studio.proposal.issueFormat": "{field} has an invalid format",
  "studio.proposal.issueExists": "{field} is already in use",
  "studio.proposal.issueOther": "{field} was not accepted",
  "studio.proposal.possibleDuplicates": "Possibly already there:",
  "studio.proposal.create": "Create",
  "studio.proposal.creating": "Creating…",
  "studio.proposal.created": "Created.",
  "studio.proposal.rowNotTaken": "Not taken over: {reason}",
  "studio.proposal.rowFailed": "An entry could not be taken over.",
  "studio.proposal.keepToCreate": "Add the card to the notebook to create it.",
  "studio.proposal.noPersonRight": "You may not create people.",
  "studio.proposal.noCompanyRight": "You may not create companies.",
  "studio.proposal.field.email": "E-mail",
  "studio.proposal.field.jobTitle": "Job title",
  "studio.proposal.field.currentEmployer": "Employer",
  "studio.proposal.field.city": "City",
  "studio.proposal.field.website": "Website",
  "studio.proposal.field.phone": "Phone",
  "studio.proposal.field.summary": "Description",
  "studio.proposal.field.employeeCount": "Employees",
  "studio.proposal.field.experiences": "Experience",
  "studio.proposal.field.educations": "Education",
  "studio.proposal.today": "today",
  "suggestions.activities": "Suggest tasks",
  "suggestions.add": "Tap to add",
  "suggestions.addTask": "+ Add task",
  "suggestions.empty": "No suggestions found",
  "suggestions.loading": "Loading suggestions…",
  "suggestions.needJobTitle": "Enter a job title first",
  "suggestions.retry": "Try again",
  "suggestions.unavailable": "Suggestions currently unavailable",
  "teamProfile.confirmDelete.message": "The profile is removed for good and it will no longer be offered when designing a Match.",
  "teamProfile.confirmDelete.title": "Delete “{label}”?",
  "teamProfile.copyName.english": "{name} (copy)",
  "teamProfile.copyName.german": "{name} (Kopie)",
  "teamProfile.create.source": "Weights from an existing scorecard",
  "teamProfile.create.sourceNone": "None (weighted equally)",
  "teamProfile.create.sub": "Starts with every power weighted equally. Open the profile afterwards to tune the weights.",
  "teamProfile.create.subFrom": "Starts with the weights of “{name}”. Open the profile afterwards to tune the weights.",
  "teamProfile.create.submit": "Create profile",
  "teamProfile.create.title": "New profile",
  "teamProfile.delete": "Delete profile",
  "teamProfile.duplicate": "A profile with this name already exists.",
  "teamProfile.duplicateAction": "Duplicate",
  "teamProfile.empty": "No profiles yet.",
  "teamProfile.loading": "Loading…",
  "teamProfile.nameDe": "Name (German)",
  "teamProfile.nameEn": "Name (English)",
  "teamProfile.presetBadge": "Template",
  "teamProfile.presetHint": "Name and weights of this template are set by Smycles and cannot be changed. Create your own profile if you need different weights.",
  "teamProfile.reset": "Discard changes",
  "teamProfile.save": "Save",
  "teamProfile.saveFailed": "The profile could not be saved.",
  "teamProfile.sub": "Named weightings across the 30 powers, offered when designing a Match. Explore, Exploit and Ausgewogen are templates from Smycles: their name and weights are fixed.",
  "teamProfile.title": "Power Scorecards",
  "teamProfile.truncated": "Showing the first {shown} of {total} profiles. Delete or rename profiles you no longer need.",
  "teamProfile.weights": "Importance",
  "topbar.help.choiceNews": "Show what's new",
  "topbar.help.choiceTour": "Start the tour",
  "topbar.help.hint": "New here? Start the guided tour of the app with this button.",
  "topbar.help.hintDismiss": "Dismiss",
  "topbar.help.hintNews": "Something has changed since your tour. This button shows you what's new.",
  "topbar.help.label": "Start the guided tour",
  "unsavedGuard.body": "You have changes that haven't been saved yet. If you leave this page, they will be lost.",
  "unsavedGuard.discard": "Discard",
  "unsavedGuard.save": "Save",
  "unsavedGuard.stay": "Stay here",
  "unsavedGuard.title": "Unsaved changes",
  "userSettings.claude.adminInstallLink": "Open the pre-filled dialog for organization owners",
  "userSettings.claude.appDesc": "Add Smycles once as a connector in your Claude account, then it works across the Claude desktop app, the web app and mobile.",
  "userSettings.claude.appInternalHint": "Note: Claude connects from its own cloud, so this does not work on internal systems for now. The Smycles server has to be reachable from the public internet. Claude Code (below) works on internal systems today.",
  "userSettings.claude.appStep1": "In Claude, open Settings, then Connectors.",
  "userSettings.claude.appStep2": "Choose Add custom connector and paste the Server URL above.",
  "userSettings.claude.appStep3": "Open Advanced settings, enter the Client ID above, and leave the client secret empty.",
  "userSettings.claude.appStep4": "Add the connector, then Connect and sign in with your Smycles account.",
  "userSettings.claude.appTeamNote": "On Team and Enterprise plans an organization owner adds the connector once; everyone else only clicks Connect and signs in.",
  "userSettings.claude.appTitle": "Claude app (desktop, web and mobile)",
  "userSettings.claude.clientIdLabel": "Client ID",
  "userSettings.claude.codeDesc": "Run this command, then start Claude Code, run /mcp, choose smycles and select Authenticate. A browser window opens for the Smycles login.",
  "userSettings.claude.codeTitle": "Claude Code (for developers)",
  "userSettings.claude.commandLabel": "Command",
  "userSettings.claude.detailsTitle": "Connection details",
  "userSettings.claude.eyebrow": "Claude",
  "userSettings.claude.installAudience": "The button is for personal Claude accounts (Free, Pro and Max) and for organization owners on Team and Enterprise plans. On a Team or Enterprise plan without owner rights you don't need it: your organization owner adds the connector once, and Smycles then appears in your Claude under Settings → Connectors – just click Connect there.",
  "userSettings.claude.installButton": "Add to Claude",
  "userSettings.claude.installHint": "The button opens Claude with the name and Server URL already filled in – just confirm. Then continue with step 3 below: enter the Client ID under Advanced settings.",
  "userSettings.claude.intro": "Use your Smycles data and tools directly inside Claude. Claude sees exactly what you can see; you sign in with your normal Smycles account. This is separate from the assistant built into Smycles.",
  "userSettings.claude.noSecret": "No client secret is needed. Leave the secret field empty.",
  "userSettings.claude.title": "Connect Claude",
  "userSettings.claude.urlLabel": "Server URL",
  "userSettings.data.desc": "Export your profile and Grow data as a JSON file (GDPR Art. 20). Find data transfer in your profile under \"Service\".",
  "userSettings.data.link": "Go to data transfer ↗",
  "userSettings.data.title": "Data export",
  "userSettings.email": "Email",
  "userSettings.eyebrow": "Account · Preferences",
  "userSettings.heading": "Settings",
  "userSettings.identityTitle": "Identity",
  "userSettings.intro": "Manage your account, notifications and privacy.",
  "userSettings.language": "Language",
  "userSettings.languageHint": "Also used for AI generation.",
  "userSettings.mcpApp.appsTitle": "Apps",
  "userSettings.mcpApp.callbackHostLabel": "Callback host",
  "userSettings.mcpApp.callbackPortLabel": "Callback port",
  "userSettings.mcpApp.desktopStep1": "Connect to the company VPN. In Claude Desktop, enable Help → Troubleshooting → Enable Developer Mode, then open Developer → Configure Third-Party Inference.",
  "userSettings.mcpApp.desktopStep2": "In the Connection section, choose Anthropic API as the inference provider and enter your Anthropic API key. Skip this if Claude Desktop already runs in third-party mode.",
  "userSettings.mcpApp.desktopStep3": "Under Connectors, add a server: transport Streamable HTTP, URL from the list above.",
  "userSettings.mcpApp.desktopStep4": "Under OAuth choose Bring your own client and enter the Client ID from above plus the callback host and port below. Leave the client secret empty.",
  "userSettings.mcpApp.desktopStep5": "Apply the changes and restart Claude Desktop. Then open Settings → Connectors, Connect, and sign in with your Smycles account in the browser window.",
  "userSettings.mcpApp.externalDesc": "When this environment is reachable from the internet, every app is added in Claude as its own custom connector, separate from the main Smycles connector, using its URL from the list above.",
  "userSettings.mcpApp.externalTitle": "External environments – Claude app (desktop, web and mobile)",
  "userSettings.mcpApp.internalDesc": "On intranet environments (e.g. trunk), claude.ai and the standard Claude apps cannot connect: they dial from Anthropic's cloud, not from your device. Use Claude Desktop in third-party inference mode on the VPN instead. Every app is its own connector; use its URL from the list above.",
  "userSettings.mcpApp.internalTitle": "Internal environments – Claude Desktop on the VPN",
  "userSettings.mcpApp.intro": "Interactive Smycles apps rendered directly inside your Claude conversations. You sign in with your normal Smycles account, and each app sees exactly what you can see.",
  "userSettings.mcpApp.oauthDesc": "Connectors authenticate with OAuth: when you connect, Claude opens the Smycles sign-in, and the app then acts with exactly your permissions. All apps share the public client below.",
  "userSettings.mcpApp.oauthTitle": "Sign-in (OAuth)",
  "userSettings.mcpApp.title": "Apps in Claude",
  "userSettings.name": "Name",
  "userSettings.sectionAccount": "Account",
  "userSettings.sectionConnections": "Connections",
  "userSettings.sectionData": "Data & export",
  "userSettings.tour.content.accountDesc": "Your identity (name and email), the interface language (also used for AI generation) and, at the bottom, account deletion.",
  "userSettings.tour.content.dataDesc": "Export your profile and Grow data as a JSON file (GDPR Art. 20). The button hands you over to the data transfer.",
  "userSettings.tour.content.title": "The active section",
  "userSettings.tour.label": "Settings",
  "userSettings.tour.nav.desc": "Switch between Account (identity, language, deletion) and Data & export (your GDPR data export).",
  "userSettings.tour.nav.title": "The sections",
  "userSettings.tour.summary": "These are your account settings: identity, interface language, data export and account deletion.",
  "whatsNew.v0_1": "New in Smycles: connect the Claude apps to your data. This settings page shows you how, with the MCP endpoint, the client id and a step-by-step guide.",
  "agent.webSearch.unavailable": "Web search is unavailable or disabled for the current provider. No online search was performed. Turn off web search to search internally.",
  "agent.webSearch.failed": "Web search could not be performed. Please try again.",
  "agent.pubmed.unavailable": "PubMed search is unavailable or disabled here. No PubMed search was performed. Turn off PubMed to answer without it.",
  "agent.turn.stopped": "You stopped this answer. The question is still here: ask again, or refine it.",
  "agent.webSearch.label": "Web search",
  "agent.webSearch.on": "Web search on: your next message is searched online, then it turns off again.",
  "agent.webSearch.onPubmed": "PubMed search on: your next message is searched in PubMed, then it turns off again.",
  "agent.webSearch.off": "Web search off. Click to search online.",
  "agent.companyRoute.label": "Company search",
  "agent.companyRoute.title": "Company search: {mode}",
  "agent.labelThreshold.label": "Match threshold",
  "agent.labelThreshold.autoShort": "auto",
  "agent.labelThreshold.example": "Example: {word}",
  "agent.labelThreshold.floor": "Below {floor} every label matches: no two labels are less alike than that.",
  "agent.companyRoute.auto": "Automatic",
  "agent.companyRoute.both": "Labels and descriptions",
  "agent.companyRoute.rag": "Descriptions only",
  "agent.companyRoute.field": "Expertise labels only",
  "agent.studioNotebook.chip": "Notebook “{name}”",
  "save.community.types": "Community content",
  "save.community.companies": "Companies",
  "save.community.companiesDescription": "Discover companies and open their profiles.",
  "save.community.companyCount": "{count, plural, one {# company} other {# companies}}",
  "save.community.companiesEmpty": "No companies found.",
  "admin.groups.deleteBlocked.department": "This person group belongs to an organizational unit and is managed there.",
  "admin.groups.deleteBlocked.system": "This person group is required for automatic assignments and cannot be deleted.",
  "admin.groups.deleteBlocked.references": "This person group is still in use. Before deleting it, remove all memberships, role assignments and references to the group in sharing or scopes.",
  "admin.inspection.target": "Inspection target",
  "admin.inspection.person": "Person",
  "admin.inspection.group": "Person group",
  "admin.inspection.compare": "Compare",
  "admin.inspection.first": "First person",
  "admin.inspection.second": "Second person",
  "admin.inspection.pickBoth": "Choose two different people to compare.",
  "admin.inspection.differences": "Differences",
  "admin.inspection.all": "All permissions",
  "admin.inspection.compareSummary": "{total, plural, one {# permission} other {# permissions}} · {differences, plural, one {# difference} other {# differences}}",
  "admin.inspection.onlyFirst": "First person only",
  "admin.inspection.onlySecond": "Second person only",
  "admin.inspection.scopeDifference": "Different scope",
  "admin.inspection.personRelative": "Person-dependent scope",
  "admin.inspection.same": "Same assignment",
  "admin.inspection.originDifference": "Same scope, different origin",
  "admin.inspection.notAssigned": "Not assigned through roles",
  "admin.inspection.noDifferences": "No differences in assigned permissions, scopes and their origins.",
  "admin.inspection.openGroup": "Open person group",
  "admin.inspection.groupHint": "These roles apply to members of this person group. Managed-person scope is evaluated separately for each acting person. Roles from other groups also apply.",
  "admin.inspection.title": "Access inspection",
  "admin.inspection.intro": "Inspect a person, the roles of a person group, or compare two people.",
  "admin.inspection.search": "Find a person",
  "admin.inspection.searchHint": "Enter at least two characters. Results only include people whose profiles you may read.",
  "admin.inspection.select": "Inspect access",
  "admin.inspection.changePerson": "Choose another person",
  "admin.inspection.unavailable": "The inspection is unavailable.",
  "admin.inspection.summary": "{groups, plural, one {# person group} other {# person groups}} · {roles, plural, one {# role} other {# roles}} · {permissions, plural, one {# permission} other {# permissions}}",
  "admin.inspection.refresh": "Refresh",
  "admin.inspection.view": "Inspection view",
  "admin.inspection.permissions": "Permissions",
  "admin.inspection.groupsRoles": "Person groups & roles",
  "admin.inspection.filter": "Filter permissions",
  "admin.inspection.global": "Granted system-wide",
  "admin.inspection.scoped": "Limited to the scopes listed below",
  "admin.inspection.noPermissions": "No permissions assigned through roles.",
  "admin.inspection.noRoles": "No roles assigned.",
  "admin.inspection.noGroups": "No person group memberships.",
  "admin.inspection.limits": "This inspection shows current group and role access. Own content, personal sharing, individual projects, applications and Match actions have additional rules. A listed permission therefore does not mean unrestricted access to all content.",
  "admin.groups.title": "Person groups",
  "admin.groups.create": "Create person group",
  "admin.groups.edit": "Edit group",
  "admin.groups.empty": "Create a group to manage its members.",
  "admin.groups.deleteTitle": "Delete empty group?",
  "admin.groups.members": "Members",
  "admin.groups.organization": "Organizational assignment",
  "admin.groups.department": "Automatic department group",
  "admin.groups.departmentHint": "Includes people assigned directly to this department. Change their department to update membership. Use another group for exceptions.",
  "admin.groups.sourcesHint": "Manual and identity memberships are independent. Change identity membership in its source system.",
  "admin.groups.manual": "Manual",
  "admin.groups.identity": "Identity",
  "admin.groups.removeManual": "Remove manual membership",
  "admin.groups.noMembers": "This group has no members yet.",
  "admin.groups.addMember": "Add member",
  "admin.groups.searchPeople": "Search by name",
  "admin.groups.noPeople": "No visible people found.",
  "admin.groups.refineSearch": "Refine the name to find more people.",
  "admin.groups.removeHint": "Membership from identity synchronization remains in place.",
  "admin.groups.name": "Group name",
  "admin.groups.nameRequired": "Enter a group name.",
  "admin.groups.roles": "Roles and scopes",
  "admin.groups.role": "Role",
  "admin.groups.scope": "Scope",
  "admin.groups.scopeGroup": "People in group",
  "admin.groups.assignRole": "Assign role",
  "admin.groups.noRoles": "No roles assigned. Choose a role and its scope to give this group access.",
  "admin.groups.removeRole": "Remove role assignment",
  "admin.groups.removeRoleHint": "Other assignments may still provide the same access.",
  "admin.groups.scope.GLOBAL": "System-wide",
  "admin.groups.scope.GROUP_MEMBERS": "Members of a group",
  "admin.groups.scope.MANAGED_PEOPLE": "People managed by the acting person",
  "profile.sharing.groupCount": "{count, plural, one {# group} other {# groups}}",
  "profile.sharing.chooseGroups": "Share with person groups",
  "profile.sharing.noRecipients": "No groups are currently available for new sharing.",
  "profile.sharing.retired": "These groups are no longer selectable. Your existing shares remain active until you remove them.",
  "admin.groups.sharingEligible": "Can people select this group when sharing personal information?",
  "admin.groups.sharingHint": "Removing a group from the picker preserves existing shares.",
  "profile.sharing.sameAsBaseline": "Same as base setting",
  "profile.sharing.requiredGroup": "This group is required by the default sharing setting.",
  "profile.sharing.allReaders": "All",
  "profile.sharing.legacyPublic": "These details are currently readable by anyone, even without group membership. This access stays in place until you explicitly restrict it to groups.",
  "profile.sharing.legacyPublicMixed": "Some of these details are currently readable by anyone, even without group membership. This access stays in place until you explicitly restrict it to groups.",
  "profile.sharing.restrictToGroups": "Restrict to groups",
  "profile.sharing.allGroups": "Share with all groups",
  "profile.sharing.entries": "Base setting:",
  "profile.sharing.mixed": "Different Groups",
  "profile.sharing.publiclyReadable": "Anyone can read this content",
  "share.create.readershipTitle": "Who can read this content?",
  "share.create.publiclyReadableHint": "Anyone can read this content, including people who join later, regardless of their groups. Smycles currently requires sign-in.",
  "share.create.requiredGroup": "This group is required by the default sharing setting.",
  "profile.sharing.publiclyReadableHint": "Anyone can read this content, including people who join later, regardless of their groups. Smycles currently requires sign-in.",
  "share.create.requiredGroups": "Configured default Groups are included when you change Group sharing.",
  "share.create.titleRequired": "Add a title before saving.",
  "share.create.recipientsUnavailable": "The recipients are not available yet, so this cannot be saved.",
  "common.retry": "Retry",
  "profile.sharing.mixedVisibility": "Different visibility",
  "organizationalPower.running": "Analysing the documents. The profile stays unchanged until you apply the results.",
  "organizationalPower.failed": "The power analysis failed. Please try again.",
  "organizationalPower.review": "Review the proposed power scores. Applying them updates these scores in the profile.",
  "organizationalPower.empty": "No power scores could be determined from the selected documents.",
  "organizationalPower.applied": "The power scores have been applied to the profile.",
  "organizationalPower.apply": "Apply to profile",
  "organizationalPower.new": "New analysis",
  "organizationalPower.fromRecord": "From the organizational record",
  "organizationalPower.uploadDestination": "New files are saved in this organizational record.",
  "organizationalPower.uploading": "Uploading …",
  "organizationalPower.guidePerson": "This is about the person in this record. The analysis uses evidence it can attribute to this person. You review the results before applying them to their profile.",
  "organizationalPower.guideConcrete": "The documents describe how the person works: references, appraisals, feedback, project and role descriptions. A job title or a plain skills list provides no usable evidence.",
  "organizationalPower.background": "The analysis continues if you close this dialog.",
  "agent.progress.searchingPubmed": "Searching PubMed for \"{query}\"",
  "agent.progress.searchingPubmedAll": "Searching PubMed",
  "model.sources.usage": "In the Studio the assistant also searches these sources when the globe is on. The search term then goes to the source's provider.",
  "studio.sources.instead": "Search {source} instead of the web for this question",
  "studio.sources.onlySource": "The active AI provider offers no web search: this question searches {source}",
  "studio.proposal.field.givenName": "Given name",
  "studio.proposal.field.familyName": "Family name",
  "studio.proposal.field.name": "Name",
  "studio.proposal.field.degree": "Degree",
  "studio.proposal.field.subject": "Subject",
  "studio.proposal.field.institution": "Institution",
  "studio.proposal.field.from": "From",
  "studio.proposal.field.to": "To",
  "studio.proposal.done": "Done",
  "studio.proposal.nothing": "Nothing here is backed by the notebook, so there is nothing to take over.",
  "studio.orgRecord.title": "For the organizational record",
  "studio.orgRecord.person": "Person",
  "studio.orgRecord.company": "Company",
  "studio.orgRecord.noHit": "{subject, select, company {No company} other {No person}} found under this name. Correct the name.",
  "studio.orgRecord.pickCount": "{subject, select, company {Which company?} other {Which person?}} {count} found",
  "studio.orgRecord.pickFirst": "{subject, select, company {Pick the company first.} other {Pick the person first.}}",
  "studio.orgRecord.kind": "Kind",
  "studio.orgRecord.kindNote": "Note",
  "studio.orgRecord.kindReport": "Report",
  "studio.orgRecord.entryTitle": "Title",
  "studio.orgRecord.text": "Text",
  "studio.orgRecord.attach": "Attach the notebook as a document",
  "studio.orgRecord.attachFile": "The notebook as a document: {fileName}",
  "studio.orgRecord.entry": "Entry",
  "studio.orgRecord.filed": "Filed in the organizational record of {name}.",
  "studio.orgRecord.open": "Open the record",
  "studio.orgRecord.noRight": "You may not keep organizational records.",
  "studio.orgRecord.file": "File in the record",
  "studio.shortcut.enter": "Enter",
  "studio.shortcut.modEnter": "Cmd/Ctrl + Enter",
  "studio.composePlaceholder": "Type a note. Enter files it. Within 30 seconds a second Enter asks the assistant with it instead, arrow up takes it back to edit.",
  "studio.askInsteadHint": "Enter asks the assistant with the note just filed, arrow up takes it back to edit",
  "studio.key.enter": "Enter",
  "studio.tools": "Tools",
  "studio.tools.emptyHint": "First bring something into the notebook: a note, a document or an answer",
  "studio.document.bring": "Bring in a document",
  "studio.document.bringHint": "From your documents, read by OCR, as context",
  "studio.document.brought": "“{name}” is in the notebook.",
  "studio.document.pickTitle": "Bring in a document",
  "studio.document.pickHint": "From your documents. Its text is read (OCR for PDFs and images) and goes into the notebook as context.",
  "studio.document.reading": "Reading “{name}” …",
  "studio.document.noText": "No text could be read from this document.",
  "studio.document.open": "Open the document",
  "studio.toRecordsHint": "Propose people and companies",
  "studio.toOrgRecord": "File in an organizational record",
  "studio.toOrgRecordHint": "As a note about a person",
  "studio.toOrgRecordPrompt": "File the content of this notebook as a note in an organizational record. Ask me which person if it is not clear.",
  "studio.finalVersion": "Write a final version",
  "studio.finalVersionHint": "Merged and ordered, as Markdown",
  "studio.proposal.field.expertises": "Skills",
  "admin.access.workflow.intro": "Choose which groups may perform which tasks.",
  "admin.access.workflow.assign": "Assign a role",
  "admin.access.workflow.members": "Manage members",
  "admin.access.workflow.sharing": "Group membership does not share personal data. Recipients of personal sharing are selected separately.",
  "admin.groups.sections": "Group management",
  "admin.groups.sharingTab": "Sharing",
  "admin.roles.sections": "Role view",
  "admin.roles.permissionDetails": "Details for “{permission}”",
  "admin.roles.catalog": "Permission catalog",
  "admin.roles.catalogHint": "Select permissions for a new role. Below each permission you can see the roles that already include it.",
  "admin.roles.createFromSelection": "Create role from selection",
  "admin.roles.manageGroup": "Manage assignments for {name}",
  "admin.permission.read": "Read shared content",
  "admin.permission.read.person": "Read other people’s profiles",
  "admin.permission.write.person": "Edit other people’s profiles",
  "admin.permission.read.person-reference": "Read person references",
  "admin.permission.read.public-content": "Read public content",
  "admin.permission.read.external-information": "Read external people’s information",
  "admin.permission.read.managed-information": "Read information within your management scope",
  "admin.permission.create.company": "Create companies",
  "admin.permission.provision.invitee": "Invite people",
  "admin.permission.write.access-config": "Manage access",
  "admin.permission.write.import": "Import data",
  "admin.permission.write.questionnaire": "Manage questionnaires",
  "admin.permission.write.reference-data": "Manage reference data",
  "admin.permission.write.self-assessment": "Manage self-assessments",
  "admin.permission.read.organizational-record": "Read organizational records",
  "admin.permission.write.organizational-record": "Edit organizational records",
  "admin.permission.feature.grow": "Use GROW",
  "admin.permission.feature.search": "Use search",
  "admin.permission.feature.match": "Use MATCH",
  "admin.permission.feature.grow.map": "Use MAP",
  "admin.permission.feature.save.community": "Open community",
  "admin.permission.feature.share": "Use SHARE",
  "admin.permission.feature.share.projects": "Create projects in SHARE",
  "admin.permission.feature.grow.watch": "Use WATCH",
  "admin.permission.feature.grow.play": "Use PLAY",
  "admin.permission.feature.grow.play.self-assessments": "Show the per-Power self-assessments in PLAY",
  "admin.permission.feature.grow.play.games": "Show the games in PLAY",
  "admin.permission.feature.grow.play.games.toplist": "Show Top 10 in PLAY",
  "admin.permission.feature.grow.play.games.roleplay": "Show the roleplay in PLAY",
  "admin.permission.feature.save.profile": "Open profile",
  "admin.permission.feature.save.documents": "Open documents",
  "admin.permission.feature.save.pins": "Open pins",
  "admin.permission.feature.save": "Use SAVE",
  "admin.permission.feature.assistant": "Use assistant",
  "admin.permission.feature.chat": "Use chat",
  "admin.permission.feature.save.profile.powers-source": "Open power analysis sources",
  "admin.permission.feature.save.profile.powers-source.self": "Show the self-assessment in the Powers box",
  "admin.permission.feature.save.profile.powers-source.smart": "Show the smart analysis in the Powers box",
  "admin.permission.feature.save.profile.powers-source.combined": "Show the combined score in the Powers box",
  "admin.groups.rolesTab": "Roles",
  "admin.groups.anonymous.title": "Anonymous",
  "admin.groups.anonymous.fixed": "System-defined",
  "admin.groups.anonymous.intro": "Visitors who are not signed in, including people who have an account but are signed out.",
  "admin.groups.anonymous.visitors": "Visitors",
  "admin.groups.anonymous.visibility": "Visibility",
  "admin.groups.anonymous.members": "No account is identified while visiting anonymously. There is no person list, and members cannot be added or removed.",
  "admin.groups.anonymous.publicContent": "Anonymous visitors can read explicitly public projects, including their public descriptions and images.",
  "admin.groups.anonymous.privateContent": "Profiles, personal information, attachments and internal content are not part of this public access.",
  "admin.groups.anonymous.roles": "Anonymous visitors have no group memberships or assigned roles. Their public access is read-only and defined by the system. It cannot be extended by assigning a role here.",
  "admin.groups.anonymous.sparkLogin": "Smycles currently requires sign-in. There is no public browsing page in Smycles yet.",
  "admin.roles.personUnavailable": "Person details unavailable",
  "admin.role.access-config-admin.name": "Access administration",
  "admin.role.access-config-admin.description": "Manages groups, roles and permissions, and administrative imports.",
  "admin.role.company-creator.name": "Company creation",
  "admin.role.company-creator.description": "Allows creating companies. Administration of an existing company is assigned separately.",
  "admin.role.invitee-provisioner.name": "Invitee provisioning",
  "admin.role.invitee-provisioner.description": "Allows provisioning invited people.",
  "admin.role.organizational-record-manager.name": "Organizational record management",
  "admin.role.organizational-record-manager.description": "Allows reading and editing organizational records across the organization.",
  "admin.role.person-administrator.name": "Person administration",
  "admin.role.person-administrator.description": "Bundles administration of person data and organizational records. Included permissions are listed below.",
  "admin.role.questionnaire-administrator.name": "Questionnaire administration",
  "admin.role.questionnaire-administrator.description": "Manages questionnaires and self-assessments, including administrative imports.",
  "admin.role.reader.name": "Content reading",
  "admin.role.reader.description": "Allows reading content within the assigned access rules. Personal sharing remains separate.",
  "admin.role.reference-data-administrator.name": "Reference data administration",
  "admin.role.reference-data-administrator.description": "Manages reference data and administrative imports.",
  "admin.groups.verified": "Verified",
  "admin.groups.registered": "Registered",
  "admin.groups.systemGroups": "System-provided",
  "admin.groups.manualGroups": "Manually managed",
  "admin.groups.details": "Details",
  "admin.groups.verifiedHint": "Automatic membership is derived at sign-in from a confirmed internal identity or a verified email address in an approved domain. Registration alone does not qualify.",
  "admin.groups.registeredHint": "Signed-in people who do not qualify as Verified are automatically assigned to this group. Verified people are not automatically members of this group as well.",
  "admin.groups.identityMembershipHint": "Manual memberships may coexist with automatic memberships. The member list shows each source. Manual assignments remain independent of automatic ones.",
  "admin.groups.manualHint": "Members of this group are assigned explicitly here. Roles and personal sharing are managed separately.",
  "admin.membershipPolicy.title": "Automatic assignment",
  "admin.membershipPolicy.activeDomains": "Domains configured for “Verified”:",
  "admin.membershipPolicy.disabled": "No domains are currently configured. Email-domain assignment is disabled. “Verified” can still be assigned through internal sign-in.",
  "admin.membershipPolicy.unavailable": "The current domain configuration could not be loaded. Whether domain-based assignment is enabled is therefore unknown.",
  "admin.membershipPolicy.readOnly": "This configuration is read from Smycles. Changes are made in system configuration. Automatic membership is updated when a sign-in is next processed.",
  "admin.groups.sourceFilter": "Filter memberships",
  "admin.groups.allSources": "All",
  "admin.groups.memberSort": "Sort by",
  "admin.groups.nameAscending": "Name A–Z",
  "admin.groups.nameDescending": "Name Z–A",
  "admin.groups.manualFirst": "Manual first",
  "admin.groups.identityFirst": "Identity first",
  "admin.groups.noMatchingMembers": "No members with this membership source.",
  "admin.groups.loadingAllMembers": "Loading remaining members. Filters and sorting will be complete afterwards.",
  "admin.access.shortcuts.title": "Shortcuts",
  "admin.access.shortcuts.personGroups": "People groups",
  "admin.agents.confirmDelete.message": "The AI agent is removed for good and is no longer offered in matches. Matches that already name it keep their saved summary.",
  "admin.agents.confirmDelete.title": "Delete “{name}”?",
  "admin.agents.delete": "Delete AI agent",
  "admin.agents.empty": "No AI agents yet.",
  "admin.agents.english": "English",
  "admin.agents.german": "German",
  "admin.agents.model": "Model",
  "admin.agents.name": "Name",
  "admin.agents.new": "New AI agent",
  "admin.agents.problem.name": "The name is missing.",
  "admin.agents.problem.controlCharacters": "A field contains invisible control characters. Remove them and save again.",
  "admin.agents.problem.role": "The role is missing. One language is enough.",
  "admin.agents.problem.toolDescription": "Every tool needs a description in at least one language.",
  "admin.agents.problem.toolName": "Every tool needs a name.",
  "admin.agents.problem.vendor": "The vendor is missing.",
  "admin.agents.problem.url": "The product page must be a web address (http or https, no spaces, at most 128 characters).",
  "admin.agents.removeRow": "Remove row",
  "admin.agents.role": "Role",
  "admin.agents.saveFailed": "The AI agent could not be saved.",
  "admin.agents.toolDescription": "Description",
  "admin.agents.toolName": "Tool name",
  "admin.agents.url": "Product page",
  "admin.agents.vendor": "Vendor",
  "admin.inspection.compare.rightsCount": "{count, plural, one {# permission} other {# permissions}}",
  "admin.inspection.compare.rolesCount": "{count, plural, one {# role} other {# roles}}",
  "admin.inspection.compare.groupsCount": "{count, plural, one {# group} other {# groups}}",
  "admin.inspection.compare.shared": "{count} shared permissions",
  "admin.inspection.compare.only": "{count} permissions only for {name}",
  "admin.inspection.compare.sight": "Visibility",
  "admin.inspection.compare.capabilities": "Capabilities",
  "admin.inspection.compare.notGranted": "Not granted",
  "admin.inspection.compare.nothingSelected": "Select permissions, roles or groups to inspect.",
  "admin.inspection.compare.refresh": "Check again",
  "admin.inspection.compare.differences": "Differences only",
  "admin.inspection.compare.all": "All permissions",
  "admin.groups.primaryEmail": "Primary email address",
  "admin.roles.layout.features": "Areas & features",
  "admin.roles.layout.actions": "Data & actions",
  "admin.roles.layout.featureHint": "Controls which features this role enables. Data access is assigned separately.",
  "admin.roles.layout.featureHint.powersSource": "None selected: Combined",
  "admin.roles.layout.people": "People",
  "admin.roles.layout.records": "Organizational records",
  "admin.roles.layout.companies": "Companies",
  "admin.roles.layout.content": "Content",
  "admin.roles.layout.administration": "Administration",
  "admin.roles.layout.other": "Other actions",
  "admin.roles.layout.feature.save": "SAVE",
  "admin.roles.layout.feature.grow": "GROW",
  "admin.roles.layout.feature.share": "SHARE",
  "admin.roles.layout.feature.share.projects": "Create projects",
  "admin.roles.layout.feature.match": "MATCH",
  "admin.roles.layout.feature.tools": "TOOLS",
  "admin.roles.layout.feature.grow.map": "MAP",
  "admin.roles.layout.feature.grow.play": "PLAY",
  "admin.roles.layout.feature.grow.play.self-assessments": "Self-assessments",
  "admin.roles.layout.feature.grow.play.games": "Games",
  "admin.roles.layout.feature.grow.play.games.toplist": "Top 10",
  "admin.roles.layout.feature.grow.play.games.roleplay": "Roleplay",
  "admin.roles.layout.feature.grow.watch": "WATCH",
  "admin.roles.layout.feature.save.profile": "Profile",
  "admin.roles.layout.feature.save.profile.powers-source": "Power analysis sources",
  "admin.roles.layout.feature.save.documents": "Documents",
  "admin.roles.layout.feature.save.community": "Community",
  "admin.roles.layout.feature.save.pins": "Pins",
  "admin.roles.layout.feature.search": "Search",
  "admin.roles.layout.feature.assistant": "Assistant",
  "admin.roles.layout.feature.chat": "Chat",
  "admin.groups.chooseRole": "Choose a role",
  "admin.groups.chooseRoleFirst": "Choose a role first",
  "admin.groups.noSupportedScope": "No valid assignment available",
  "admin.groups.scopeHint.GLOBAL": "Applies system-wide to members of this group. Each permission retains its own business restrictions.",
  "admin.groups.scopeHint.GROUP_MEMBERS": "Permissions apply to people in the selected target group.",
  "admin.groups.scopeHint.MANAGED_PEOPLE": "Permissions apply to people within the acting group member’s own area of responsibility.",
  "admin.roles.layout.view": "View:",
  "admin.roles.layout.simple": "Simple",
  "admin.roles.layout.expert": "Expert",
  "admin.roles.manageAssignment": "Manage assignments",
  "admin.roles.managedScopeHint": "Requires the “Managed people” scope. Assign a separate role for additional rights. Permissions from multiple roles are combined.",
  "admin.roles.managedChecking": "Checking the scopes of existing assignments…",
  "admin.roles.managedCheckFailed": "Compatibility could not be checked. Reopen the role to retry.",
  "admin.roles.managedIncompatible": "Not available for these role assignments. This permission requires a separate role with the “Managed people” scope.",
  "admin.groups.sharingSelectionHint": "<on>On: The group is offered when sharing personal information.</on> <off>Off: It is no longer offered.</off> Existing shares are preserved. Turning this on does not itself give the group access.",
  "admin.groups.administratorsHint": "System administrator group with manually assigned memberships. At least one active person and a role with “Manage access” must remain. Add another active person before removing the last administrator.",
  "admin.groups.lastAdministrator": "At least one active administrator must remain. Add another active person first.",
  "admin.groups.lastAdministratorRole": "At least one role granting “Manage access” must remain assigned to this system group.",
  "admin.role.standard-administrators.name": "Administrators",
  "admin.role.standard-administrators.description": "Provided by Smycles as the default for administration. Personal sharing and domain responsibilities still apply.",
  "admin.role.standard-verified.name": "Verified",
  "admin.role.standard-verified.description": "Provided by Smycles as the default for core features.",
  "admin.role.standard-registered.name": "Registered",
  "admin.role.standard-registered.description": "Provided by Smycles as the default for core features.",
  "grow.about.approach": "The Smycles framework draws on research into personality and human behavior, including established models such as the Big Five and HEXACO, as well as widely used personality assessments such as MBTI and DISC. While these approaches provide reference points, the 30 Powers and their organization into six clusters are specific to Smycles. The framework considers how individual tendencies interact with circumstances, experiences, and learned behaviors.",
  "grow.about.approachTitle": "Research and development",
  "grow.about.author": "Dr. Bernhard Zünkeler",
  "grow.about.authorName": "Bernhard Zünkeler",
  "grow.about.attribution": "Smycles’ <concept>Powers concept</concept> draws on {author}’s work.",
  "grow.about.book.atlas": "Juicy Gray – Atlas der Kreativität",
  "grow.about.book.innovation": "Innovationskraft in Unternehmen – Impulse für mehr Innovationsfähigkeit, Performanz und Zukunftsfähigkeit",
  "grow.about.book.newWork": "New Work: Auf dem Weg zur neuen Arbeitswelt – Management-Impulse, Praxisbeispiele, Studien",
  "grow.about.coAuthor": "co-author",
  "grow.about.contributor": "contributor",
  "grow.about.development": "Research on attention, empathy, and improvisation informs the development of Power definitions and assessment questions. Smycles also brings together perspectives from psychology, biology, neuroscience, philosophy, and practical experience to explore human creativity and collaboration. Further studies are planned to examine the assessment's reliability and its potential value for understanding teamwork.",
  "grow.about.intro": "People bring different ways of thinking, acting, and relating to others into a team. Smycles explores these differences through 30 Powers, a framework for understanding individual working styles and how they interact. Rather than placing people into fixed personality types, the Powers provide a shared language for understanding team chemistry.",
  "grow.about.origins": "The framework builds on {author}'s work on creativity and team composition. Smycles continues to develop these ideas into Power definitions, assessment questions, and a framework for understanding collaboration.",
  "grow.about.originsTitle": "Origins of the framework",
  "grow.about.structure": "The Smycles framework organizes 30 Powers into six clusters, each containing five Powers. These clusters describe different aspects of how people respond to challenges, pursue goals, explore ideas, and collaborate.",
  "grow.about.structureTitle": "30 Powers, six clusters",
  "grow.about.title": "Powers and team chemistry",
  "grow.assess.documentsCountHint": "Across your Power Profile, counting each document once. Only documents with stored Powers evidence count; uploads and analyses with no findings are not included.",
  "grow.assess.introQuestionnaires": "Explore your <concept>Powers</concept> through questionnaires. Choose where to start or continue.",
  "grow.assess.introSelf": "Explore your <concept>Powers</concept> through questionnaires and self-assessments. Choose where to start or continue.",
  "grow.assess.powerQuizDescription": "A good starting point to explore your Powers. Answer {count} statements about yourself.",
  "grow.assess.powerQuizEyebrow": "A guided self-assessment",
  "grow.assess.powerQuizReview": "Review Power Quiz",
  "grow.powerDetail.selfScoreSources": "This score uses your available answers from Power Quiz, other questionnaires and in-depth self-assessment.",
  "grow.powerDetail.quiz.done": "Power Quiz done",
  "grow.powerDetail.quiz.inProgress": "Power Quiz in progress",
  "grow.powerDetail.quiz.missing": "Power Quiz missing",
  "grow.powerDetail.quiz.complete": "Power Quiz completed.",
  "grow.powerDetail.quiz.incomplete": "Power Quiz not completed.",
  "grow.powerDetail.quiz.includedHint": "Your Power Quiz answers for this Power are included in the self-assessment score.",
  "grow.powerDetail.quiz.notIncludedHint": "There are no scored Power Quiz answers for this Power yet.",
  "grow.powerDetail.quiz.start": "Start Power Quiz",
  "grow.powerDetail.quiz.continue": "Continue Power Quiz",
  "grow.about.cluster.Re": "Resilience describes how people maintain focus, adapt to change, and respond to pressure or setbacks.",
  "grow.about.cluster.Ro": "Result Orientation describes how people set goals, plan their work, take responsibility, and follow through to achieve results.",
  "grow.about.cluster.Fo": "Future Orientation describes how people imagine possibilities, think beyond current circumstances, and approach uncertain situations with courage and conviction.",
  "grow.about.cluster.In": "Inventiveness describes how people explore questions, generate ideas, and respond creatively and independently to unfamiliar situations.",
  "grow.about.cluster.Ts": "Teamability describes how people understand others, respect differences, and develop relationships built on trust, commitment, and fairness.",
  "grow.about.cluster.Co": "Communication describes how people recognize their own feelings and others' signals, express themselves, and develop shared understanding.",
  "grow.about.workingStyles": "For example, one person may prefer uninterrupted time for focused work, while another responds quickly to changing priorities. Recognizing these differences can help teammates communicate their needs, coordinate their work, and build stronger relationships.",
  "grow.about.publications": "{authorName}'s publications and contributions include:",
  "match.teamContext.chooseMembers": "Choose people",
  "match.teamContext.enable": "Use team context",
  "match.teamContext.incomplete": "Incomplete",
  "match.teamContext.missingMembers": "Team-Fit is not calculated without an existing team.",
  "match.teamContext.missingScorecard": "Team-Fit is not calculated without a Power Scorecard.",
  "match.teamContext.missingWeights": "Give at least one power a weight to calculate Team-Fit.",
  "match.teamContext.title": "Team-Fit",
  "match.teamContext.toggleHint": "Every candidate also gets a team contribution: how much of what this team is still missing they cover. Measured against the team Power Scorecard, where powers the team is thin on count for more. Calculated automatically for every candidate.",
  "match.teamFit.add": "Add",
  "match.teamFit.added": "Added",
  "match.teamFit.badgeTooltip": "Team contribution: what this person adds to the existing team, not how strong they are themselves.",
  "match.teamFit.contributionScore": "Covers {score}% of what this team is still missing",
  "match.teamFit.elementDelta": "Team {from} → {to}",
  "match.teamFit.measuredMembers": "Based on {measured} of {total} members with usable power values",
  "match.teamFit.pickerTitle": "Current team",
  "match.teamFit.remove": "Remove {name}",
  "match.teamFit.resultTitle": "Team-Fit",
  "match.teamFit.roleScorecardLabel": "Role Power Scorecard",
  "match.teamFit.savedSets": "Groups and pins",
  "match.teamFit.scorecardLabel": "Team Power Scorecard",
  "match.teamFit.scorecardPlaceholder": "Select",
  "match.teamFit.searchPlaceholder": "Search by name",
  "match.teamFit.sortHint": "A/B/C groups use Team-Fit when this sort is selected. Role must-have requirements still apply.",
  "match.teamFit.summary": "Current team: {count} people · Team Power Scorecard: {scorecard}",
  "match.teamFit.unavailable": "Team contribution cannot be assessed: comparable power evaluations are missing, or the existing team is already at the ceiling.",
  "match.teamFit.sortUnavailable": "No existing team selected, so Team-Fit is not calculated for this Match. The existing team is chosen in the first step.",
  "common.sortable.cancelled": "{item}: cancelled, back at position {position} of {total}.",
  "common.sortable.dropped": "{item} dropped at position {position} of {total}.",
  "common.sortable.handle": "Move {item}",
  "common.sortable.moved": "{item}: position {position} of {total}",
  "common.sortable.picked": "{item} picked up at position {position} of {total}. Move it with the arrow keys, drop it with Enter, cancel with Escape.",
  "grow.games.toplist.discover.changeTags": "Change categories",
  "grow.games.toplist.discover.picks": "Your picks",
  "grow.games.toplist.discover.progress": "{count} of {keep}",
  "grow.games.toplist.discover.progressLabel": "Picks for your top {keep}",
  "grow.games.toplist.discover.skip": "None of these",
  "grow.games.toplist.next": "Next",
  "grow.games.toplist.ownEntry": "Your own entry",
  "grow.games.toplist.remove": "Remove {title}",
  "grow.games.toplist.result.full": "To add another, take one off your list first.",
  "grow.games.toplist.result.hint": "Drag to reorder, or tap one and then tap its new place.",
  "grow.games.toplist.result.missing": "{missing} more for your top {keep}",
  "grow.games.toplist.result.moreRounds": "More suggestions",
  "grow.games.toplist.result.passed": "Not picked",
  "grow.games.toplist.result.placeHint": "Tap the new place for {item}.",
  "grow.games.toplist.result.showAll": "Show all {count}",
  "grow.games.toplist.search.label": "Missing one?",
  "grow.games.toplist.search.noMatch": "Nothing found.",
  "grow.games.toplist.search.placeholder.BOOK": "Search book titles",
  "grow.games.toplist.search.placeholder.CITY": "Search cities",
  "grow.games.toplist.search.placeholder.DISH": "Search dishes",
  "grow.games.toplist.search.placeholder.HOBBY": "Search hobbies",
  "grow.games.toplist.search.placeholder.MOVIE": "Search movie titles",
  "grow.games.toplist.search.placeholder.MUSIC_ARTIST": "Search artists or bands",
  "grow.games.toplist.search.placeholder.SERIES": "Search series titles",
  "grow.games.toplist.search.placeholder.SPORT": "Search sports",
  "grow.games.toplist.search.takeOwn": "Take “{title}” as your own entry",
  "grow.games.toplist.tag.BOOK.CHILDREN": "Children & young adult",
  "grow.games.toplist.tag.BOOK.CLASSIC": "Classic",
  "grow.games.toplist.tag.BOOK.CRIME": "Crime",
  "grow.games.toplist.tag.BOOK.FANTASY": "Fantasy",
  "grow.games.toplist.tag.BOOK.HISTORY": "History",
  "grow.games.toplist.tag.BOOK.NONFICTION": "Non-fiction",
  "grow.games.toplist.tag.BOOK.NOVEL": "Novel",
  "grow.games.toplist.tag.BOOK.PHILOSOPHY": "Philosophy",
  "grow.games.toplist.tag.BOOK.PLAY": "Play",
  "grow.games.toplist.tag.BOOK.POETRY": "Poetry & epic",
  "grow.games.toplist.tag.BOOK.SCIENCE_FICTION": "Science fiction",
  "grow.games.toplist.tag.CITY.AFRICA": "Africa",
  "grow.games.toplist.tag.CITY.ASIA": "Asia",
  "grow.games.toplist.tag.CITY.EUROPE": "Europe",
  "grow.games.toplist.tag.CITY.NORTH_AMERICA": "North America",
  "grow.games.toplist.tag.CITY.OCEANIA": "Oceania",
  "grow.games.toplist.tag.CITY.SOUTH_AMERICA": "South America",
  "grow.games.toplist.tag.DISH.AMERICAN": "North American",
  "grow.games.toplist.tag.DISH.BRITISH": "British & Irish",
  "grow.games.toplist.tag.DISH.CHINESE": "Chinese",
  "grow.games.toplist.tag.DISH.EASTERN_EUROPEAN": "Eastern European",
  "grow.games.toplist.tag.DISH.FRENCH": "French",
  "grow.games.toplist.tag.DISH.GERMAN": "German-speaking",
  "grow.games.toplist.tag.DISH.GREEK": "Greek",
  "grow.games.toplist.tag.DISH.INDIAN": "Indian",
  "grow.games.toplist.tag.DISH.INTERNATIONAL": "International",
  "grow.games.toplist.tag.DISH.ITALIAN": "Italian",
  "grow.games.toplist.tag.DISH.JAPANESE": "Japanese",
  "grow.games.toplist.tag.DISH.KOREAN": "Korean",
  "grow.games.toplist.tag.DISH.LATIN_AMERICAN": "Latin American",
  "grow.games.toplist.tag.DISH.MIDDLE_EASTERN": "Middle Eastern & North African",
  "grow.games.toplist.tag.DISH.SOUTHEAST_ASIAN": "Southeast Asian",
  "grow.games.toplist.tag.DISH.SPANISH": "Spanish",
  "grow.games.toplist.tag.DISH.TURKISH": "Turkish",
  "grow.games.toplist.tag.HOBBY.COLLECTING": "Collecting",
  "grow.games.toplist.tag.HOBBY.CRAFT": "Craft",
  "grow.games.toplist.tag.HOBBY.CREATIVE": "Creative",
  "grow.games.toplist.tag.HOBBY.DIGITAL": "Digital",
  "grow.games.toplist.tag.HOBBY.MIND": "Mind",
  "grow.games.toplist.tag.HOBBY.OUTDOOR": "Outdoor",
  "grow.games.toplist.tag.HOBBY.SOCIAL": "Social",
  "grow.games.toplist.tag.MOVIE.ACTION": "Action",
  "grow.games.toplist.tag.MOVIE.ADVENTURE": "Adventure",
  "grow.games.toplist.tag.MOVIE.ANIMATION": "Animation",
  "grow.games.toplist.tag.MOVIE.BIOGRAPHY": "Biography",
  "grow.games.toplist.tag.MOVIE.COMEDY": "Comedy",
  "grow.games.toplist.tag.MOVIE.CRIME": "Crime",
  "grow.games.toplist.tag.MOVIE.DRAMA": "Drama",
  "grow.games.toplist.tag.MOVIE.FAMILY": "Family",
  "grow.games.toplist.tag.MOVIE.FANTASY": "Fantasy",
  "grow.games.toplist.tag.MOVIE.HISTORY": "History",
  "grow.games.toplist.tag.MOVIE.HORROR": "Horror",
  "grow.games.toplist.tag.MOVIE.MUSICAL": "Music film",
  "grow.games.toplist.tag.MOVIE.MYSTERY": "Mystery",
  "grow.games.toplist.tag.MOVIE.ROMANCE": "Romance",
  "grow.games.toplist.tag.MOVIE.SCIENCE_FICTION": "Science fiction",
  "grow.games.toplist.tag.MOVIE.THRILLER": "Thriller",
  "grow.games.toplist.tag.MOVIE.WAR": "War",
  "grow.games.toplist.tag.MOVIE.WESTERN": "Western",
  "grow.games.toplist.tag.MUSIC_ARTIST.BLUES": "Blues",
  "grow.games.toplist.tag.MUSIC_ARTIST.CLASSICAL": "Classical",
  "grow.games.toplist.tag.MUSIC_ARTIST.COUNTRY": "Country",
  "grow.games.toplist.tag.MUSIC_ARTIST.ELECTRONIC": "Electronic",
  "grow.games.toplist.tag.MUSIC_ARTIST.FOLK": "Folk",
  "grow.games.toplist.tag.MUSIC_ARTIST.HIP_HOP": "Hip-hop",
  "grow.games.toplist.tag.MUSIC_ARTIST.JAZZ": "Jazz",
  "grow.games.toplist.tag.MUSIC_ARTIST.METAL": "Metal",
  "grow.games.toplist.tag.MUSIC_ARTIST.POP": "Pop",
  "grow.games.toplist.tag.MUSIC_ARTIST.REGGAE": "Reggae",
  "grow.games.toplist.tag.MUSIC_ARTIST.ROCK": "Rock",
  "grow.games.toplist.tag.MUSIC_ARTIST.SOUL_RNB": "Soul & R&B",
  "grow.games.toplist.tag.SERIES.ACTION": "Action",
  "grow.games.toplist.tag.SERIES.ADVENTURE": "Adventure",
  "grow.games.toplist.tag.SERIES.ANIMATION": "Animation",
  "grow.games.toplist.tag.SERIES.COMEDY": "Comedy",
  "grow.games.toplist.tag.SERIES.CRIME": "Crime",
  "grow.games.toplist.tag.SERIES.DRAMA": "Drama",
  "grow.games.toplist.tag.SERIES.FAMILY": "Family",
  "grow.games.toplist.tag.SERIES.FANTASY": "Fantasy",
  "grow.games.toplist.tag.SERIES.HISTORY": "History",
  "grow.games.toplist.tag.SERIES.HORROR": "Horror",
  "grow.games.toplist.tag.SERIES.MUSICAL": "Music",
  "grow.games.toplist.tag.SERIES.ROMANCE": "Romance",
  "grow.games.toplist.tag.SERIES.SCIENCE_FICTION": "Science fiction",
  "grow.games.toplist.tag.SERIES.THRILLER": "Thriller",
  "grow.games.toplist.tag.SPORT.BALL": "Ball sport",
  "grow.games.toplist.tag.SPORT.COMBAT": "Combat sport",
  "grow.games.toplist.tag.SPORT.ENDURANCE": "Endurance sport",
  "grow.games.toplist.tag.SPORT.INDIVIDUAL": "Individual sport",
  "grow.games.toplist.tag.SPORT.MIND": "Mind sport",
  "grow.games.toplist.tag.SPORT.MOTORSPORT": "Motorsport",
  "grow.games.toplist.tag.SPORT.RACKET": "Racket sport",
  "grow.games.toplist.tag.SPORT.TEAM": "Team sport",
  "grow.games.toplist.tag.SPORT.WATER": "Water sport",
  "grow.games.toplist.tag.SPORT.WINTER": "Winter sport",
  "grow.games.toplist.tags.all": "Everything",
  "grow.games.toplist.tags.hint": "Pick as many categories as you like, or everything.",
  "grow.games.toplist.tags.question.BOOK": "What do you like to read most?",
  "grow.games.toplist.tags.question.CITY": "Where are you drawn to?",
  "grow.games.toplist.tags.question.DISH": "What do you like to eat most?",
  "grow.games.toplist.tags.question.HOBBY": "What do you like doing most?",
  "grow.games.toplist.tags.question.MOVIE": "Which movies do you like best?",
  "grow.games.toplist.tags.question.MUSIC_ARTIST": "What do you like to listen to most?",
  "grow.games.toplist.tags.question.SERIES": "Which series do you like best?",
  "grow.games.toplist.tags.question.SPORT": "Which sport excites you?",
  "grow.games.toplist.genus.BOOK": "other",
  "grow.games.toplist.genus.CITY": "other",
  "grow.games.toplist.genus.DISH": "other",
  "grow.games.toplist.genus.HOBBY": "other",
  "grow.games.toplist.genus.MOVIE": "other",
  "grow.games.toplist.genus.MUSIC_ARTIST": "other",
  "grow.games.toplist.genus.SERIES": "other",
  "grow.games.toplist.genus.SPORT": "other",
  "common.progressCount": "{done, number} / {total, number}",
  "settings.styleguide.section.stateCues": "State cues",
  "settings.styleguide.selectedExample": "Selected card",
  "settings.styleguide.dropExample": "Drop target",
  "settings.styleguide.pressedExample": "Pressed symbol",
  "settings.styleguide.pillsPurpose": "Pick one option. Selection uses a neutral 6% track-ink wash, a small shadow and a semibold label with reserved width.",
  "admin.permission.compare.profiles": "Compare profiles",
  "profile.compare.addPerson": "Add person to comparison",
  "profile.compare.title": "Compare profiles",
  "profile.compare.tools": "Profile tools",
  "profile.compare.selectDescription": "Select this profile to compare two profiles side by side.",
  "profile.compare.removeDescription": "Remove this profile from your comparison selection.",
  "profile.compare.select": "Select for comparison",
  "profile.compare.remove": "Remove from comparison",
  "profile.compare.removeName": "Remove {name} from comparison",
  "profile.compare.count": "Comparison {count}/2",
  "profile.compare.unnamed": "Unnamed profile",
  "profile.compare.full": "Two profiles selected. Remove one before selecting another.",
  "profile.compare.empty": "Select two profiles using “Select for comparison” in their tools menu.",
  "profile.compare.unavailable": "This profile is unavailable.",
  "profile.compare.noData": "No visible information",
  "profile.compare.loading": "Loading profiles …",
  "profile.compare.retry": "Try again",
  "profile.compare.profile": "Open profile",
  "profile.compare.search": "Find profiles",
  "profile.compare.overview": "Overview",
  "profile.compare.bio": "About me",
  "profile.compare.experience": "Experience",
  "profile.compare.education": "Education",
  "profile.compare.expertise": "Skills",
  "profile.compare.certificates": "Certificates",
  "profile.compare.languages": "Languages",
  "profile.compare.powers": "Powers",
  "profile.compare.denied": "You do not have permission to compare profiles.",
  "documents.preview.open": "Preview",
  "documents.preview.zoomOut": "Zoom out",
  "documents.preview.zoomIn": "Zoom in",
  "documents.preview.unavailable": "No preview is available for this format. You can download the original file.",
  "documents.preview.original-missing": "Original file unavailable",
  "documents.preview.original-access": "Original file cannot be retrieved here",
  "profile.compare.addItem": "Add person to comparison",
  "company.compare.title": "Compare companies",
  "company.compare.tools": "Company tools",
  "company.compare.selectDescription": "Select this company to compare two companies side by side.",
  "company.compare.removeDescription": "Remove this company from your comparison selection.",
  "company.compare.select": "Select for comparison",
  "company.compare.remove": "Remove from comparison",
  "company.compare.removeName": "Remove {name} from comparison",
  "company.compare.count": "Comparison {count}/2",
  "company.compare.full": "Two companies selected. Remove one before selecting another.",
  "company.compare.empty": "Select two companies using “Select for comparison” in their tools menu.",
  "company.compare.unavailable": "This company is unavailable.",
  "company.compare.noData": "No visible information",
  "company.compare.loading": "Loading companies …",
  "company.compare.retry": "Try again",
  "company.compare.profile": "Open company",
  "company.compare.search": "Find companies",
  "company.compare.overview": "Overview",
  "company.compare.expertise": "Skills",
  "company.compare.denied": "You do not have permission to compare companies.",
  "company.compare.addItem": "Add company",
  "admin.permission.compare.companies": "Compare companies",
  "company.compare.summary": "About us",
  "company.compare.noResults": "No further companies found.",
  "company.compare.loadMore": "Load more",
  "company.compare.loadMoreFailed": "Could not load more companies. Please try again.",
  "admin.permission.use.microsoft-connection": "Use Microsoft connection",
  "microsoft.signIn": "Sign in with Microsoft",
  "microsoft.title": "Microsoft connection",
  "microsoft.intro": "Connect a personal and a company account for emails, calendar and Teams invitations.",
  "microsoft.notConfigured": "Microsoft integration has not been set up yet. Please contact the operator of this instance.",
  "microsoft.disconnected": "No Microsoft account connected.",
  "microsoft.connected": "Emails and Teams meetings available",
  "microsoft.teamsUnavailable": "Account connected. Teams meetings are unavailable for this calendar. Check the Microsoft license or connect another work account.",
  "microsoft.reconnectRequired": "The Microsoft connection needs to be renewed. Please reconnect the account.",
  "microsoft.success": "Microsoft account connected successfully.",
  "microsoft.cancelled": "The connection was cancelled at Microsoft.",
  "microsoft.expired": "The sign-in expired. Please start connecting again.",
  "microsoft.failed": "The account could not be connected. Try again or check Microsoft approval with your IT team.",
  "microsoft.loading": "Loading connection…",
  "microsoft.changeAccount": "Connect / change account",
  "microsoft.check": "Check connection",
  "microsoft.disconnect": "Disconnect account",
  "microsoft.disconnectMessage": "You will no longer be able to use this account in Smycles. Existing Microsoft meetings will not be deleted.",
  "microsoft.checkedAt": "Last checked: {time}",
  "microsoft.checked": "Check complete. The connection status has been updated.",
  "microsoft.retry": "Try again",
  "microsoft.replaceMessage": "New meetings will use the newly connected account. Existing meetings remain with their original organizer and cannot be managed through the new account.",
  "microsoft.compose.title": "Send email",
  "microsoft.compose.from": "From: {email}",
  "microsoft.compose.recipients": "Recipients",
  "microsoft.compose.subject": "Subject",
  "microsoft.compose.message": "Message",
  "microsoft.compose.teams": "Add Teams meeting",
  "microsoft.compose.start": "Start",
  "microsoft.compose.end": "End",
  "microsoft.compose.timezone": "Time zone: {zone}",
  "microsoft.compose.invalidRecipients": "Enter 1 to 20 distinct email addresses.",
  "microsoft.compose.invalidTime": "Choose a valid future start and a later end.",
  "microsoft.compose.review": "Review message",
  "microsoft.compose.send": "Send now",
  "microsoft.compose.confirmTitle": "Send email?",
  "microsoft.compose.meetingNotice": "Microsoft will create a Teams meeting and send your message as a native calendar invitation to these recipients.",
  "microsoft.compose.mailNotice": "This message will be sent to these recipients.",
  "microsoft.compose.sending": "Submitting to Microsoft…",
  "microsoft.compose.retry": "Check delivery status",
  "microsoft.compose.retryHint": "The response could not be confirmed. Check this request before composing another message.",
  "microsoft.compose.meetingAccepted": "Teams meeting created. Microsoft accepted the invitation for delivery.",
  "microsoft.compose.mailAccepted": "Microsoft accepted the email for delivery.",
  "microsoft.compose.unknown": "The delivery status is uncertain. Check your Outlook calendar or Sent Items first. This request will not be sent again.",
  "microsoft.compose.join": "Open Teams link",
  "microsoft.compose.outlook": "Open event in Outlook",
  "microsoft.compose.new": "New message",
  "microsoft.agenda.title": "Choose week",
  "microsoft.agenda.load": "Load events",
  "microsoft.agenda.refresh": "Refresh",
  "microsoft.agenda.account": "Primary calendar · {email}",
  "microsoft.agenda.loading": "Loading events…",
  "microsoft.agenda.truncated": "This view is incomplete. Please check further events in Outlook.",
  "microsoft.agenda.conflicts": "{count, plural, one {# overlap} other {# overlaps}} with your planned meeting in this week.",
  "microsoft.agenda.noConflicts": "No overlap with your planned meeting in this week.",
  "microsoft.agenda.empty": "No events this week.",
  "microsoft.agenda.private": "Private event",
  "microsoft.agenda.untitled": "Untitled event",
  "microsoft.agenda.free": "Free",
  "microsoft.agenda.tentative": "Tentative",
  "microsoft.agenda.busy": "Busy",
  "microsoft.agenda.oof": "Out of office",
  "microsoft.agenda.workingElsewhere": "Working elsewhere",
  "microsoft.agenda.unknown": "Availability unknown",
  "microsoft.agenda.allDay": "All day",
  "microsoft.agenda.overlap": "Overlaps your planned meeting",
  "microsoft.agenda.outlook": "Open in Outlook",
  "microsoft.agenda.checked": "As of {time} · {zone}. This view does not reserve a time slot.",
  "microsoft.agenda.weekView": "Weekly calendar",
  "microsoft.agenda.previousWeek": "Previous week",
  "microsoft.agenda.nextWeek": "Next week",
  "microsoft.agenda.today": "Today",
  "microsoft.agenda.draft": "Planned Teams meeting",
  "microsoft.agenda.now": "Current time",
  "datePicker.chooseDate": "Choose date",
  "datePicker.chooseDateTime": "Choose date and time",
  "datePicker.previousMonth": "Previous month",
  "datePicker.nextMonth": "Next month",
  "datePicker.month": "Month",
  "datePicker.year": "Year",
  "datePicker.hours": "Hours",
  "datePicker.minutes": "Minutes",
  "datePicker.today": "Today",
  "datePicker.clear": "Clear date",
  "datePicker.apply": "Apply",
  "datePicker.invalidTime": "Enter a valid time within the allowed range.",
  "settings.styleguide.section.datePicker": "Date picker",
  "microsoft.compose.duration": "Duration",
  "microsoft.compose.duration30": "30 min",
  "microsoft.compose.duration60": "1 hour",
  "microsoft.compose.duration120": "2 hours",
  "microsoft.compose.teamsUnavailable": "Teams meetings are not available for this account.",
  "microsoft.compose.schedule": "Meeting time",
  "microsoft.agenda.availability": "Availability",
  "microsoft.agenda.notLoaded": "Load your calendar to see available times and overlaps.",
  "microsoft.continueToMicrosoft": "Continue to Microsoft",
  "microsoft.complete": "Complete connection",
  "microsoft.completeHint": "Reconnect your Microsoft account to authorize emails and calendar together.",
  "microsoft.completeMessage": "At Microsoft, approve calendar access and email sending together. Select the same account. Your existing meetings will remain.",
  "microsoft.accountKind": "Microsoft account",
  "microsoft.personal": "Personal",
  "microsoft.company": "Company",
  "microsoft.accountSelectionHint": "Choose the account for sender and calendar. Both connections belong to your Smycles user.",
  "microsoft.switchTitle": "Switch account?",
  "microsoft.switchDraft": "Your unsent draft will be discarded when you switch accounts.",
  "microsoft.switchConfirm": "Discard draft and switch",
  "microsoft.compose.removeRecipient": "Remove {email}",
  "microsoft.compose.recipientPlaceholder": "Add email address",
  "microsoft.compose.recipientHint": "Press Enter or comma to add. You can also paste multiple addresses.",
  "microsoft.status.connected": "Connected",
  "microsoft.status.disconnected": "Not connected",
  "microsoft.status.incomplete": "Review permissions",
  "microsoft.status.reconnect": "Reconnect required",
  "microsoft.status.limited": "Limited connection",
  "microsoft.status.checking": "Checking",
  "microsoft.status.unconfirmed": "Connection not confirmed",
  "microsoft.connectionSelectionHint": "Manage your personal and company accounts here.",
  "microsoft.compose.connectionRequired": "Connect this Microsoft account in your settings and authorize email and calendar access.",
  "microsoft.compose.manageConnection": "Manage connection"
}
